<template>
  <div>
    <svg
      class="clickable"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="505px"
      height="177px"
      viewBox="0 0 505 177"
      style="enable-background:new 0 0 505 177; max-height:200px;"
      xml:space="preserve"
    >
      <g>
        <g>
          <path
            style="fill:#D9D9D9;"
            d="M2.553,127.119c0.2,3.611,2.106,7.117,4.894,9.565l6.424,5.977
			c2.059,1.801,4.624,2.952,7.342,3.282l15.189,1.848l4.059,0.494c-0.165-2.659-0.282-5.378-0.282-8.389
			c0-24.966,19.883-45.203,44.414-45.203c24.53,0,44.414,20.237,44.414,45.203c0,4.988-0.118,9.694-0.612,14.259l0.706,0.048
			l3.423,0.012l225.989,1.129l3.177,0.012l0.623-0.012c-0.447-5.623-0.941-10.53-0.941-16.624c0-24.966,20.39-45.202,45.543-45.202
			c25.167,0,45.557,20.236,45.557,45.202c0,4.977-0.953,9.683-2.189,14.236l0.695-0.023l3.67-0.295l41.309-3.247
			c3.529-0.27,5.647-4.035,4.07-7.2l-3.941-7.883l0.188-10.989h3.765c0.53,0,0.988-0.412,1.035-0.94
			c3.401-38.484-43.955-57.18-118.018-64.297c-2.212-0.212-4.436-0.412-6.694-0.602l-0.494-0.047l-3.965-0.388
			c-3.365-0.329-6.624-1.389-9.518-3.118c-25.261-15.153-47.897-26.778-77.487-39.26c-1.529-0.637-1.435-1.083,0.224-0.989
			l1.153,0.071c-26.566-8.354-51.638-11.154-81.875-11.118C140.63,2.878,103.37,7.337,52.262,16.313
			c-0.506,0.082-0.942,0.423-1.142,0.895c-0.282,0.611-0.141,1.329,0.33,1.8l2.447,2.447c-0.012,0.012-0.012,0.012-0.024,0.012
			l17.648,0.94L37.401,49.104c-6.894,1.823-11.154,2.07-17.731,2.411c-1.211,1.177-2.423,2.365-3.658,3.589
			c-3.848,3.813-6.036,9.012-6.036,14.437v22.119C2.317,100.389,1.659,111.201,2.553,127.119 M98.463,22.867
			c0.647-3.271,2.2-5.071,5.165-6.425c1.471-0.682,3.059-1.07,4.659-1.271c54.768-6.929,87.369-8.694,140.607-4.541
			c5.695,0.447,11.354,1.388,16.872,2.883c28.319,7.635,47.272,16.977,72.263,34.342c3.882,2.695,7.129,6.236,9.436,10.354
			c1.636,2.94,2.836,5.812,4.117,9.589c-73.944-7.225-141.913-11.836-233.529-14.201c-2.659-0.071-5.33-0.447-7.871-1.259
			c-4.859-1.541-7.577-3.847-9.483-7.53c-0.588-1.141-0.906-2.399-1.023-3.682c-0.318-3.671-1.047-11.966-1.341-15.226
			C98.251,24.891,98.264,23.867,98.463,22.867"
          />
          <path
            d="M114.248,137.961c0,16.029-12.994,29.023-29.023,29.023c-16.028,0-29.022-12.994-29.022-29.023
			c0-16.028,12.994-29.022,29.022-29.022C101.253,108.938,114.248,121.933,114.248,137.961"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_1_"
              d="M84.943,118.587c-1.013,0.013-2.017,0.108-3.004,0.279c-0.921,0.16-1.828,0.386-2.711,0.674
				c-0.008,0.002-0.016,0.005-0.024,0.007c-0.01,0.004-0.021,0.007-0.032,0.011c-0.086,0.028-0.172,0.058-0.257,0.087
				c-0.005,0.002-0.009,0.004-0.014,0.006c-0.015,0.005-0.03,0.01-0.044,0.015c-0.876,0.306-1.728,0.673-2.55,1.1
				c-0.88,0.455-1.725,0.979-2.528,1.566c-0.099,0.073-0.198,0.146-0.296,0.221c-0.002,0.001-0.004,0.003-0.007,0.005
				c-0.017,0.014-0.035,0.027-0.052,0.04c-0.009,0.007-0.018,0.014-0.027,0.021c-0.002,0.002-0.004,0.004-0.006,0.005
				c-0.654,0.504-1.276,1.05-1.86,1.633c-0.263,0.262-0.518,0.531-0.765,0.809c-0.007,0.008-0.014,0.015-0.02,0.022
				c-0.007,0.007-0.014,0.015-0.021,0.023c-0.016,0.018-0.032,0.035-0.047,0.053c-0.002,0.002-0.004,0.004-0.005,0.006
				c-0.394,0.447-0.769,0.914-1.122,1.401c-0.596,0.82-1.132,1.694-1.6,2.619c-0.469,0.925-0.868,1.898-1.192,2.92
				c-0.321,1.011-0.554,2.029-0.704,3.047c-0.15,1.018-0.218,2.034-0.205,3.04c0.01,0.88,0.081,1.75,0.209,2.607
				c0.127,0.859,0.313,1.705,0.553,2.532c0.312,1.078,0.716,2.123,1.206,3.127c0.491,1.004,1.067,1.964,1.723,2.871
				c0.561,0.775,1.179,1.509,1.852,2.195c0.672,0.687,1.4,1.328,2.178,1.913c0.879,0.664,1.824,1.257,2.829,1.768
				c0.372,0.19,0.754,0.37,1.143,0.537c0.008,0.004,0.016,0.007,0.024,0.01l0,0c2.992,1.279,6.44,1.827,9.73,1.471
				c0.286-0.03,0.573-0.068,0.858-0.112c0.014-0.002,0.028-0.004,0.041-0.006c0.006-0.001,0.01-0.002,0.015-0.002
				c0.142-0.023,0.283-0.047,0.424-0.072c0.315-0.057,0.628-0.12,0.938-0.192c0.005-0.001,0.009-0.002,0.014-0.003
				c0.022-0.005,0.043-0.01,0.065-0.015c0.008-0.002,0.017-0.004,0.026-0.006c0.017-0.004,0.033-0.009,0.05-0.013
				c0.013-0.004,0.026-0.007,0.039-0.01c0.013-0.003,0.025-0.006,0.038-0.009c0.016-0.004,0.032-0.008,0.048-0.012
				c0.01-0.002,0.019-0.004,0.028-0.008c0.019-0.004,0.036-0.009,0.055-0.013c0.008-0.002,0.016-0.004,0.024-0.006
				c0.019-0.005,0.039-0.01,0.058-0.015c0.006-0.002,0.012-0.003,0.017-0.006c0.022-0.005,0.044-0.011,0.066-0.017
				c0.001,0,0.002,0,0.004-0.001c0.076-0.02,0.152-0.04,0.228-0.061c0.002,0,0.004-0.001,0.006-0.001
				c0.008-0.003,0.016-0.006,0.024-0.008c0.02-0.006,0.04-0.011,0.06-0.017c0.004-0.001,0.01-0.002,0.015-0.004
				c0.023-0.006,0.047-0.013,0.071-0.021l0,0c0.28-0.079,0.557-0.165,0.832-0.257c0.961-0.32,1.894-0.716,2.791-1.181
				c0.899-0.464,1.76-0.999,2.575-1.598c0.279-0.205,0.552-0.417,0.82-0.637c0-0.001,0-0.001,0-0.001
				c0.023-0.019,0.046-0.037,0.069-0.056c0.006-0.006,0.012-0.011,0.019-0.016c0.016-0.015,0.033-0.028,0.05-0.042
				c0.008-0.007,0.015-0.014,0.023-0.02c0.016-0.014,0.033-0.028,0.049-0.041c0.006-0.006,0.013-0.011,0.019-0.016
				c0.018-0.017,0.036-0.031,0.055-0.047c0.004-0.003,0.008-0.008,0.012-0.011c0.405-0.346,0.797-0.709,1.173-1.09
				c0.713-0.719,1.373-1.499,1.971-2.332c0.58-0.809,1.102-1.67,1.56-2.579c0.456-0.907,0.847-1.863,1.164-2.863
				c0.323-1.021,0.557-2.049,0.708-3.073c0.15-1.024,0.216-2.049,0.201-3.063c-0.015-1.014-0.11-2.018-0.28-3.005
				c-0.09-0.519-0.201-1.034-0.332-1.542c-0.006-0.022-0.012-0.045-0.017-0.066c-0.001-0.003-0.002-0.008-0.003-0.011
				c-0.074-0.278-0.153-0.556-0.238-0.829c-0.015-0.048-0.03-0.096-0.045-0.144c-0.003-0.01-0.006-0.019-0.01-0.029
				c-0.002-0.008-0.005-0.017-0.007-0.023c-0.027-0.084-0.055-0.167-0.083-0.25c-0.318-0.941-0.706-1.857-1.163-2.737
				s-0.98-1.726-1.567-2.527c-0.586-0.802-1.235-1.562-1.944-2.269c-0.149-0.149-0.301-0.296-0.455-0.441
				c-0.144-0.135-0.29-0.268-0.438-0.397c-2.599-2.288-5.909-3.866-9.241-4.492c-0.554-0.104-1.105-0.182-1.653-0.237
				c-0.637-0.063-1.272-0.094-1.905-0.094C85.127,118.585,85.035,118.586,84.943,118.587"
            />
          </defs>
          <clipPath id="SVGIDA_2_">
            <use xlink:href="#SVGIDA_1_" style="overflow:visible;" />
          </clipPath>
          <g style="clip-path:url(#SVGIDA_2_);">
            <g>
              <defs>
                <rect
                  id="SVGIDA_3_"
                  x="65.837"
                  y="118.585"
                  width="38.778"
                  height="38.998"
                />
              </defs>
              <clipPath id="SVGIDA_4_">
                <use xlink:href="#SVGIDA_3_" style="overflow:visible;" />
              </clipPath>
              <g
                transform="matrix(1 0 0 1 -1.747176e-007 2.612076e-006)"
                style="clip-path:url(#SVGIDA_4_);"
              >
                <image
                  style="overflow:visible;"
                  width="81"
                  height="82"
                  xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA
EAMCAwYAAAIQAAADcQAABVv/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX
Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa
JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAFMAUwMBIgACEQEDEQH/
xACUAAACAwEBAQAAAAAAAAAAAAAABAMFBgECBwEBAAAAAAAAAAAAAAAAAAAAABAAAgMAAQMDBQEA
AAAAAAAAAwQBAgUAERITEBQVIFAhIgYxEQABAwMBBQUFCQEAAAAAAAABABECIRIDMUFhcRMEEFGB
IkIgkbFSFKHBMoKiwjNjg2QSAQAAAAAAAAAAAAAAAAAAAFD/2gAMAwEAAhEDEQAAAPoAKknjGXp4
r7KnNWR5k23czpToBGrWV43W36Y5UORjFNPdnpqmqzcFaClboFSiZbhOnQ4pZcEGHpCEaCpq9iqV
L8ucLMeqSayrfB1XT+BQuwEX+GFfsJzznbzPGqy+qTFNMs4AAAB5AqKUDTtgdAAA/9oACAECAAEF
APsn/9oACAEDAAEFAPsn/9oACAEBAAEFAPRhtdaBtwWuq44PiejoEIsYvj+TWreJi0erzUrhYMxL
GS1F42h/pmV7jXtAl9BibkwnGgciYmOFLQI5sNiulmfhI1ljv9DpYlO5jabgVE1CMkVUoGgWh+Tn
9K9cd1tWacW0Qnrp5UXrlsedbErA72oXTcEJdETexHLPlknysduohZhq+Nfnx7YpXffVnyLkNNbQ
OHQqDIPQZkeQSeDyunPaT2MuCEW2svXhN5esztGPJfcRWK0pYl2l4rrh5R8VuVapPPLHT+lGYbg1
TFlPG7pNdTNFmwRxlOKtTn6F1yGQWYqfKIOZlsE+M3j0E6thAlQcOPDXoQpHWBChZDIL2v7afS+X
p2pylxmrCNCF6R6aUkEJtmx75KnW2jbsXSv0cZHB1mRWAXKbKS469tfSYiYc/nRSRJWwY1b/AKgn
ownbvAzjlbvn5iyA/pt/mn4+0PtvOj08f0f/2gAIAQICBj8AE//aAAgBAwIGPwAT/9oACAEBAQY/
AOx80xEnSO08AnxhhsdGzLKDfKW+CaXUZCN8igZm7irMp5Z2E6IEFwdCPYJgLshHlHdvRy5pGUia
koRdGSbevBGIKGObzwy9J9PBAjQ9hnMsAq6lGUQhGVA6vFaIjuKsBqriKIGSGF9dOPZi6eGjXz+A
VSrZtVHNgq1aLJ0uT+SINCs+SVBjJRtcwB1XmIuCIiUJxJeJcK5g303P/M9re9TmQ+gHBFgnxurc
uMzhtUeq6U2ZwfPhlS4bWWbFiIhz8hMpmgjBgS/vXI6GByS25G1V03AOxPJ1UK3+rl+F96lGWoR0
VIgq3B04lxCjLq7ImdIYYRFxPE6IxyG2N1lxAlGMgAWIOyqc4YTh80E0hae4hlQhap9z+Dsozg9m
WP2jVbUDMURIAOQaKXWZ6iDmAOgXW4J1ulcOIR6TqaxBYEq+IBdPiJCYvIK20v8ASX6eq+5uLIAh
5QN0U5CIjqq1i6LUJCm/qK50NdUITKcIOPKC57TkgCY+ptm9MDRAkK0dyfegdSycUDqOODykdiAO
u3tY1B1CObpTaTWWM6eCacbSEQn3ptyYNCO2RVuIPM/iyHU+1s8VK7k+N7/oQb6Z3/6Pvog3K/zf
93s//9k="
                  transform="matrix(0.48 0 0 0.48 65.8369 118.585)"
                ></image>
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_5_"
              d="M71.63,137.961c0,7.509,6.086,13.596,13.595,13.596c7.509,0,13.595-6.087,13.595-13.596
				c0-7.508-6.086-13.595-13.595-13.595C77.716,124.366,71.63,130.453,71.63,137.961"
            />
          </defs>
          <clipPath id="SVGIDA_6_">
            <use xlink:href="#SVGIDA_5_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_7_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(13.5951 0 0 -13.5951 2219.6567 2870.5774)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.8368" style="stop-color:#1A1A1A" />
            <stop offset="1" style="stop-color:#4E4D4D" />
          </radialGradient>
          <rect
            x="71.63"
            y="124.366"
            style="clip-path:url(#SVGIDA_6_);fill:url(#SVGIDA_7_);"
            width="27.19"
            height="27.19"
          />
        </g>
        <g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_8_"
                  x="65.848"
                  y="118.603"
                  width="38.754"
                  height="38.735"
                />
              </defs>
              <clipPath id="SVGIDA_9_">
                <use xlink:href="#SVGIDA_8_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_9_);">
                <defs>
                  <path
                    id="SVGIDA_10_"
                    d="M104.602,137.97c0,10.697-8.675,19.368-19.377,19.368c-10.701,0-19.377-8.671-19.377-19.368
							c0-10.695,8.676-19.367,19.377-19.367C95.927,118.603,104.602,127.274,104.602,137.97"
                  />
                </defs>
                <clipPath id="SVGIDA_11_">
                  <use xlink:href="#SVGIDA_10_" style="overflow:visible;" />
                </clipPath>

                <radialGradient
                  id="SVGIDA_12_"
                  cx="-157"
                  cy="201"
                  r="1"
                  gradientTransform="matrix(19.377 0 0 -19.3673 3127.4133 4030.8044)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" style="stop-color:#FFFFFF" />
                  <stop offset="0.5732" style="stop-color:#FFFFFF" />
                  <stop offset="0.7573" style="stop-color:#808080" />
                  <stop offset="1" style="stop-color:#676767" />
                </radialGradient>
                <rect
                  x="65.848"
                  y="118.603"
                  style="clip-path:url(#SVGIDA_11_);fill:url(#SVGIDA_12_);"
                  width="38.754"
                  height="38.735"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_13_"
              d="M104.322,130.197l-5.053,1.146c-0.803,0.16-1.382,0.864-1.382,1.684c0.669,3.563,0.381,6.004,0,9.85
				c0,0.829,0.586,1.544,1.4,1.706l5.05,1.146c0.314,0.071,0.639-0.097,0.75-0.397c0.856-2.297,1.324-4.782,1.324-7.373
				c0-2.586-0.466-5.065-1.317-7.352c-0.098-0.263-0.352-0.427-0.623-0.427C104.421,130.18,104.372,130.186,104.322,130.197"
            />
          </defs>
          <clipPath id="SVGIDA_14_">
            <use xlink:href="#SVGIDA_13_" style="overflow:visible;" />
          </clipPath>

          <linearGradient
            id="SVGIDA_15_"
            gradientUnits="userSpaceOnUse"
            x1="-157"
            y1="201"
            x2="-156"
            y2="201"
            gradientTransform="matrix(0 -15.565 -15.565 0 3230.7205 -2297.9609)"
          >
            <stop offset="0" style="stop-color:#0E0405" />
            <stop offset="0.5021" style="stop-color:#681418" />
            <stop offset="1" style="stop-color:#0E0405" />
          </linearGradient>
          <rect
            x="97.887"
            y="130.18"
            style="clip-path:url(#SVGIDA_14_);fill:url(#SVGIDA_15_);"
            width="8.524"
            height="15.62"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_16_"
              d="M62.525,137.965c0-12.537,10.167-22.695,22.696-22.695c12.537,0,22.704,10.158,22.704,22.695
				c0,12.538-10.167,22.696-22.704,22.696C72.692,160.661,62.525,150.503,62.525,137.965 M57.427,137.965
				c0,15.351,12.444,27.795,27.794,27.795c15.358,0,27.802-12.444,27.802-27.795c0-15.35-12.444-27.802-27.802-27.802
				C69.871,110.163,57.427,122.615,57.427,137.965"
            />
          </defs>
          <clipPath id="SVGIDA_17_">
            <use xlink:href="#SVGIDA_16_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_18_"
            cx="-157.0005"
            cy="201"
            r="1"
            gradientTransform="matrix(27.7983 0 0 -27.7983 4449.5483 5725.4229)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#878787" />
            <stop offset="0.8536" style="stop-color:#878787" />
            <stop offset="1" style="stop-color:#F0F0F0" />
          </radialGradient>
          <rect
            x="57.427"
            y="110.163"
            :style="rearWheelClass"
            v-on:click="changeSeverity('rearWheel')"
            style="clip-path:url(#SVGIDA_17_);fill:url(#SVGIDA_18_);"
            width="55.596"
            height="55.597"
          />
        </g>
        <g>
          <path
            style="fill:#4D4D4D;"
            d="M94.507,131.526l9.794-5.875l-6.749-6.754l-5.902,9.826c-1.705,1.216-3.853,0.325-4.415-1.88
			l2.822-11.061l-9.652-0.001l2.829,11.133c-0.356,2.054-2.5,2.936-4.452,1.772l-5.872-9.792l-6.754,6.753l9.854,5.923
			c1.196,1.702,0.307,3.835-1.889,4.396l-11.088-2.776v9.545l11.147-2.77c2.053,0.35,2.938,2.482,1.793,4.432l-9.815,5.882
			l6.749,6.749l5.909-9.816c1.698-1.223,3.838-0.347,4.416,1.838l-2.78,11.104l9.502,0.043l-2.722-11.134
			c0.327-2.077,2.465-2.978,4.422-1.843l5.887,9.809l6.75-6.749l-9.793-5.875c-1.241-1.702-0.363-3.855,1.831-4.435l11.087,2.765
			v-9.545l-11.088,2.778C94.251,135.635,93.353,133.486,94.507,131.526"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_19_"
              d="M80.441,115.676l2.808,11.32c-0.354,2.039-2.482,2.914-4.419,1.759l-6.019-9.911
				c-0.038,0.031-6.679,6.669-6.706,6.705l9.972,6.07c1.188,1.688,0.306,3.807-1.874,4.363l-11.276-2.758
				c-0.006,0.047-0.006,9.433,0,9.478l11.334-2.75c2.039,0.347,2.917,2.464,1.781,4.398l-9.935,6.029
				c0.027,0.033,6.663,6.671,6.701,6.701l6.055-9.938c1.686-1.213,3.811-0.343,4.383,1.825l-2.76,11.293
				c0.045,0.005,9.388,0.045,9.435,0.042l-2.703-11.321c0.324-2.062,2.446-2.956,4.389-1.829l6.034,9.928
				c0.036-0.027,6.67-6.666,6.701-6.701l-9.913-6.021c-1.232-1.69-0.361-3.829,1.818-4.402l11.275,2.745
				c0.005-0.047,0.004-9.434,0-9.478l-11.275,2.759c-2.062-0.331-2.953-2.464-1.809-4.409l9.914-6.022
				c-0.028-0.035-6.665-6.675-6.702-6.706l-6.048,9.946c-1.692,1.206-3.825,0.322-4.382-1.867l2.802-11.249
				c-0.026-0.001-3.012-0.002-5.643-0.002C82.31,115.674,80.46,115.674,80.441,115.676"
            />
          </defs>
          <clipPath id="SVGIDA_20_">
            <use xlink:href="#SVGIDA_19_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_21_"
            cx="-157"
            cy="200.999"
            r="1.0005"
            gradientTransform="matrix(22.3681 -0.3158 -0.3158 -22.3681 3660.5073 4584.3911)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#727271" />
            <stop offset="0.5272" style="stop-color:#727271" />
            <stop offset="1" style="stop-color:#737372" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_20_);fill:url(#SVGIDA_21_);"
            points="62.291,115.683 107.518,115.044 108.157,160.298
			62.93,160.937 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_22_"
              d="M80.476,115.57l2.787,11.508c-0.351,2.023-2.462,2.892-4.386,1.746l-6.165-10.03
				c-0.076,0.062-6.602,6.585-6.658,6.655l10.092,6.217c1.178,1.677,0.302,3.779-1.861,4.331L62.82,133.26
				c-0.009,0.092-0.009,9.317,0,9.408l11.522-2.729c2.023,0.344,2.896,2.444,1.767,4.365l-10.053,6.175
				c0.054,0.065,6.576,6.595,6.653,6.653l6.202-10.056c1.673-1.204,3.782-0.341,4.35,1.811l-2.741,11.481
				c0.089,0.01,9.275,0.05,9.368,0.041L87.202,148.9c0.323-2.047,2.429-2.935,4.357-1.815l6.181,10.047
				c0.072-0.054,6.591-6.582,6.653-6.653l-10.031-6.168c-1.224-1.677-0.359-3.8,1.803-4.369l11.464,2.727
				c0.01-0.093,0.008-9.322,0-9.408l-11.464,2.738c-2.047-0.328-2.932-2.445-1.795-4.376l10.033-6.169
				c-0.056-0.071-6.58-6.597-6.653-6.658l-6.194,10.065c-1.682,1.196-3.797,0.32-4.351-1.854l2.782-11.437
				c-0.051-0.003-2.935-0.006-5.513-0.006C82.395,115.564,80.515,115.566,80.476,115.57"
            />
          </defs>
          <clipPath id="SVGIDA_23_">
            <use xlink:href="#SVGIDA_22_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_24_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(22.5273 -0.6397 -0.6397 -22.5273 3750.5996 4565.5439)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#757574" />
            <stop offset="0.5272" style="stop-color:#747473" />
            <stop offset="1" style="stop-color:#767675" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_23_);fill:url(#SVGIDA_24_);"
            points="61.538,115.601 107.603,114.292 108.912,160.382
			62.847,161.69 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_25_"
              d="M80.511,115.464l2.767,11.695c-0.349,2.008-2.445,2.871-4.353,1.732l-6.312-10.148
				c-0.114,0.092-6.526,6.501-6.61,6.606l10.21,6.364c1.17,1.664,0.301,3.75-1.846,4.298l-11.653-2.718
				c-0.015,0.138-0.015,9.204,0,9.34l11.71-2.711c2.008,0.341,2.873,2.428,1.753,4.334l-10.172,6.322
				c0.082,0.097,6.49,6.515,6.605,6.604l6.348-10.176c1.661-1.194,3.753-0.338,4.318,1.798l-2.722,11.669
				c0.133,0.015,9.161,0.054,9.301,0.039l-2.667-11.695c0.319-2.03,2.41-2.912,4.324-1.803l6.327,10.168
				c0.108-0.082,6.513-6.499,6.606-6.605l-10.151-6.315c-1.216-1.664-0.357-3.771,1.789-4.336l11.652,2.707
				c0.015-0.14,0.013-9.211,0-9.34l-11.652,2.719c-2.032-0.326-2.909-2.428-1.781-4.344l10.152-6.316
				c-0.083-0.104-6.495-6.518-6.605-6.608l-6.341,10.184c-1.668,1.189-3.768,0.319-4.317-1.839l2.761-11.625
				c-0.078-0.005-3.007-0.009-5.582-0.009C82.361,115.455,80.568,115.457,80.511,115.464"
            />
          </defs>
          <clipPath id="SVGIDA_26_">
            <use xlink:href="#SVGIDA_25_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_27_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(22.6765 -0.9714 -0.9714 -22.6765 3840.6936 4543.4536)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#777777" />
            <stop offset="0.5272" style="stop-color:#767675" />
            <stop offset="1" style="stop-color:#797978" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_26_);fill:url(#SVGIDA_27_);"
            points="60.771,115.537 107.667,113.528 109.677,160.445
			62.782,162.454 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_28_"
              d="M80.546,115.358l2.747,11.882c-0.346,1.994-2.427,2.85-4.321,1.721l-6.458-10.269
				c-0.152,0.123-6.451,6.417-6.562,6.559l10.33,6.509c1.16,1.653,0.298,3.724-1.833,4.267l-11.841-2.698
				c-0.02,0.185-0.021,9.091,0,9.272l11.897-2.692c1.994,0.339,2.852,2.409,1.741,4.301l-10.292,6.469
				c0.108,0.13,6.403,6.438,6.557,6.558l6.494-10.295c1.648-1.188,3.725-0.337,4.285,1.783l-2.702,11.857
				c0.178,0.02,9.048,0.057,9.233,0.04l-2.647-11.885c0.316-2.016,2.391-2.891,4.291-1.788l6.473,10.287
				c0.145-0.109,6.434-6.416,6.558-6.558l-10.271-6.462c-1.205-1.65-0.353-3.743,1.776-4.304l11.84,2.688
				c0.022-0.187,0.016-9.099,0-9.271l-11.84,2.7c-2.015-0.324-2.887-2.409-1.768-4.313l10.272-6.462
				c-0.112-0.14-6.41-6.439-6.557-6.561l-6.488,10.303c-1.655,1.18-3.739,0.315-4.284-1.825l2.741-11.813
				c-0.104-0.008-2.959-0.014-5.49-0.014C82.424,115.345,80.623,115.349,80.546,115.358"
            />
          </defs>
          <clipPath id="SVGIDA_29_">
            <use xlink:href="#SVGIDA_28_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_30_"
            cx="-156.9995"
            cy="201"
            r="0.9998"
            gradientTransform="matrix(22.8153 -1.3106 -1.3106 -22.8153 3930.6453 4518.0928)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#7A7A79" />
            <stop offset="0.5272" style="stop-color:#787877" />
            <stop offset="1" style="stop-color:#7C7C7C" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_29_);fill:url(#SVGIDA_30_);"
            points="59.994,115.494 107.714,112.753 110.456,160.489
			62.736,163.23 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_31_"
              d="M80.581,115.251l2.726,12.071c-0.343,1.979-2.407,2.827-4.287,1.708l-6.606-10.39
				c-0.189,0.153-6.373,6.334-6.513,6.512l10.448,6.654c1.152,1.641,0.296,3.695-1.819,4.235l-12.028-2.68
				c-0.025,0.23-0.025,8.978,0,9.205l12.085-2.674c1.977,0.337,2.83,2.391,1.727,4.268l-10.411,6.617
				c0.136,0.162,6.316,6.357,6.509,6.508l6.64-10.415c1.636-1.176,3.697-0.333,4.253,1.771l-2.683,12.044
				c0.223,0.025,8.935,0.061,9.166,0.039l-2.63-12.071c0.315-2,2.375-2.867,4.259-1.774l6.621,10.406
				c0.179-0.136,6.354-6.332,6.509-6.509l-10.39-6.608c-1.196-1.639-0.35-3.715,1.763-4.271l12.028,2.67
				c0.026-0.235,0.02-8.989,0-9.205l-12.029,2.68c-2-0.321-2.865-2.39-1.754-4.278l10.391-6.608
				c-0.139-0.177-6.325-6.362-6.509-6.513l-6.634,10.423c-1.642,1.171-3.711,0.313-4.252-1.812l2.721-12.003
				c-0.129-0.009-2.91-0.015-5.398-0.015C82.487,115.236,80.678,115.24,80.581,115.251"
            />
          </defs>
          <clipPath id="SVGIDA_32_">
            <use xlink:href="#SVGIDA_31_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_33_"
            cx="-157.001"
            cy="200.998"
            r="1.0014"
            gradientTransform="matrix(22.943 -1.6569 -1.6569 -22.943 4020.311 4489.4097)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#7D7C7C" />
            <stop offset="0.5272" style="stop-color:#7A7A7A" />
            <stop offset="1" style="stop-color:#807F7F" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_32_);fill:url(#SVGIDA_33_);"
            points="59.208,115.472 107.738,111.968 111.244,160.511
			62.713,164.016 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_34_"
              d="M80.616,115.145l2.706,12.259c-0.341,1.964-2.389,2.807-4.255,1.694l-6.752-10.508
				c-0.226,0.185-6.298,6.25-6.464,6.463l10.567,6.803c1.143,1.627,0.293,3.664-1.806,4.2l-12.216-2.659
				c-0.03,0.276-0.031,8.864,0,9.136l12.272-2.654c1.963,0.335,2.809,2.374,1.715,4.237l-10.53,6.762
				c0.162,0.195,6.229,6.28,6.46,6.46l6.787-10.533c1.622-1.168,3.668-0.331,4.22,1.757l-2.663,12.232
				c0.267,0.031,8.821,0.064,9.099,0.038l-2.612-12.259c0.312-1.984,2.355-2.846,4.226-1.761l6.767,10.525
				c0.215-0.163,6.276-6.249,6.461-6.46l-10.51-6.756c-1.187-1.626-0.347-3.687,1.75-4.238l12.217,2.649
				c0.031-0.281,0.024-8.875,0-9.136l-12.218,2.66c-1.985-0.318-2.843-2.372-1.741-4.245l10.511-6.756
				c-0.167-0.211-6.24-6.283-6.461-6.465l-6.78,10.541c-1.63,1.162-3.683,0.313-4.219-1.796l2.7-12.191
				c-0.154-0.011-2.887-0.019-5.34-0.019C82.529,115.126,80.734,115.131,80.616,115.145"
            />
          </defs>
          <clipPath id="SVGIDA_35_">
            <use xlink:href="#SVGIDA_34_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_36_"
            cx="-157.001"
            cy="200.998"
            r="1.0014"
            gradientTransform="matrix(23.0595 -2.0098 -2.0098 -23.0595 4109.5391 4457.3979)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#7F7F7F" />
            <stop offset="0.5272" style="stop-color:#7C7C7C" />
            <stop offset="1" style="stop-color:#838282" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_35_);fill:url(#SVGIDA_36_);"
            points="58.409,115.471 107.741,111.171 112.042,160.513
			62.709,164.812 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_37_"
              d="M80.651,115.038l2.686,12.447c-0.338,1.947-2.371,2.783-4.222,1.682l-6.899-10.628
				c-0.264,0.214-6.222,6.167-6.417,6.415l10.686,6.948c1.135,1.613,0.292,3.637-1.791,4.168l-12.404-2.64
				c-0.036,0.322-0.036,8.75,0,9.067l12.46-2.634c1.948,0.332,2.786,2.354,1.701,4.203l-10.65,6.908
				c0.19,0.229,6.144,6.202,6.412,6.413l6.933-10.653c1.611-1.159,3.641-0.327,4.189,1.745l-2.644,12.42
				c0.311,0.035,8.706,0.066,9.031,0.036l-2.593-12.445c0.31-1.969,2.337-2.824,4.194-1.748l6.914,10.646
				c0.251-0.189,6.196-6.167,6.412-6.413l-10.629-6.901c-1.178-1.614-0.345-3.657,1.736-4.207l12.405,2.631
				c0.037-0.327,0.028-8.764,0-9.067l-12.406,2.642c-1.969-0.317-2.821-2.354-1.727-4.213l10.63-6.903
				c-0.195-0.246-6.155-6.204-6.412-6.416l-6.927,10.661c-1.618,1.152-3.655,0.308-4.188-1.783l2.68-12.38
				c-0.18-0.012-2.908-0.021-5.342-0.021C82.535,115.017,80.787,115.023,80.651,115.038"
            />
          </defs>
          <clipPath id="SVGIDA_38_">
            <use xlink:href="#SVGIDA_37_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_39_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(23.1641 -2.3691 -2.3691 -23.1641 4198.166 4422.0122)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#828281" />
            <stop offset="0.5272" style="stop-color:#7F7E7E" />
            <stop offset="1" style="stop-color:#868585" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_38_);fill:url(#SVGIDA_39_);"
            points="57.603,115.492 107.722,110.367 112.849,160.491
			62.729,165.617 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_40_"
              d="M80.686,114.932l2.665,12.635c-0.335,1.933-2.351,2.763-4.188,1.669l-7.046-10.747
				c-0.302,0.245-6.146,6.083-6.368,6.367l10.805,7.094c1.125,1.601,0.288,3.608-1.778,4.137l-12.593-2.621
				c-0.039,0.368-0.04,8.637,0,9l12.648-2.615c1.933,0.328,2.766,2.335,1.687,4.169l-10.768,7.058
				c0.217,0.259,6.057,6.124,6.364,6.364l7.08-10.773c1.599-1.149,3.612-0.325,4.156,1.731l-2.625,12.608
				c0.356,0.04,8.593,0.07,8.964,0.036l-2.575-12.634c0.308-1.953,2.32-2.802,4.161-1.734l7.061,10.766
				c0.287-0.219,6.118-6.083,6.364-6.364l-10.749-7.05c-1.168-1.603-0.342-3.628,1.723-4.174l12.593,2.611
				c0.042-0.374,0.033-8.653,0-8.999l-12.594,2.622c-1.954-0.314-2.799-2.336-1.713-4.18l10.749-7.05
				c-0.223-0.281-6.07-6.126-6.364-6.367l-7.074,10.778c-1.604,1.145-3.626,0.307-4.154-1.769l2.659-12.568
				c-0.206-0.014-2.885-0.024-5.283-0.024C82.578,114.907,80.842,114.914,80.686,114.932"
            />
          </defs>
          <clipPath id="SVGIDA_41_">
            <use xlink:href="#SVGIDA_40_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_42_"
            cx="-157.0005"
            cy="201"
            r="1.0002"
            gradientTransform="matrix(23.2564 -2.7341 -2.7341 -23.2564 4286.0425 4383.2593)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#858484" />
            <stop offset="0.5272" style="stop-color:#818080" />
            <stop offset="1" style="stop-color:#898888" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_41_);fill:url(#SVGIDA_42_);"
            points="56.789,115.536 107.68,109.554 113.663,160.447
			62.772,166.431 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_43_"
              d="M80.721,114.825l2.646,12.823c-0.333,1.918-2.335,2.74-4.157,1.654l-7.192-10.864
				c-0.34,0.274-6.07,5.997-6.32,6.317l10.923,7.24c1.117,1.589,0.287,3.581-1.763,4.104l-12.781-2.601
				c-0.045,0.415-0.046,8.524,0,8.932l12.836-2.597c1.917,0.327,2.743,2.319,1.674,4.138L65.7,151.175
				c0.243,0.292,5.969,6.045,6.315,6.316l7.226-10.892c1.586-1.142,3.584-0.323,4.123,1.717l-2.604,12.797
				c0.4,0.046,8.479,0.073,8.896,0.035L87.1,148.327c0.305-1.938,2.3-2.78,4.128-1.719l7.208,10.882
				c0.322-0.243,6.037-5.999,6.315-6.315l-10.868-7.196c-1.159-1.589-0.339-3.601,1.709-4.141l12.782,2.593
				c0.047-0.422,0.036-8.542,0-8.932l-12.782,2.602c-1.939-0.311-2.777-2.316-1.701-4.146l10.869-7.196
				c-0.251-0.316-5.985-6.048-6.316-6.319l-7.219,10.898c-1.593,1.135-3.599,0.304-4.123-1.755l2.639-12.756
				c-0.232-0.017-2.897-0.029-5.272-0.029C82.592,114.797,80.896,114.805,80.721,114.825"
            />
          </defs>
          <clipPath id="SVGIDA_44_">
            <use xlink:href="#SVGIDA_43_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_45_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(23.3361 -3.1045 -3.1045 -23.3361 4373.0112 4341.127)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#878786" />
            <stop offset="0.5272" style="stop-color:#838282" />
            <stop offset="1" style="stop-color:#8B8B8B" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_44_);fill:url(#SVGIDA_45_);"
            points="55.967,115.604 107.614,108.732 114.485,160.38
			62.838,167.251 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_46_"
              d="M80.757,114.719l2.624,13.01c-0.33,1.904-2.316,2.721-4.124,1.644l-7.339-10.986
				c-0.376,0.307-5.993,5.916-6.272,6.271l11.043,7.387c1.108,1.576,0.285,3.552-1.749,4.071l-12.969-2.582
				c-0.05,0.461-0.05,8.41,0,8.863l13.023-2.576c1.902,0.323,2.722,2.299,1.661,4.104l-11.007,7.351
				c0.271,0.323,5.884,5.967,6.268,6.268l7.373-11.012c1.573-1.132,3.555-0.32,4.09,1.703l-2.585,12.984
				c0.444,0.051,8.366,0.077,8.829,0.035l-2.538-13.008c0.302-1.924,2.283-2.759,4.095-1.707l7.355,11.003
				c0.359-0.271,5.959-5.916,6.268-6.267l-10.988-7.345c-1.15-1.575-0.337-3.571,1.695-4.107l12.97,2.573
				c0.052-0.469,0.041-8.431,0-8.863l-12.97,2.583c-1.924-0.31-2.755-2.299-1.687-4.115l10.988-7.343
				c-0.278-0.352-5.901-5.968-6.268-6.271l-7.366,11.019c-1.58,1.126-3.57,0.301-4.09-1.742l2.619-12.944
				c-0.258-0.017-2.867-0.03-5.205-0.03C82.64,114.688,80.951,114.697,80.757,114.719"
            />
          </defs>
          <clipPath id="SVGIDA_47_">
            <use xlink:href="#SVGIDA_46_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_48_"
            cx="-157"
            cy="200.999"
            r="1.0004"
            gradientTransform="matrix(23.4027 -3.4797 -3.4797 -23.4027 4458.8774 4295.6055)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#8A8A89" />
            <stop offset="0.5272" style="stop-color:#858584" />
            <stop offset="1" style="stop-color:#8E8E8E" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_47_);fill:url(#SVGIDA_48_);"
            points="55.141,115.696 107.524,107.907 115.312,160.288
			62.929,168.076 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_49_"
              d="M80.792,114.613l2.603,13.197c-0.326,1.888-2.296,2.697-4.09,1.63l-7.486-11.105
				c-0.414,0.338-5.918,5.832-6.223,6.223l11.161,7.533c1.099,1.564,0.283,3.524-1.735,4.039l-13.157-2.562
				c-0.055,0.506-0.056,8.296,0,8.795l13.211-2.559c1.887,0.322,2.7,2.281,1.648,4.073l-11.126,7.496
				c0.298,0.356,5.797,5.889,6.219,6.219l7.519-11.13c1.561-1.123,3.527-0.318,4.058,1.69l-2.565,13.173
				c0.487,0.056,8.251,0.081,8.761,0.033l-2.52-13.195c0.3-1.908,2.265-2.736,4.064-1.693l7.501,11.122
				c0.394-0.298,5.88-5.833,6.219-6.219l-11.108-7.49c-1.14-1.563-0.334-3.544,1.682-4.075l13.158,2.554
				c0.058-0.516,0.045-8.318,0-8.794l-13.158,2.563c-1.908-0.306-2.733-2.281-1.674-4.082l11.108-7.49
				c-0.307-0.387-5.816-5.89-6.219-6.222l-7.514,11.136c-1.567,1.117-3.54,0.3-4.056-1.728l2.598-13.132
				c-0.283-0.02-2.847-0.034-5.15-0.034C82.68,114.579,81.006,114.588,80.792,114.613"
            />
          </defs>
          <clipPath id="SVGIDA_50_">
            <use xlink:href="#SVGIDA_49_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_51_"
            cx="-157.0005"
            cy="200.999"
            r="1.0006"
            gradientTransform="matrix(23.4559 -3.8591 -3.8591 -23.4559 4543.5049 4246.7383)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#8C8C8C" />
            <stop offset="0.5272" style="stop-color:#878786" />
            <stop offset="1" style="stop-color:#919190" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_50_);fill:url(#SVGIDA_51_);"
            points="54.308,115.813 107.41,107.076 116.146,160.173
			63.043,168.909 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_52_"
              d="M80.827,114.506l2.584,13.386c-0.325,1.873-2.279,2.678-4.058,1.616l-7.633-11.223
				c-0.452,0.367-5.841,5.748-6.175,6.173l11.28,7.679c1.09,1.553,0.28,3.497-1.721,4.007l-13.346-2.542
				c-0.059,0.553-0.06,8.184,0,8.728l13.399-2.539c1.872,0.319,2.678,2.263,1.635,4.04l-11.245,7.644
				c0.324,0.39,5.71,5.811,6.171,6.17l7.665-11.249c1.548-1.113,3.499-0.315,4.025,1.677l-2.545,13.36
				c0.533,0.062,8.138,0.085,8.694,0.033l-2.502-13.383c0.298-1.893,2.247-2.715,4.031-1.68l7.648,11.241
				c0.43-0.325,5.801-5.749,6.171-6.171l-11.226-7.636c-1.132-1.552-0.332-3.516,1.667-4.043l13.347,2.535
				c0.064-0.563,0.049-8.208,0-8.728l-13.347,2.545c-1.893-0.305-2.711-2.264-1.66-4.05l11.227-7.637
				c-0.334-0.422-5.732-5.812-6.171-6.175l-7.66,11.257c-1.555,1.108-3.512,0.296-4.025-1.714l2.579-13.322
				c-0.309-0.021-2.828-0.037-5.099-0.037C82.719,114.469,81.061,114.48,80.827,114.506"
            />
          </defs>
          <clipPath id="SVGIDA_53_">
            <use xlink:href="#SVGIDA_52_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_54_"
            cx="-157.001"
            cy="200.999"
            r="1.0009"
            gradientTransform="matrix(23.4954 -4.2422 -4.2422 -23.4954 4626.6982 4194.5352)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#8F8F8E" />
            <stop offset="0.5272" style="stop-color:#898988" />
            <stop offset="1" style="stop-color:#949493" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_53_);fill:url(#SVGIDA_54_);"
            points="53.471,115.954 107.271,106.24 116.983,160.031
			63.184,169.745 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_55_"
              d="M80.862,114.4l2.563,13.573c-0.322,1.858-2.26,2.654-4.025,1.604l-7.779-11.344
				c-0.491,0.398-5.766,5.665-6.127,6.126l11.399,7.825c1.082,1.539,0.278,3.469-1.707,3.976l-13.534-2.524
				c-0.065,0.599-0.065,8.069,0,8.659l13.587-2.519c1.856,0.315,2.656,2.243,1.622,4.007l-11.366,7.79
				c0.353,0.421,5.624,5.732,6.124,6.123l7.812-11.369c1.535-1.105,3.47-0.313,3.992,1.662l-2.526,13.55
				c0.577,0.064,8.024,0.088,8.626,0.032L87.04,148c0.296-1.878,2.229-2.692,3.998-1.666l7.796,11.362
				c0.466-0.354,5.721-5.667,6.123-6.123l-11.347-7.784c-1.123-1.538-0.329-3.487,1.655-4.01l13.535,2.516
				c0.068-0.609,0.053-8.096,0-8.659l-13.535,2.524c-1.878-0.301-2.691-2.243-1.647-4.017l11.346-7.782
				c-0.362-0.458-5.647-5.733-6.123-6.126l-7.806,11.374c-1.542,1.1-3.484,0.295-3.992-1.699l2.558-13.51
				c-0.334-0.023-2.812-0.04-5.048-0.04C82.756,114.36,81.115,114.371,80.862,114.4"
            />
          </defs>
          <clipPath id="SVGIDA_56_">
            <use xlink:href="#SVGIDA_55_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_57_"
            cx="-157"
            cy="200.998"
            r="1.0008"
            gradientTransform="matrix(23.5209 -4.6283 -4.6283 -23.5209 4708.2988 4139.0225)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#929191" />
            <stop offset="0.5272" style="stop-color:#8B8A8A" />
            <stop offset="1" style="stop-color:#979796" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_56_);fill:url(#SVGIDA_57_);"
            points="52.633,116.122 107.105,105.403 117.822,159.865
			63.35,170.584 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_58_"
              d="M80.897,114.293l2.542,13.762c-0.319,1.843-2.24,2.634-3.991,1.59l-7.926-11.462
				c-0.529,0.429-5.69,5.58-6.079,6.077l11.518,7.973c1.073,1.525,0.276,3.439-1.693,3.941l-13.722-2.504
				c-0.069,0.645-0.07,7.956,0,8.591l13.774-2.5c1.842,0.313,2.635,2.227,1.608,3.976l-11.483,7.936
				c0.379,0.454,5.537,5.655,6.074,6.075l7.959-11.489c1.523-1.096,3.442-0.309,3.96,1.649l-2.507,13.739
				c0.621,0.069,7.91,0.091,8.56,0.029l-2.465-13.758c0.292-1.861,2.21-2.67,3.965-1.652l7.942,11.481
				c0.502-0.38,5.642-5.583,6.075-6.075l-11.466-7.93c-1.114-1.526-0.327-3.459,1.642-3.978l13.722,2.496
				c0.074-0.657,0.057-7.983,0-8.591l-13.723,2.505c-1.862-0.299-2.668-2.226-1.634-3.983l11.466-7.93
				c-0.39-0.493-5.562-5.654-6.075-6.078l-7.952,11.494c-1.53,1.09-3.456,0.291-3.96-1.686l2.538-13.699
				c-0.362-0.024-2.822-0.043-5.035-0.043C82.772,114.25,81.168,114.262,80.897,114.293"
            />
          </defs>
          <clipPath id="SVGIDA_59_">
            <use xlink:href="#SVGIDA_58_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_60_"
            cx="-157"
            cy="200.999"
            r="1.0004"
            gradientTransform="matrix(23.5321 -5.0168 -5.0168 -23.5321 4788.1406 4080.2783)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#949494" />
            <stop offset="0.5272" style="stop-color:#8D8C8C" />
            <stop offset="1" style="stop-color:#9A9999" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_59_);fill:url(#SVGIDA_60_);"
            points="51.792,116.314 106.915,104.563 118.664,159.673
			63.541,171.424 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_61_"
              d="M80.932,114.187l2.523,13.95c-0.317,1.827-2.224,2.611-3.96,1.577l-8.073-11.582
				c-0.565,0.459-5.613,5.497-6.029,6.029l11.636,8.119c1.064,1.513,0.273,3.411-1.68,3.909l-13.909-2.485
				c-0.075,0.69-0.076,7.843,0,8.522l13.962-2.48c1.826,0.311,2.613,2.208,1.594,3.942l-11.602,8.084
				c0.406,0.485,5.45,5.575,6.026,6.025l8.105-11.607c1.511-1.087,3.414-0.308,3.928,1.636l-2.488,13.926
				c0.666,0.075,7.797,0.094,8.493,0.03l-2.447-13.945c0.29-1.847,2.192-2.648,3.933-1.639l8.088,11.6
				c0.538-0.407,5.564-5.5,6.027-6.025l-11.585-8.078c-1.105-1.515-0.324-3.431,1.628-3.944l13.91,2.476
				c0.079-0.702,0.061-7.872,0-8.521l-13.911,2.486c-1.847-0.298-2.646-2.208-1.62-3.951l11.585-8.077
				c-0.418-0.528-5.477-5.576-6.026-6.03l-8.1,11.614c-1.517,1.081-3.427,0.289-3.927-1.672l2.518-13.888
				c-0.386-0.025-2.792-0.046-4.969-0.046C82.82,114.141,81.224,114.154,80.932,114.187"
            />
          </defs>
          <clipPath id="SVGIDA_62_">
            <use xlink:href="#SVGIDA_61_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_63_"
            cx="-157.0005"
            cy="200.999"
            r="1.0006"
            gradientTransform="matrix(23.5287 -5.4071 -5.4071 -23.5287 4866.0571 4018.3469)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#979796" />
            <stop offset="0.5272" style="stop-color:#8F8E8E" />
            <stop offset="1" style="stop-color:#9C9C9C" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_62_);fill:url(#SVGIDA_63_);"
            points="50.951,116.534 106.697,103.724 119.504,159.453
			63.758,172.264 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_64_"
              d="M80.967,114.081l2.502,14.138c-0.314,1.813-2.205,2.589-3.927,1.563l-8.219-11.702
				c-0.603,0.491-5.537,5.414-5.982,5.981l11.756,8.265c1.055,1.502,0.271,3.384-1.666,3.878l-14.097-2.466
				c-0.079,0.737-0.081,7.729,0,8.455l14.149-2.461c1.811,0.308,2.592,2.188,1.582,3.907l-11.722,8.231
				c0.433,0.519,5.364,5.498,5.978,5.979l8.251-11.728c1.499-1.078,3.386-0.305,3.895,1.622L81,161.858
				c0.71,0.081,7.683,0.098,8.424,0.029l-2.428-14.133c0.288-1.831,2.174-2.627,3.901-1.625l8.235,11.72
				c0.573-0.435,5.484-5.417,5.979-5.979l-11.706-8.224c-1.095-1.503-0.321-3.402,1.615-3.912l14.099,2.458
				c0.084-0.75,0.065-7.762,0-8.455l-14.1,2.466c-1.832-0.294-2.624-2.188-1.607-3.917l11.706-8.224
				c-0.447-0.563-5.393-5.498-5.979-5.981l-8.246,11.732c-1.504,1.071-3.399,0.286-3.894-1.658l2.497-14.075
				c-0.412-0.028-2.777-0.05-4.92-0.05C82.856,114.031,81.279,114.045,80.967,114.081"
            />
          </defs>
          <clipPath id="SVGIDA_65_">
            <use xlink:href="#SVGIDA_64_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_66_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(23.5107 -5.7983 -5.7983 -23.5107 4941.8784 3953.2988)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#999999" />
            <stop offset="0.5272" style="stop-color:#909090" />
            <stop offset="1" style="stop-color:#9F9F9F" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_65_);fill:url(#SVGIDA_66_);"
            points="50.111,116.779 106.454,102.884 120.345,159.208
			64.002,173.104 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_67_"
              d="M81.002,113.975l2.482,14.325c-0.312,1.797-2.186,2.567-3.894,1.55l-8.366-11.819
				c-0.641,0.52-5.461,5.33-5.934,5.932l11.876,8.411c1.045,1.49,0.268,3.354-1.653,3.845l-14.286-2.444
				c-0.084,0.782-0.085,7.615,0,8.386l14.337-2.442c1.797,0.306,2.571,2.171,1.569,3.877l-11.841,8.377
				c0.461,0.551,5.278,5.42,5.93,5.931l8.398-11.848c1.485-1.068,3.357-0.302,3.862,1.608l-2.448,14.302
				c0.754,0.087,7.57,0.103,8.357,0.029l-2.41-14.32c0.286-1.815,2.156-2.604,3.868-1.612l8.382,11.841
				c0.61-0.462,5.405-5.334,5.931-5.931l-11.825-8.372c-1.086-1.487-0.318-3.373,1.601-3.879l14.287,2.439
				c0.089-0.798,0.07-7.65,0-8.386l-14.288,2.446c-1.816-0.293-2.602-2.172-1.593-3.885l11.824-8.371
				c-0.474-0.598-5.307-5.419-5.93-5.933l-8.392,11.851c-1.493,1.064-3.371,0.285-3.862-1.644l2.476-14.264
				c-0.436-0.029-2.76-0.053-4.871-0.053C82.893,113.922,81.334,113.936,81.002,113.975"
            />
          </defs>
          <clipPath id="SVGIDA_68_">
            <use xlink:href="#SVGIDA_67_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_69_"
            cx="-157.0005"
            cy="200.999"
            r="1.0006"
            gradientTransform="matrix(23.4779 -6.19 -6.19 -23.4779 5015.4482 3885.2119)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#9C9C9B" />
            <stop offset="0.5272" style="stop-color:#929292" />
            <stop offset="1" style="stop-color:#A2A2A1" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_68_);fill:url(#SVGIDA_69_);"
            points="49.274,117.051 106.183,102.047 121.182,158.937
			64.273,173.941 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_70_"
              d="M81.037,113.867l2.462,14.515c-0.31,1.781-2.168,2.546-3.861,1.537l-8.513-11.94
				c-0.679,0.552-5.386,5.246-5.885,5.885l11.993,8.558c1.038,1.477,0.266,3.326-1.638,3.813l-14.474-2.427
				c-0.089,0.829-0.091,7.501,0,8.318l14.524-2.423c1.783,0.303,2.549,2.153,1.557,3.844l-11.961,8.524
				c0.487,0.584,5.191,5.341,5.882,5.882l8.544-11.966c1.473-1.061,3.329-0.301,3.83,1.595l-2.429,14.49
				c0.799,0.091,7.456,0.104,8.29,0.026l-2.391-14.507c0.283-1.801,2.137-2.582,3.834-1.597l8.53,11.958
				c0.645-0.489,5.326-5.25,5.881-5.882l-11.944-8.519c-1.077-1.476-0.315-3.345,1.588-3.846l14.476,2.419
				c0.094-0.844,0.073-7.539,0-8.318l-14.476,2.428c-1.802-0.29-2.58-2.153-1.58-3.854l11.943-8.516
				c-0.502-0.634-5.222-5.341-5.882-5.887l-8.539,11.972c-1.479,1.055-3.342,0.283-3.829-1.63l2.456-14.453
				c-0.464-0.031-2.764-0.056-4.849-0.056C82.913,113.812,81.387,113.827,81.037,113.867"
            />
          </defs>
          <clipPath id="SVGIDA_71_">
            <use xlink:href="#SVGIDA_70_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_72_"
            cx="-157.0005"
            cy="201"
            r="1.0002"
            gradientTransform="matrix(23.4302 -6.5812 -6.5812 -23.4302 5086.5977 3814.1997)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#9F9F9E" />
            <stop offset="0.5272" style="stop-color:#949494" />
            <stop offset="1" style="stop-color:#A5A5A4" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_71_);fill:url(#SVGIDA_72_);"
            points="48.438,117.349 105.887,101.212 122.018,158.64
			64.569,174.775 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_73_"
              d="M81.072,113.761l2.441,14.702c-0.306,1.766-2.149,2.524-3.827,1.524l-8.661-12.06
				c-0.716,0.582-5.308,5.163-5.837,5.836l12.113,8.704c1.028,1.464,0.264,3.298-1.624,3.78l-14.662-2.407
				c-0.094,0.875-0.095,7.388,0,8.25l14.712-2.404c1.766,0.302,2.528,2.136,1.543,3.812l-12.08,8.672
				c0.515,0.615,5.104,5.263,5.834,5.833l8.69-12.085c1.461-1.051,3.301-0.298,3.798,1.581l-2.41,14.679
				c0.843,0.097,7.342,0.108,8.224,0.027l-2.374-14.696c0.281-1.785,2.12-2.56,3.803-1.584l8.675,12.078
				c0.681-0.515,5.247-5.166,5.834-5.834L93.2,143.504c-1.067-1.463-0.312-3.315,1.574-3.813l14.665,2.399
				c0.099-0.891,0.077-7.427,0-8.25l-14.665,2.408c-1.786-0.287-2.559-2.134-1.566-3.82l12.063-8.663
				c-0.53-0.669-5.138-5.263-5.835-5.837l-8.685,12.09c-1.467,1.046-3.314,0.28-3.797-1.616l2.436-14.642
				c-0.489-0.033-2.748-0.059-4.801-0.059C82.949,113.702,81.442,113.719,81.072,113.761"
            />
          </defs>
          <clipPath id="SVGIDA_74_">
            <use xlink:href="#SVGIDA_73_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_75_"
            cx="-157.001"
            cy="200.998"
            r="1.0012"
            gradientTransform="matrix(23.3675 -6.9714 -6.9714 -23.3675 5155.1821 3740.3479)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A1A1A1" />
            <stop offset="0.5272" style="stop-color:#969695" />
            <stop offset="1" style="stop-color:#A8A8A7" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_74_);fill:url(#SVGIDA_75_);"
            points="47.61,117.673 105.564,100.383 122.848,158.315
			64.894,175.605 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_76_"
              d="M81.108,113.655l2.421,14.89c-0.305,1.751-2.132,2.503-3.796,1.511l-8.807-12.179
				c-0.753,0.613-5.233,5.079-5.788,5.788l12.231,8.85c1.02,1.451,0.262,3.271-1.61,3.748l-14.85-2.388
				c-0.099,0.921-0.101,7.275,0,8.182l14.9-2.385c1.751,0.299,2.505,2.117,1.528,3.779l-12.198,8.817
				c0.542,0.648,5.017,5.186,5.786,5.786l8.837-12.205c1.447-1.042,3.273-0.295,3.765,1.568l-2.391,14.866
				c0.888,0.101,7.229,0.112,8.156,0.025l-2.355-14.882c0.279-1.771,2.101-2.539,3.77-1.57l8.823,12.196
				c0.717-0.543,5.167-5.083,5.785-5.785l-12.183-8.812c-1.059-1.451-0.31-3.288,1.56-3.781l14.853,2.381
				c0.105-0.938,0.081-7.314,0-8.182l-14.853,2.389c-1.771-0.285-2.536-2.115-1.552-3.787l12.181-8.81
				c-0.557-0.704-5.052-5.184-5.785-5.789l-8.833,12.209c-1.454,1.036-3.285,0.277-3.763-1.603l2.415-14.829
				c-0.514-0.035-2.725-0.063-4.742-0.063C82.992,113.593,81.498,113.611,81.108,113.655"
            />
          </defs>
          <clipPath id="SVGIDA_77_">
            <use xlink:href="#SVGIDA_76_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_78_"
            cx="-157.0005"
            cy="200.999"
            r="1.0006"
            gradientTransform="matrix(23.2899 -7.3597 -7.3597 -23.2899 5221.0557 3663.7617)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A4A4A3" />
            <stop offset="0.5272" style="stop-color:#989897" />
            <stop offset="1" style="stop-color:#ABAAAA" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_77_);fill:url(#SVGIDA_78_);"
            points="46.786,118.024 105.215,99.56 123.672,157.965
			65.243,176.429 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_79_"
              d="M81.143,113.549l2.4,15.077c-0.301,1.736-2.112,2.481-3.763,1.498l-8.953-12.298
				c-0.791,0.643-5.157,4.995-5.74,5.74l12.35,8.995c1.011,1.438,0.26,3.242-1.596,3.716l-15.038-2.367
				c-0.105,0.967-0.106,7.161,0,8.113l15.087-2.365c1.736,0.295,2.484,2.098,1.516,3.746l-12.318,8.964
				c0.569,0.681,4.932,5.106,5.737,5.737l8.984-12.324c1.435-1.032,3.244-0.291,3.732,1.555l-2.37,15.054
				c0.932,0.106,7.114,0.116,8.088,0.025l-2.336-15.069c0.276-1.755,2.082-2.517,3.737-1.557l8.969,12.316
				c0.753-0.57,5.089-4.999,5.737-5.737l-12.303-8.958c-1.049-1.439-0.307-3.26,1.547-3.749l15.041,2.362
				c0.111-0.985,0.086-7.204,0-8.113l-15.041,2.368c-1.755-0.281-2.514-2.099-1.539-3.754l12.301-8.956
				c-0.585-0.74-4.968-5.107-5.737-5.742l-8.978,12.329c-1.442,1.026-3.257,0.274-3.732-1.589l2.395-15.018
				c-0.541-0.037-2.722-0.064-4.711-0.064C83.019,113.484,81.551,113.502,81.143,113.549"
            />
          </defs>
          <clipPath id="SVGIDA_80_">
            <use xlink:href="#SVGIDA_79_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_81_"
            cx="-157"
            cy="200.998"
            r="1.0008"
            gradientTransform="matrix(23.1974 -7.7456 -7.7456 -23.1974 5284.0835 3584.5864)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A7A6A6" />
            <stop offset="0.5272" style="stop-color:#9A9A99" />
            <stop offset="1" style="stop-color:#ADADAD" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_80_);fill:url(#SVGIDA_81_);"
            points="45.971,118.401 104.84,98.744 124.488,157.589
			65.619,177.245 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_82_"
              d="M81.178,113.442l2.379,15.266c-0.298,1.72-2.094,2.459-3.729,1.485l-9.1-12.418
				c-0.829,0.673-5.081,4.91-5.692,5.69l12.469,9.144c1.002,1.426,0.257,3.214-1.582,3.684l-15.226-2.349
				c-0.109,1.013-0.111,7.048,0,8.046l15.275-2.348c1.72,0.293,2.462,2.08,1.502,3.714l-12.437,9.11
				c0.596,0.713,4.845,5.029,5.689,5.689l9.131-12.442c1.422-1.023,3.215-0.29,3.699,1.54l-2.351,15.243
				c0.976,0.111,7.001,0.119,8.021,0.024l-2.318-15.257c0.274-1.739,2.065-2.495,3.705-1.545l9.116,12.437
				c0.788-0.597,5.009-4.915,5.688-5.689l-12.421-9.104c-1.041-1.426-0.305-3.231,1.532-3.716l15.229,2.343
				c0.116-1.032,0.09-7.092,0-8.045l-15.229,2.35c-1.739-0.28-2.492-2.08-1.525-3.723l12.421-9.104
				c-0.614-0.773-4.884-5.027-5.69-5.691l-9.125,12.446c-1.429,1.02-3.228,0.273-3.699-1.574l2.375-15.206
				c-0.567-0.038-2.711-0.068-4.669-0.068C83.051,113.374,81.606,113.393,81.178,113.442"
            />
          </defs>
          <clipPath id="SVGIDA_83_">
            <use xlink:href="#SVGIDA_82_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_84_"
            cx="-157.0005"
            cy="200.999"
            r="1.0006"
            gradientTransform="matrix(23.0901 -8.1281 -8.1281 -23.0901 5344.1196 3502.9631)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A9A9A9" />
            <stop offset="0.5272" style="stop-color:#9C9C9B" />
            <stop offset="1" style="stop-color:#B0B0B0" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_83_);fill:url(#SVGIDA_84_);"
            points="45.163,118.803 104.439,97.938 125.296,157.187
			66.02,178.053 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_85_"
              d="M81.213,113.335l2.36,15.453c-0.296,1.707-2.077,2.438-3.697,1.473l-9.247-12.537
				c-0.867,0.705-5.005,4.827-5.644,5.644l12.588,9.29c0.993,1.413,0.255,3.185-1.568,3.649l-15.415-2.329
				c-0.114,1.06-0.116,6.935,0,7.979l15.463-2.328c1.706,0.291,2.44,2.063,1.49,3.681l-12.557,9.258
				c0.624,0.747,4.758,4.95,5.641,5.642l9.276-12.563c1.411-1.015,3.188-0.286,3.668,1.527l-2.332,15.431
				c1.021,0.116,6.888,0.123,7.954,0.024l-2.3-15.444c0.272-1.725,2.046-2.473,3.672-1.529l9.263,12.555
				c0.825-0.624,4.931-4.833,5.641-5.642l-12.542-9.252c-1.031-1.412-0.302-3.202,1.52-3.683l15.417,2.324
				c0.121-1.08,0.094-6.982,0-7.979l-15.417,2.33c-1.725-0.276-2.471-2.061-1.513-3.688l12.54-9.25
				c-0.641-0.811-4.798-4.949-5.641-5.645l-9.271,12.567c-1.417,1.008-3.2,0.269-3.667-1.562l2.355-15.396
				c-0.592-0.039-2.696-0.071-4.622-0.071C83.087,113.264,81.661,113.284,81.213,113.335"
            />
          </defs>
          <clipPath id="SVGIDA_86_">
            <use xlink:href="#SVGIDA_85_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_87_"
            cx="-157.001"
            cy="200.999"
            r="1.0008"
            gradientTransform="matrix(22.9681 -8.5066 -8.5066 -22.9681 5401.0586 3419.0217)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#ACACAB" />
            <stop offset="0.5272" style="stop-color:#9E9D9D" />
            <stop offset="1" style="stop-color:#B3B3B2" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_86_);fill:url(#SVGIDA_87_);"
            points="44.365,119.23 104.013,97.139 126.094,156.76
			66.446,178.852 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_88_"
              d="M81.248,113.229l2.339,15.642c-0.293,1.69-2.057,2.417-3.664,1.459l-9.394-12.656
				c-0.904,0.735-4.928,4.744-5.595,5.595l12.707,9.436c0.984,1.402,0.253,3.158-1.554,3.619l-15.603-2.311
				c-0.119,1.105-0.121,6.821,0,7.909l15.651-2.307c1.69,0.288,2.418,2.043,1.476,3.646l-12.675,9.405
				c0.649,0.778,4.67,4.872,5.592,5.593l9.423-12.682c1.398-1.006,3.159-0.284,3.634,1.514l-2.312,15.619
				c1.066,0.121,6.775,0.125,7.887,0.022l-2.282-15.632c0.269-1.709,2.029-2.45,3.64-1.517l9.409,12.675
				c0.861-0.651,4.852-4.749,5.593-5.593l-12.661-9.399c-1.022-1.4-0.3-3.174,1.506-3.649l15.606,2.304
				c0.126-1.125,0.098-6.869,0-7.909l-15.606,2.311c-1.709-0.274-2.448-2.043-1.499-3.655l12.659-9.397
				c-0.669-0.845-4.713-4.87-5.592-5.596l-9.419,12.687c-1.404,1-3.171,0.267-3.634-1.549l2.335-15.583
				c-0.617-0.042-2.681-0.073-4.575-0.073C83.123,113.155,81.716,113.176,81.248,113.229"
            />
          </defs>
          <clipPath id="SVGIDA_89_">
            <use xlink:href="#SVGIDA_88_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_90_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(22.8317 -8.8804 -8.8804 -22.8317 5454.771 3332.9216)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#AEAEAE" />
            <stop offset="0.5272" style="stop-color:#A09F9F" />
            <stop offset="1" style="stop-color:#B6B5B5" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_89_);fill:url(#SVGIDA_90_);"
            points="43.579,119.684 103.562,96.353 126.881,156.307
			66.898,179.638 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_91_"
              d="M81.283,113.123l2.319,15.828c-0.291,1.676-2.039,2.395-3.631,1.447l-9.541-12.776
				c-0.941,0.766-4.852,4.66-5.547,5.547l12.826,9.582c0.976,1.388,0.25,3.129-1.541,3.586l-15.79-2.291
				c-0.124,1.151-0.126,6.708,0,7.841l15.838-2.288c1.675,0.286,2.397,2.024,1.463,3.615l-12.795,9.551
				c0.678,0.812,4.585,4.795,5.545,5.545l9.569-12.801c1.385-0.997,3.131-0.282,3.602,1.5l-2.293,15.808
				c1.11,0.127,6.66,0.129,7.82,0.021l-2.264-15.819c0.267-1.693,2.011-2.429,3.607-1.503l9.556,12.794
				c0.897-0.678,4.773-4.666,5.545-5.545L92.79,143.22c-1.013-1.389-0.297-3.146,1.494-3.618l15.793,2.285
				c0.131-1.172,0.101-6.758,0-7.841l-15.794,2.292c-1.694-0.272-2.427-2.024-1.485-3.624l12.779-9.544
				c-0.698-0.88-4.629-4.792-5.545-5.547l-9.565,12.804c-1.392,0.992-3.143,0.267-3.601-1.533l2.314-15.771
				c-0.644-0.043-2.671-0.077-4.533-0.077C83.155,113.046,81.77,113.067,81.283,113.123"
            />
          </defs>
          <clipPath id="SVGIDA_92_">
            <use xlink:href="#SVGIDA_91_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_93_"
            cx="-157.001"
            cy="200.999"
            r="1.0007"
            gradientTransform="matrix(22.681 -9.2488 -9.2488 -22.681 5505.1582 3244.7881)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B1B1B1" />
            <stop offset="0.5272" style="stop-color:#A1A1A1" />
            <stop offset="1" style="stop-color:#B8B8B8" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_92_);fill:url(#SVGIDA_93_);"
            points="42.805,120.16 103.085,95.579 127.655,155.831
			67.375,180.411 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_94_"
              d="M81.318,113.016l2.299,16.018c-0.288,1.661-2.021,2.374-3.599,1.433l-9.687-12.895
				c-0.979,0.796-4.776,4.576-5.499,5.499l12.945,9.728c0.966,1.376,0.248,3.101-1.527,3.553l-15.978-2.27
				c-0.129,1.196-0.131,6.594,0,7.772l16.026-2.27c1.66,0.283,2.375,2.007,1.449,3.583l-12.914,9.698
				c0.705,0.843,4.498,4.716,5.497,5.497l9.716-12.921c1.372-0.988,3.102-0.28,3.569,1.485l-2.273,15.996
				c1.153,0.131,6.546,0.132,7.751,0.021l-2.244-16.007c0.263-1.679,1.991-2.406,3.574-1.489l9.702,12.915
				c0.933-0.706,4.695-4.583,5.498-5.497l-12.901-9.693c-1.003-1.375-0.294-3.117,1.48-3.584l15.982,2.266
				c0.136-1.22,0.105-6.647,0-7.772l-15.983,2.271c-1.679-0.27-2.404-2.006-1.472-3.591l12.898-9.689
				c-0.724-0.915-4.543-4.714-5.496-5.499l-9.711,12.924c-1.379,0.982-3.115,0.263-3.57-1.521l2.295-15.959
				c-0.67-0.046-2.665-0.081-4.499-0.081C83.184,112.936,81.823,112.958,81.318,113.016"
            />
          </defs>
          <clipPath id="SVGIDA_95_">
            <use xlink:href="#SVGIDA_94_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_96_"
            cx="-157.0005"
            cy="200.998"
            r="1.0009"
            gradientTransform="matrix(22.6315 -9.6603 -9.6603 -22.6315 5580.0918 3170.2363)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B4B3B3" />
            <stop offset="0.5272" style="stop-color:#A3A3A3" />
            <stop offset="1" style="stop-color:#BBBBBA" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_95_);fill:url(#SVGIDA_96_);"
            points="42.045,120.66 102.586,94.818 128.416,155.331
			67.875,181.173 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_97_"
              d="M81.353,112.91l2.278,16.205c-0.285,1.645-2.001,2.351-3.566,1.42l-9.833-13.016
				c-1.017,0.828-4.701,4.493-5.45,5.45l13.063,9.875c0.958,1.363,0.246,3.072-1.513,3.522l-16.167-2.252
				c-0.134,1.244-0.135,6.479,0,7.705l16.214-2.25c1.645,0.279,2.353,1.987,1.436,3.549l-13.032,9.845
				c0.731,0.876,4.411,4.638,5.447,5.449l9.862-13.04c1.361-0.979,3.075-0.277,3.537,1.472l-2.253,16.185
				c1.199,0.137,6.433,0.136,7.684,0.02l-2.226-16.193c0.261-1.663,1.974-2.386,3.542-1.476l9.849,13.033
				c0.969-0.733,4.615-4.5,5.449-5.449l-13.02-9.839c-0.995-1.363-0.292-3.089,1.466-3.553l16.17,2.248
				c0.141-1.268,0.11-6.536,0-7.705l-16.171,2.252c-1.663-0.268-2.382-1.988-1.458-3.559l13.017-9.837
				c-0.753-0.95-4.458-4.635-5.448-5.45l-9.858,13.043c-1.366,0.974-3.086,0.26-3.536-1.507l2.273-16.147
				c-0.695-0.047-2.644-0.084-4.444-0.084C83.224,112.826,81.879,112.85,81.353,112.91"
            />
          </defs>
          <clipPath id="SVGIDA_98_">
            <use xlink:href="#SVGIDA_97_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_99_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(22.6327 -10.0981 -10.0981 -22.6327 5668.2744 3101.7542)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B6B6B6" />
            <stop offset="0.5272" style="stop-color:#A5A5A5" />
            <stop offset="1" style="stop-color:#BDBDBD" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_98_);fill:url(#SVGIDA_99_);"
            points="41.298,121.184 102.063,94.072 129.163,154.809
			68.397,181.92 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_100_"
              d="M81.388,112.804l2.258,16.393c-0.283,1.631-1.984,2.33-3.533,1.406l-9.98-13.134
				c-1.056,0.858-4.625,4.409-5.403,5.402l13.183,10.021c0.949,1.351,0.243,3.042-1.499,3.488l-16.355-2.231
				c-0.138,1.29-0.141,6.366,0,7.636l16.402-2.23c1.63,0.277,2.332,1.97,1.423,3.518l-13.153,9.991c0.759,0.907,4.326,4.561,5.4,5.4
				l10.009-13.16c1.347-0.969,3.046-0.273,3.505,1.46l-2.235,16.371c1.243,0.143,6.32,0.142,7.618,0.021l-2.209-16.382
				c0.259-1.647,1.956-2.362,3.509-1.462l9.996,13.152c1.005-0.76,4.536-4.417,5.401-5.4l-13.14-9.985
				c-0.985-1.352-0.289-3.062,1.453-3.521l16.358,2.228c0.148-1.313,0.115-6.423,0-7.636l-16.358,2.232
				c-1.649-0.265-2.361-1.97-1.446-3.525l13.138-9.983c-0.781-0.986-4.374-4.557-5.4-5.403l-10.005,13.162
				c-1.353,0.964-3.058,0.258-3.503-1.492l2.252-16.336c-0.721-0.049-2.638-0.087-4.408-0.087
				C83.253,112.717,81.933,112.741,81.388,112.804"
            />
          </defs>
          <clipPath id="SVGIDA_101_">
            <use xlink:href="#SVGIDA_100_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_102_"
            cx="-157.0005"
            cy="200.999"
            r="1.0005"
            gradientTransform="matrix(22.6219 -10.5361 -10.5361 -22.6219 5754.6128 3030.8113)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B9B9B8" />
            <stop offset="0.5272" style="stop-color:#A7A7A7" />
            <stop offset="1" style="stop-color:#C0C0C0" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_101_);fill:url(#SVGIDA_102_);"
            points="40.567,121.729 101.52,93.341 129.895,154.265
			68.942,182.653 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_103_"
              d="M81.423,112.697l2.238,16.581c-0.28,1.614-1.966,2.308-3.5,1.393l-10.128-13.252
				c-1.093,0.887-4.548,4.325-5.353,5.354l13.301,10.167c0.94,1.339,0.241,3.015-1.485,3.455l-16.543-2.212
				c-0.144,1.336-0.146,6.253,0,7.568l16.589-2.211c1.614,0.275,2.31,1.952,1.41,3.485l-13.271,10.138
				c0.785,0.94,4.238,4.48,5.351,5.353l10.155-13.278c1.335-0.961,3.019-0.272,3.472,1.444l-2.215,16.561
				c1.288,0.146,6.206,0.143,7.55,0.018l-2.189-16.567c0.256-1.633,1.937-2.343,3.476-1.449l10.143,13.271
				c1.04-0.787,4.456-4.333,5.353-5.352l-13.26-10.133c-0.977-1.338-0.286-3.032,1.439-3.486l16.547,2.207
				c0.152-1.359,0.118-6.312,0-7.568l-16.547,2.214c-1.633-0.263-2.339-1.951-1.432-3.492l13.257-10.131
				c-0.809-1.021-4.289-4.479-5.352-5.354L90.278,130.7c-1.341,0.956-3.03,0.256-3.472-1.479l2.232-16.524
				c-0.746-0.05-2.623-0.09-4.361-0.09C83.288,112.607,81.988,112.633,81.423,112.697"
            />
          </defs>
          <clipPath id="SVGIDA_104_">
            <use xlink:href="#SVGIDA_103_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_105_"
            cx="-157.001"
            cy="200.998"
            r="1.0011"
            gradientTransform="matrix(22.599 -10.9737 -10.9737 -22.599 5839.002 2957.4888)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#BBBBBB" />
            <stop offset="0.5272" style="stop-color:#A9A9A9" />
            <stop offset="1" style="stop-color:#C3C2C2" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_104_);fill:url(#SVGIDA_105_);"
            points="39.853,122.296 100.953,92.627 130.609,153.699
			69.509,183.369 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_106_"
              d="M81.459,112.591l2.216,16.769c-0.277,1.6-1.946,2.287-3.467,1.381l-10.274-13.373
				c-1.13,0.919-4.472,4.242-5.305,5.306l13.419,10.314c0.932,1.326,0.24,2.985-1.47,3.424l-16.731-2.194
				c-0.149,1.382-0.151,6.141,0,7.501l16.777-2.192c1.599,0.271,2.288,1.934,1.397,3.451L64.63,153.262
				c0.812,0.974,4.151,4.404,5.303,5.305l10.302-13.397c1.323-0.953,2.989-0.27,3.438,1.431l-2.195,16.748
				c1.332,0.153,6.092,0.147,7.483,0.019l-2.172-16.756c0.255-1.617,1.92-2.319,3.445-1.436l10.289,13.392
				c1.077-0.814,4.378-4.25,5.304-5.305l-13.378-10.279c-0.967-1.325-0.283-3.004,1.425-3.454l16.736,2.189
				c0.157-1.407,0.121-6.201,0-7.501l-16.736,2.194c-1.617-0.26-2.317-1.934-1.418-3.459l13.375-10.278
				c-0.836-1.056-4.203-4.398-5.303-5.306l-10.297,13.399c-1.329,0.947-3.002,0.254-3.439-1.464l2.211-16.713
				c-0.77-0.052-2.604-0.093-4.309-0.093C83.327,112.498,82.044,112.524,81.459,112.591"
            />
          </defs>
          <clipPath id="SVGIDA_107_">
            <use xlink:href="#SVGIDA_106_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_108_"
            cx="-157.001"
            cy="200.999"
            r="1.0007"
            gradientTransform="matrix(22.5643 -11.4104 -11.4104 -22.5643 5921.3257 2881.9524)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#BEBEBE" />
            <stop offset="0.5272" style="stop-color:#ABABAA" />
            <stop offset="1" style="stop-color:#C5C5C5" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_107_);fill:url(#SVGIDA_108_);"
            points="39.157,122.885 100.367,91.932 131.306,153.114
			70.096,184.067 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_109_"
              d="M81.494,112.484l2.197,16.957c-0.276,1.585-1.929,2.264-3.435,1.366l-10.421-13.49
				c-1.168,0.948-4.396,4.156-5.258,5.257l13.54,10.46c0.922,1.313,0.237,2.958-1.457,3.391l-16.918-2.174
				c-0.155,1.428-0.157,6.027,0,7.433l16.963-2.173c1.585,0.27,2.267,1.914,1.383,3.418l-13.51,10.434
				c0.841,1.005,4.065,4.324,5.256,5.255L80.282,145.1c1.31-0.941,2.961-0.266,3.407,1.418l-2.176,16.938
				c1.376,0.156,5.978,0.15,7.415,0.017l-2.153-16.943c0.252-1.603,1.902-2.297,3.411-1.421l10.437,13.51
				c1.112-0.84,4.299-4.166,5.255-5.255L92.38,142.935c-0.957-1.313-0.28-2.975,1.412-3.421l16.924,2.17
				c0.163-1.453,0.126-6.09,0-7.433l-16.924,2.175c-1.602-0.257-2.295-1.914-1.405-3.427l13.496-10.424
				c-0.865-1.092-4.12-4.321-5.256-5.258l-10.444,13.52c-1.316,0.938-2.973,0.25-3.406-1.451l2.191-16.901
				c-0.797-0.055-2.594-0.097-4.267-0.097C83.36,112.388,82.098,112.415,81.494,112.484"
            />
          </defs>
          <clipPath id="SVGIDA_110_">
            <use xlink:href="#SVGIDA_109_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_111_"
            cx="-157.001"
            cy="200.998"
            r="1.0011"
            gradientTransform="matrix(22.5178 -11.8456 -11.8456 -22.5178 6001.4888 2804.2876)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C1C1C0" />
            <stop offset="0.5272" style="stop-color:#ADADAC" />
            <stop offset="1" style="stop-color:#C8C8C7" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_110_);fill:url(#SVGIDA_111_);"
            points="38.479,123.49 99.761,91.253 131.984,152.509
			70.703,184.746 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_112_"
              d="M81.529,112.378l2.176,17.145c-0.273,1.569-1.91,2.243-3.402,1.354l-10.567-13.61
				c-1.206,0.98-4.32,4.074-5.209,5.208l13.657,10.607c0.915,1.301,0.235,2.93-1.442,3.359l-17.107-2.154
				c-0.159,1.473-0.162,5.913,0,7.364l17.152-2.154c1.568,0.267,2.245,1.896,1.369,3.386l-13.628,10.579
				c0.867,1.038,3.979,4.247,5.207,5.208l10.594-13.636c1.298-0.936,2.933-0.266,3.374,1.403l-2.156,17.124
				c1.421,0.162,5.864,0.154,7.348,0.017l-2.135-17.13c0.25-1.587,1.883-2.276,3.379-1.408l10.583,13.63
				c1.148-0.869,4.219-4.084,5.208-5.208l-13.617-10.573c-0.95-1.301-0.278-2.947,1.397-3.389l17.112,2.151
				c0.168-1.501,0.13-5.979,0-7.364l-17.112,2.155c-1.586-0.256-2.272-1.897-1.391-3.396l13.615-10.57
				c-0.893-1.127-4.036-4.242-5.208-5.209l-10.591,13.638c-1.303,0.929-2.943,0.25-3.373-1.437l2.171-17.09
				c-0.823-0.056-2.586-0.099-4.23-0.099C83.389,112.279,82.151,112.307,81.529,112.378"
            />
          </defs>
          <clipPath id="SVGIDA_113_">
            <use xlink:href="#SVGIDA_112_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_114_"
            cx="-157"
            cy="200.999"
            r="1.0004"
            gradientTransform="matrix(22.4596 -12.2787 -12.2787 -22.4596 6079.4023 2724.5935)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C3C3C3" />
            <stop offset="0.5272" style="stop-color:#AFAFAE" />
            <stop offset="1" style="stop-color:#CACACA" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_113_);fill:url(#SVGIDA_114_);"
            points="37.82,124.117 99.135,90.596 132.643,151.886
			71.328,185.406 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_115_"
              d="M81.564,112.272l2.155,17.331c-0.269,1.555-1.891,2.222-3.368,1.342l-10.714-13.731
				c-1.244,1.011-4.244,3.991-5.161,5.161l13.777,10.753c0.905,1.288,0.232,2.902-1.429,3.327l-17.295-2.135
				c-0.164,1.52-0.167,5.799,0,7.296l17.339-2.135c1.554,0.265,2.224,1.879,1.357,3.354l-13.748,10.726
				c0.894,1.069,3.892,4.168,5.159,5.159l10.741-13.756c1.285-0.925,2.904-0.262,3.341,1.393l-2.137,17.312
				c1.465,0.167,5.751,0.157,7.281,0.014l-2.117-17.316c0.248-1.572,1.865-2.254,3.346-1.395l10.731,13.749
				c1.184-0.896,4.14-4,5.159-5.159L92.244,142.84c-0.939-1.288-0.275-2.919,1.385-3.355l17.3,2.131
				c0.173-1.547,0.134-5.866,0-7.295l-17.301,2.136c-1.571-0.253-2.25-1.879-1.377-3.362l13.733-10.718
				c-0.919-1.161-3.95-4.163-5.158-5.161l-10.737,13.758c-1.291,0.92-2.916,0.246-3.341-1.423l2.15-17.277
				c-0.849-0.059-2.572-0.104-4.184-0.104C83.424,112.169,82.206,112.198,81.564,112.272"
            />
          </defs>
          <clipPath id="SVGIDA_116_">
            <use xlink:href="#SVGIDA_115_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_117_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(22.3899 -12.7092 -12.7092 -22.3899 6155.0005 2642.9956)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C6C6C6" />
            <stop offset="0.5272" style="stop-color:#B1B0B0" />
            <stop offset="1" style="stop-color:#CDCDCD" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_116_);fill:url(#SVGIDA_117_);"
            points="37.182,124.76 98.494,89.957 133.283,151.244
			71.971,186.047 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_118_"
              d="M81.599,112.165l2.136,17.52c-0.268,1.54-1.874,2.2-3.337,1.328l-10.861-13.849
				c-1.28,1.041-4.168,3.907-5.112,5.112l13.896,10.898c0.896,1.275,0.23,2.874-1.415,3.294l-17.483-2.115
				c-0.169,1.566-0.172,5.687,0,7.229l17.527-2.116c1.539,0.263,2.201,1.86,1.343,3.321L64.426,153.66
				c0.921,1.102,3.805,4.091,5.11,5.111l10.888-13.875c1.272-0.916,2.876-0.26,3.309,1.378l-2.118,17.5
				c1.509,0.172,5.638,0.159,7.214,0.015l-2.098-17.506c0.245-1.557,1.847-2.231,3.314-1.381l10.876,13.869
				c1.22-0.923,4.062-3.918,5.111-5.111l-13.856-10.868c-0.931-1.275-0.273-2.889,1.371-3.322l17.488,2.112
				c0.179-1.595,0.139-5.756,0-7.229l-17.489,2.116c-1.556-0.25-2.228-1.858-1.364-3.328l13.854-10.864
				c-0.949-1.197-3.866-4.085-5.111-5.113l-10.884,13.877c-1.278,0.911-2.887,0.244-3.308-1.409l2.13-17.467
				c-0.874-0.059-2.559-0.105-4.139-0.105C83.459,112.06,82.261,112.089,81.599,112.165"
            />
          </defs>
          <clipPath id="SVGIDA_119_">
            <use xlink:href="#SVGIDA_118_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_120_"
            cx="-157.001"
            cy="201"
            r="1.0004"
            gradientTransform="matrix(22.3089 -13.1366 -13.1366 -22.3089 6228.1812 2559.6252)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C9C8C8" />
            <stop offset="0.5272" style="stop-color:#B2B2B2" />
            <stop offset="1" style="stop-color:#D0CFCF" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_119_);fill:url(#SVGIDA_120_);"
            points="36.564,125.419 97.835,89.34 133.9,150.587
			72.63,186.666 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_121_"
              d="M81.634,112.058l2.115,17.709c-0.265,1.524-1.855,2.179-3.303,1.315l-11.008-13.969
				c-1.318,1.071-4.091,3.822-5.064,5.063l14.015,11.046c0.887,1.264,0.227,2.846-1.402,3.262l-17.67-2.097
				c-0.175,1.612-0.178,5.573,0,7.16l17.714-2.096c1.523,0.259,2.18,1.842,1.331,3.288l-13.987,11.02
				c0.948,1.134,3.719,4.012,5.062,5.063l11.034-13.995c1.26-0.906,2.848-0.256,3.276,1.365l-2.098,17.688
				c1.555,0.178,5.525,0.164,7.146,0.014l-2.08-17.692c0.243-1.54,1.829-2.21,3.282-1.367l11.024,13.988
				c1.255-0.949,3.982-3.833,5.062-5.063l-13.976-11.013c-0.921-1.263-0.27-2.862,1.358-3.292l17.676,2.094
				c0.184-1.641,0.144-5.643,0-7.16l-17.676,2.098c-1.541-0.247-2.207-1.843-1.351-3.296l13.973-11.012
				c-0.976-1.231-3.781-4.007-5.063-5.063l-11.03,13.996c-1.266,0.9-2.859,0.24-3.276-1.396l2.11-17.657
				c-0.901-0.06-2.549-0.106-4.099-0.106C83.49,111.951,82.315,111.981,81.634,112.058"
            />
          </defs>
          <clipPath id="SVGIDA_122_">
            <use xlink:href="#SVGIDA_121_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_123_"
            cx="-157.001"
            cy="200.998"
            r="1.0011"
            gradientTransform="matrix(22.2169 -13.5603 -13.5603 -22.2169 6298.9014 2474.585)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCBCB" />
            <stop offset="0.5272" style="stop-color:#B4B4B4" />
            <stop offset="1" style="stop-color:#D2D2D2" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_122_);fill:url(#SVGIDA_123_);"
            points="35.967,126.094 97.161,88.744 134.497,149.915
			73.304,187.265 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_124_"
              d="M81.669,111.952l2.095,17.896c-0.261,1.509-1.836,2.156-3.27,1.302l-11.155-14.089
				c-1.356,1.103-4.016,3.739-5.015,5.017l14.133,11.191c0.878,1.25,0.225,2.817-1.388,3.229l-17.858-2.076
				c-0.18,1.657-0.182,5.458,0,7.091l17.902-2.077c1.508,0.258,2.158,1.824,1.317,3.257l-14.106,11.166
				c0.975,1.167,3.632,3.934,5.014,5.015l11.18-14.114c1.248-0.897,2.82-0.255,3.245,1.352l-2.079,17.876
				c1.598,0.182,5.41,0.168,7.079,0.012l-2.062-17.88c0.24-1.525,1.811-2.188,3.248-1.354l11.171,14.108
				c1.291-0.978,3.903-3.751,5.015-5.015l-14.096-11.161c-0.913-1.25-0.267-2.833,1.345-3.258l17.864,2.073
				c0.19-1.688,0.146-5.531,0-7.091L93.383,136.5c-1.526-0.245-2.186-1.824-1.338-3.264l14.092-11.157
				c-1.003-1.269-3.695-3.929-5.014-5.018l-11.176,14.115c-1.253,0.895-2.831,0.24-3.244-1.381l2.09-17.844
				c-0.926-0.063-2.535-0.111-4.053-0.111C83.526,111.841,82.37,111.872,81.669,111.952"
            />
          </defs>
          <clipPath id="SVGIDA_125_">
            <use xlink:href="#SVGIDA_124_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_126_"
            cx="-157.001"
            cy="200.998"
            r="1.0011"
            gradientTransform="matrix(22.1141 -13.9799 -13.9799 -22.1141 6367.0972 2388.0581)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CECECE" />
            <stop offset="0.5272" style="stop-color:#B6B6B6" />
            <stop offset="1" style="stop-color:#D5D5D5" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_125_);fill:url(#SVGIDA_126_);"
            points="35.394,126.782 96.474,88.17 135.073,149.228
			73.993,187.841 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_127_"
              d="M81.704,111.846l2.075,18.084c-0.259,1.494-1.818,2.135-3.238,1.289L69.24,117.011
				c-1.394,1.133-3.94,3.656-4.968,4.967l14.253,11.339c0.87,1.238,0.223,2.789-1.374,3.197l-18.047-2.057
				c-0.184,1.703-0.187,5.345,0,7.023l18.089-2.059c1.494,0.255,2.138,1.805,1.305,3.223l-14.225,11.313
				c1.003,1.2,3.546,3.855,4.966,4.967l11.327-14.233c1.235-0.89,2.791-0.251,3.211,1.338l-2.059,18.064
				c1.642,0.188,5.296,0.171,7.012,0.012l-2.043-18.067c0.237-1.51,1.792-2.166,3.215-1.34l11.317,14.227
				c1.327-1.004,3.824-3.667,4.967-4.967L91.971,142.65c-0.903-1.237-0.265-2.805,1.331-3.225l18.053,2.055
				c0.194-1.735,0.15-5.421,0-7.023l-18.053,2.057c-1.51-0.241-2.164-1.804-1.325-3.229l14.212-11.306
				c-1.033-1.302-3.611-3.849-4.966-4.968L89.9,131.245c-1.241,0.884-2.803,0.237-3.212-1.367l2.07-18.032
				c-0.952-0.063-2.523-0.114-4.008-0.114C83.56,111.731,82.425,111.764,81.704,111.846"
            />
          </defs>
          <clipPath id="SVGIDA_128_">
            <use xlink:href="#SVGIDA_127_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_129_"
            cx="-157.001"
            cy="201"
            r="1.0004"
            gradientTransform="matrix(22.0009 -14.3948 -14.3948 -22.0009 6432.7236 2300.1599)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D0D0D0" />
            <stop offset="0.5272" style="stop-color:#B8B8B7" />
            <stop offset="1" style="stop-color:#D7D7D7" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_128_);fill:url(#SVGIDA_129_);"
            points="34.841,127.483 95.772,87.617 135.625,148.528
			74.694,188.395 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_130_"
              d="M81.74,111.74l2.053,18.271c-0.256,1.479-1.799,2.113-3.205,1.276L69.141,116.96
				c-1.432,1.164-3.864,3.572-4.92,4.919l14.372,11.485c0.86,1.225,0.22,2.76-1.36,3.165l-18.235-2.038
				c-0.189,1.749-0.191,5.231,0,6.955l18.277-2.038c1.479,0.252,2.115,1.787,1.291,3.189l-14.344,11.46
				c1.029,1.232,3.459,3.777,4.918,4.918l11.473-14.353c1.223-0.879,2.763-0.248,3.178,1.324L81.752,164.2
				c1.687,0.192,5.183,0.174,6.944,0.011l-2.025-18.255c0.236-1.495,1.775-2.145,3.184-1.327l11.464,14.347
				c1.362-1.03,3.745-3.583,4.918-4.918l-14.335-11.455c-0.894-1.225-0.262-2.775,1.318-3.192l18.241,2.036
				c0.2-1.782,0.155-5.31,0-6.955l-18.241,2.038c-1.495-0.24-2.142-1.786-1.312-3.197l14.332-11.452
				c-1.06-1.337-3.526-3.771-4.918-4.919l-11.47,14.354c-1.228,0.875-2.774,0.233-3.179-1.354l2.05-18.22
				c-0.977-0.067-2.509-0.118-3.963-0.118C83.595,111.622,82.48,111.655,81.74,111.74"
            />
          </defs>
          <clipPath id="SVGIDA_131_">
            <use xlink:href="#SVGIDA_130_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_132_"
            cx="-157.001"
            cy="200.998"
            r="1.0011"
            gradientTransform="matrix(21.8775 -14.8047 -14.8047 -21.8775 6495.7446 2210.9868)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D3D3D3" />
            <stop offset="0.5272" style="stop-color:#BAB9B9" />
            <stop offset="1" style="stop-color:#DADADA" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_131_);fill:url(#SVGIDA_132_);"
            points="34.313,128.197 95.06,87.09 136.155,147.817
			75.408,188.926 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_133_"
              d="M81.775,111.633l2.033,18.46c-0.254,1.463-1.781,2.091-3.172,1.264l-11.595-14.447
				c-1.469,1.194-3.787,3.489-4.87,4.871l14.489,11.631c0.853,1.213,0.219,2.731-1.345,3.132l-18.423-2.018
				c-0.193,1.797-0.197,5.117,0,6.887l18.464-2.02c1.464,0.249,2.095,1.77,1.278,3.157l-14.463,11.607
				c1.057,1.264,3.373,3.699,4.87,4.871l11.619-14.473c1.21-0.872,2.735-0.247,3.147,1.31l-2.021,18.44
				c1.732,0.198,5.069,0.179,6.877,0.011l-2.006-18.442c0.233-1.479,1.756-2.121,3.151-1.313l11.61,14.467
				c1.398-1.06,3.667-3.5,4.871-4.87l-14.455-11.602c-0.885-1.213-0.259-2.748,1.304-3.159l18.429,2.016
				c0.205-1.829,0.16-5.198,0-6.887l-18.429,2.019c-1.48-0.238-2.12-1.769-1.298-3.165l14.45-11.598
				c-1.087-1.373-3.44-3.694-4.869-4.872l-11.617,14.473c-1.215,0.866-2.745,0.232-3.145-1.34l2.028-18.409
				c-1.004-0.067-2.501-0.121-3.925-0.121C83.625,111.512,82.533,111.546,81.775,111.633"
            />
          </defs>
          <clipPath id="SVGIDA_134_">
            <use xlink:href="#SVGIDA_133_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_135_"
            cx="-157.001"
            cy="200.998"
            r="1.0011"
            gradientTransform="matrix(21.7443 -15.2092 -15.2092 -21.7443 6556.127 2120.7087)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D6D6D5" />
            <stop offset="0.5272" style="stop-color:#BBBBBB" />
            <stop offset="1" style="stop-color:#DCDCDC" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_134_);fill:url(#SVGIDA_135_);"
            points="33.806,128.921 94.335,86.583 136.661,147.095
			76.132,189.433 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_136_"
              d="M81.811,111.527l2.012,18.646c-0.251,1.449-1.763,2.07-3.139,1.251l-11.742-14.566
				c-1.506,1.225-3.711,3.404-4.823,4.822l14.61,11.778c0.843,1.199,0.216,2.703-1.332,3.099l-18.611-1.999
				c-0.199,1.844-0.203,5.006,0,6.82l18.652-2.001c1.448,0.246,2.072,1.75,1.265,3.125L64.12,154.257
				c1.084,1.297,3.286,3.62,4.822,4.821l11.765-14.591c1.198-0.862,2.707-0.244,3.114,1.296l-2.001,18.629
				c1.776,0.203,4.956,0.182,6.81,0.01l-1.988-18.63c0.231-1.464,1.738-2.099,3.118-1.299l11.758,14.585
				c1.434-1.085,3.586-3.416,4.822-4.821l-14.575-11.749c-0.875-1.2-0.256-2.72,1.291-3.127l18.618,1.997
				c0.21-1.875,0.163-5.086,0-6.819l-18.618,2c-1.464-0.235-2.098-1.75-1.284-3.133l14.57-11.745
				c-1.115-1.406-3.356-3.613-4.822-4.821L89.757,131.45c-1.203,0.856-2.717,0.229-3.113-1.326l2.008-18.597
				c-1.028-0.07-2.485-0.124-3.876-0.124C83.661,111.403,82.589,111.438,81.811,111.527"
            />
          </defs>
          <clipPath id="SVGIDA_137_">
            <use xlink:href="#SVGIDA_136_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_138_"
            cx="-157.001"
            cy="200.999"
            r="1.0007"
            gradientTransform="matrix(21.6016 -15.6078 -15.6078 -21.6016 6613.8535 2029.4692)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D8D8D8" />
            <stop offset="0.5272" style="stop-color:#BDBDBD" />
            <stop offset="1" style="stop-color:#DFDFDF" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_137_);fill:url(#SVGIDA_138_);"
            points="33.323,129.654 93.602,86.101 137.144,146.363
			76.865,189.917 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_139_"
              d="M81.846,111.42l1.991,18.835c-0.248,1.435-1.744,2.049-3.106,1.238l-11.888-14.686
				c-1.544,1.256-3.636,3.321-4.774,4.774l14.727,11.923c0.836,1.188,0.215,2.676-1.317,3.068l-18.799-1.979
				c-0.204,1.889-0.207,4.892,0,6.75l18.839-1.98c1.434,0.244,2.051,1.731,1.252,3.093l-14.702,11.9
				c1.11,1.328,3.199,3.543,4.773,4.772l11.913-14.71c1.185-0.853,2.678-0.241,3.08,1.283l-1.98,18.816
				c1.82,0.207,4.842,0.186,6.742,0.009l-1.97-18.817c0.228-1.449,1.72-2.077,3.085-1.285l11.905,14.704
				c1.47-1.112,3.508-3.332,4.774-4.772L91.697,142.46c-0.866-1.187-0.254-2.691,1.277-3.094l18.806,1.978
				c0.216-1.922,0.167-4.975,0-6.751l-18.806,1.981c-1.449-0.234-2.075-1.732-1.271-3.101l14.69-11.892
				c-1.144-1.443-3.271-3.536-4.774-4.774l-11.909,14.71c-1.19,0.849-2.689,0.228-3.081-1.312l1.988-18.786
				c-1.054-0.071-2.472-0.127-3.832-0.127C83.696,111.293,82.644,111.329,81.846,111.42"
            />
          </defs>
          <clipPath id="SVGIDA_140_">
            <use xlink:href="#SVGIDA_139_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_141_"
            cx="-157.0015"
            cy="200.998"
            r="1.0012"
            gradientTransform="matrix(21.4499 -16.0002 -16.0002 -21.4499 6668.9141 1937.3474)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#DBDBDB" />
            <stop offset="0.5272" style="stop-color:#BFBFBE" />
            <stop offset="1" style="stop-color:#E1E1E1" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_140_);fill:url(#SVGIDA_141_);"
            points="32.864,130.396 92.861,85.642 137.604,145.624
			77.607,190.378 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_142_"
              d="M81.881,111.314l1.972,19.022c-0.247,1.419-1.727,2.027-3.074,1.224l-12.035-14.805
				c-1.583,1.286-3.559,3.238-4.726,4.727l14.847,12.069c0.825,1.176,0.211,2.648-1.304,3.036l-18.988-1.96
				c-0.208,1.934-0.212,4.778,0,6.682l19.028-1.961c1.418,0.241,2.029,1.715,1.239,3.06l-14.822,12.048
				c1.138,1.361,3.114,3.464,4.725,4.725l12.06-14.83c1.171-0.844,2.649-0.238,3.048,1.27l-1.962,19.006
				c1.865,0.212,4.728,0.188,6.675,0.007l-1.951-19.005c0.225-1.432,1.701-2.055,3.053-1.271l12.051,14.823
				c1.505-1.14,3.428-3.25,4.725-4.725L91.63,142.414c-0.858-1.176-0.252-2.663,1.263-3.063l18.994,1.958
				c0.22-1.969,0.171-4.862,0-6.683l-18.995,1.961c-1.434-0.23-2.054-1.714-1.257-3.065l14.808-12.039
				c-1.17-1.479-3.186-3.458-4.724-4.728l-12.056,14.831c-1.178,0.838-2.66,0.224-3.048-1.299l1.967-18.974
				c-1.081-0.073-2.462-0.131-3.792-0.131C83.727,111.184,82.698,111.221,81.881,111.314"
            />
          </defs>
          <clipPath id="SVGIDA_143_">
            <use xlink:href="#SVGIDA_142_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_144_"
            cx="-157.001"
            cy="200.998"
            r="1.001"
            gradientTransform="matrix(21.2896 -16.3862 -16.3862 -21.2896 6721.3213 1844.5342)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#DDDDDD" />
            <stop offset="0.5272" style="stop-color:#C1C0C0" />
            <stop offset="1" style="stop-color:#E4E4E4" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_143_);fill:url(#SVGIDA_144_);"
            points="32.428,131.145 92.112,85.206 138.041,144.878
			78.355,190.815 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_145_"
              d="M81.916,111.207l1.951,19.211c-0.244,1.404-1.707,2.006-3.041,1.212l-12.181-14.925
				c-1.621,1.317-3.484,3.154-4.678,4.678L78.932,133.6c0.817,1.163,0.21,2.619-1.289,3.002l-19.176-1.939
				c-0.213,1.979-0.217,4.665,0,6.614l19.216-1.942c1.402,0.239,2.007,1.695,1.224,3.027l-14.94,12.193
				c1.165,1.395,3.027,3.387,4.677,4.678l12.205-14.949c1.16-0.835,2.622-0.237,3.016,1.255l-1.942,19.194
				c1.909,0.218,4.614,0.19,6.608,0.007l-1.933-19.193c0.223-1.417,1.683-2.033,3.02-1.258l12.198,14.944
				c1.542-1.167,3.349-3.166,4.677-4.678l-14.932-12.188c-0.849-1.163-0.248-2.634,1.25-3.029l19.182,1.939
				c0.226-2.017,0.175-4.751,0-6.615l-19.183,1.941c-1.418-0.227-2.031-1.694-1.244-3.033l14.929-12.186
				c-1.199-1.514-3.102-3.379-4.677-4.678l-12.203,14.948c-1.164,0.831-2.631,0.222-3.016-1.283l1.948-19.164
				c-1.107-0.075-2.451-0.133-3.749-0.133C83.76,111.074,82.752,111.111,81.916,111.207"
            />
          </defs>
          <clipPath id="SVGIDA_146_">
            <use xlink:href="#SVGIDA_145_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_147_"
            cx="-157.001"
            cy="200.999"
            r="1.0007"
            gradientTransform="matrix(21.1215 -16.7657 -16.7657 -21.1215 6771.2134 1751.1755)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E0E0E0" />
            <stop offset="0.5272" style="stop-color:#C2C2C2" />
            <stop offset="1" style="stop-color:#E6E6E6" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_146_);fill:url(#SVGIDA_147_);"
            points="32.015,131.898 91.358,84.794 138.454,144.125
			79.111,191.23 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_148_"
              d="M81.951,111.101l1.93,19.399c-0.24,1.388-1.688,1.984-3.007,1.198l-12.329-15.043
				c-1.657,1.347-3.407,3.069-4.629,4.629l15.085,12.363c0.808,1.149,0.207,2.591-1.276,2.97l-19.364-1.921
				c-0.219,2.025-0.222,4.551,0,6.547l19.403-1.924c1.388,0.235,1.985,1.677,1.211,2.995l-15.059,12.34
				c1.192,1.426,2.94,3.308,4.629,4.629l12.352-15.069c1.147-0.825,2.593-0.232,2.983,1.242l-1.923,19.383
				c1.954,0.222,4.501,0.194,6.54,0.005l-1.914-19.379c0.221-1.403,1.665-2.012,2.988-1.244l12.345,15.063
				c1.577-1.194,3.27-3.083,4.628-4.629l-15.051-12.336c-0.84-1.149-0.246-2.605,1.236-2.996l19.371,1.921
				c0.231-2.064,0.179-4.642,0-6.548l-19.372,1.923c-1.403-0.226-2.009-1.677-1.23-3.002l15.048-12.332
				c-1.228-1.549-3.017-3.3-4.629-4.629l-12.349,15.067c-1.152,0.821-2.603,0.22-2.983-1.27l1.927-19.353
				c-1.132-0.076-2.437-0.136-3.704-0.136C83.795,110.965,82.807,111.003,81.951,111.101"
            />
          </defs>
          <clipPath id="SVGIDA_149_">
            <use xlink:href="#SVGIDA_148_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_150_"
            cx="-157.001"
            cy="200.999"
            r="1.0007"
            gradientTransform="matrix(20.9467 -17.1391 -17.1391 -20.9467 6818.8232 1657.4413)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E3E3E3" />
            <stop offset="0.5272" style="stop-color:#C4C4C4" />
            <stop offset="1" style="stop-color:#E9E9E8" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_149_);fill:url(#SVGIDA_150_);"
            points="31.626,132.658 90.599,84.405 138.844,143.368
			79.871,191.621 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_151_"
              d="M81.986,110.995l1.911,19.586c-0.239,1.374-1.671,1.962-2.976,1.186l-12.475-15.164
				c-1.695,1.379-3.331,2.987-4.581,4.582l15.203,12.51c0.799,1.138,0.205,2.563-1.262,2.938l-19.551-1.901
				c-0.223,2.072-0.228,4.437,0,6.478l19.591-1.903c1.372,0.233,1.963,1.659,1.198,2.961l-15.179,12.487
				c1.219,1.459,2.853,3.231,4.581,4.582l12.498-15.188c1.135-0.816,2.565-0.23,2.951,1.229l-1.904,19.569
				c1.998,0.228,4.388,0.198,6.474,0.005l-1.896-19.566c0.218-1.388,1.647-1.99,2.954-1.231l12.492,15.183
				c1.613-1.222,3.191-3,4.581-4.582L91.424,142.27c-0.83-1.136-0.243-2.575,1.223-2.963l19.559,1.901
				c0.237-2.109,0.184-4.528,0-6.479l-19.559,1.904c-1.388-0.223-1.988-1.659-1.217-2.969l15.167-12.479
				c-1.255-1.584-2.932-3.222-4.581-4.582l-12.495,15.188c-1.141,0.813-2.575,0.217-2.95-1.256l1.906-19.54
				c-1.157-0.079-2.423-0.14-3.656-0.14C83.831,110.855,82.863,110.894,81.986,110.995"
            />
          </defs>
          <clipPath id="SVGIDA_152_">
            <use xlink:href="#SVGIDA_151_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_153_"
            cx="-157.001"
            cy="200.999"
            r="1.0007"
            gradientTransform="matrix(20.7673 -17.5076 -17.5076 -20.7673 6864.7305 1563.5238)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E5E5E5" />
            <stop offset="0.5272" style="stop-color:#C6C6C5" />
            <stop offset="1" style="stop-color:#EBEBEB" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_152_);fill:url(#SVGIDA_153_);"
            points="31.259,133.421 89.836,84.039 139.211,142.606
			80.634,191.989 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_154_"
              d="M82.021,110.888l1.89,19.775c-0.236,1.358-1.652,1.94-2.942,1.172l-12.622-15.282
				c-1.733,1.409-3.255,2.903-4.533,4.533l15.323,12.655c0.79,1.125,0.202,2.535-1.249,2.905l-19.739-1.883
				c-0.229,2.119-0.233,4.324,0,6.41l19.778-1.884c1.357,0.231,1.942,1.64,1.185,2.928l-15.298,12.634
				c1.247,1.492,2.767,3.152,4.533,4.534l12.645-15.307c1.122-0.81,2.536-0.229,2.917,1.215l-1.883,19.757
				c2.042,0.233,4.273,0.203,6.406,0.005l-1.879-19.754c0.217-1.373,1.629-1.969,2.923-1.218l12.639,15.302
				c1.649-1.249,3.112-2.917,4.532-4.534l-15.291-12.628c-0.821-1.125-0.24-2.549,1.21-2.932l19.746,1.882
				c0.243-2.156,0.188-4.417,0-6.41l-19.746,1.884c-1.373-0.221-1.967-1.641-1.205-2.936l15.287-12.626
				c-1.283-1.619-2.847-3.143-4.533-4.533l-12.642,15.307c-1.127,0.803-2.546,0.215-2.918-1.243l1.887-19.729
				c-1.184-0.08-2.413-0.142-3.616-0.142C83.863,110.746,82.916,110.786,82.021,110.888"
            />
          </defs>
          <clipPath id="SVGIDA_155_">
            <use xlink:href="#SVGIDA_154_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_156_"
            cx="-157.001"
            cy="200.999"
            r="1.0007"
            gradientTransform="matrix(20.5861 -17.8732 -17.8732 -20.5861 6909.7788 1469.7061)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E8E8E8" />
            <stop offset="0.5272" style="stop-color:#C8C7C7" />
            <stop offset="1" style="stop-color:#EDEDED" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_155_);fill:url(#SVGIDA_156_);"
            points="30.917,134.187 89.071,83.697 139.554,141.843
			81.4,192.333 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_157_"
              d="M82.056,110.782l1.869,19.963c-0.232,1.342-1.633,1.918-2.908,1.158l-12.769-15.401
				c-1.771,1.439-3.179,2.818-4.485,4.484l15.441,12.802c0.782,1.112,0.201,2.506-1.234,2.874l-19.928-1.864
				c-0.233,2.165-0.237,4.211,0,6.342l19.967-1.864c1.342,0.229,1.92,1.622,1.172,2.896l-15.417,12.781
				c1.272,1.523,2.68,3.074,4.483,4.484l12.791-15.427c1.11-0.798,2.51-0.226,2.887,1.202l-1.865,19.946
				c2.087,0.238,4.16,0.206,6.338,0.003l-1.859-19.941c0.213-1.356,1.61-1.945,2.89-1.204l12.785,15.421
				c1.685-1.275,3.032-2.834,4.484-4.484l-15.411-12.776c-0.811-1.111-0.237-2.52,1.197-2.897l19.935,1.861
				c0.247-2.203,0.191-4.305,0-6.342l-19.935,1.864c-1.358-0.218-1.944-1.622-1.191-2.903l15.406-12.771
				c-1.311-1.655-2.762-3.065-4.485-4.485l-12.788,15.425c-1.115,0.794-2.518,0.213-2.885-1.229l1.866-19.916
				c-1.209-0.082-2.4-0.146-3.572-0.146C83.897,110.637,82.971,110.677,82.056,110.782"
            />
          </defs>
          <clipPath id="SVGIDA_158_">
            <use xlink:href="#SVGIDA_157_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_159_"
            cx="-157.001"
            cy="200.999"
            r="1.0007"
            gradientTransform="matrix(20.4042 -18.2368 -18.2368 -20.4042 6954.3091 1376.0325)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#EBEBEA" />
            <stop offset="0.5272" style="stop-color:#C9C9C9" />
            <stop offset="1" style="stop-color:#F0F0F0" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_158_);fill:url(#SVGIDA_159_);"
            points="30.597,134.955 88.303,83.379 139.874,141.078
			82.168,192.654 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_160_"
              d="M82.091,110.675l1.85,20.151c-0.231,1.328-1.616,1.896-2.877,1.146L68.149,116.45
				c-1.809,1.471-3.104,2.735-4.437,4.437l15.56,12.949c0.774,1.1,0.199,2.478-1.22,2.84l-20.116-1.844
				c-0.238,2.211-0.242,4.098,0,6.275l20.154-1.848c1.327,0.227,1.899,1.605,1.159,2.864l-15.537,12.927
				c1.301,1.557,2.594,2.996,4.436,4.438l12.938-15.546c1.097-0.79,2.48-0.224,2.853,1.188l-1.845,20.135
				c2.131,0.243,4.046,0.208,6.271,0.001l-1.841-20.128c0.211-1.342,1.593-1.924,2.857-1.19l12.932,15.541
				c1.721-1.304,2.954-2.75,4.436-4.438l-15.53-12.923c-0.802-1.099-0.235-2.492,1.183-2.865l20.124,1.845
				c0.252-2.251,0.195-4.195,0-6.275l-20.124,1.845c-1.342-0.216-1.923-1.604-1.177-2.87l15.525-12.92
				c-1.339-1.688-2.677-2.985-4.437-4.437l-12.934,15.545c-1.102,0.786-2.49,0.211-2.853-1.215l1.846-20.105
				c-1.235-0.083-2.388-0.147-3.528-0.147C83.931,110.527,83.026,110.568,82.091,110.675"
            />
          </defs>
          <clipPath id="SVGIDA_161_">
            <use xlink:href="#SVGIDA_160_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_162_"
            cx="-157.002"
            cy="200.998"
            r="1.0014"
            gradientTransform="matrix(20.2213 -18.5981 -18.5981 -20.2213 6998.1992 1282.5525)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#EDEDED" />
            <stop offset="0.5272" style="stop-color:#CBCBCB" />
            <stop offset="1" style="stop-color:#F2F2F2" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_161_);fill:url(#SVGIDA_162_);"
            points="30.299,135.723 87.535,83.081 140.172,140.313
			82.937,192.954 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_163_"
              d="M82.126,110.569l1.829,20.339c-0.228,1.312-1.596,1.875-2.844,1.132L68.049,116.4
				c-1.845,1.5-3.026,2.65-4.388,4.388l15.68,13.094c0.763,1.088,0.195,2.45-1.207,2.81l-20.304-1.825
				c-0.243,2.257-0.247,3.983,0,6.207l20.342-1.827c1.311,0.223,1.876,1.585,1.145,2.831l-15.656,13.074
				c1.328,1.589,2.508,2.917,4.388,4.388l13.084-15.665c1.085-0.781,2.452-0.221,2.821,1.175l-1.826,20.322
				c2.175,0.247,3.933,0.212,6.204,0.002l-1.823-20.317c0.209-1.325,1.574-1.901,2.826-1.176l13.077,15.659
				c1.757-1.329,2.876-2.667,4.389-4.388l-15.65-13.07c-0.793-1.087-0.232-2.464,1.169-2.833l20.312,1.825
				c0.257-2.298,0.2-4.083,0-6.207l-20.312,1.825c-1.327-0.214-1.9-1.585-1.164-2.838l15.645-13.065
				c-1.366-1.724-2.592-2.908-4.389-4.388l-13.08,15.664c-1.09,0.775-2.462,0.207-2.821-1.202l1.825-20.293
				c-1.261-0.085-2.377-0.152-3.487-0.152C83.962,110.417,83.079,110.46,82.126,110.569"
            />
          </defs>
          <clipPath id="SVGIDA_164_">
            <use xlink:href="#SVGIDA_163_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_165_"
            cx="-157.001"
            cy="201"
            r="1.0003"
            gradientTransform="matrix(20.0366 -18.9562 -18.9562 -20.0366 7041.1685 1189.2197)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F0F0F0" />
            <stop offset="0.5272" style="stop-color:#CDCDCC" />
            <stop offset="1" style="stop-color:#F5F5F5" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_164_);fill:url(#SVGIDA_165_);"
            points="30.025,136.489 86.767,82.807 140.447,139.546
			83.705,193.229 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_166_"
              d="M82.161,110.463l1.809,20.526c-0.225,1.297-1.578,1.854-2.811,1.12l-13.208-15.761
				c-1.884,1.531-2.952,2.567-4.34,4.341l15.797,13.24c0.755,1.075,0.194,2.421-1.192,2.776L57.724,134.9
				c-0.249,2.303-0.253,3.871,0,6.138l20.529-1.807c1.297,0.221,1.856,1.566,1.132,2.798L63.611,155.25
				c1.354,1.621,2.42,2.839,4.34,4.34l13.229-15.784c1.072-0.771,2.424-0.219,2.789,1.161l-1.807,20.51
				c2.221,0.254,3.819,0.217,6.137,0.001l-1.804-20.504c0.206-1.31,1.556-1.88,2.792-1.163l13.224,15.779
				c1.794-1.355,2.797-2.583,4.341-4.34l-15.77-13.216c-0.784-1.075-0.229-2.437,1.156-2.801l20.5,1.805
				c0.263-2.344,0.204-3.97,0-6.138l-20.5,1.807c-1.311-0.212-1.878-1.568-1.15-2.806l15.764-13.212
				c-1.395-1.761-2.507-2.829-4.34-4.341l-13.228,15.783c-1.077,0.768-2.433,0.205-2.787-1.188l1.804-20.481
				c-1.286-0.087-2.362-0.155-3.44-0.155C83.998,110.308,83.135,110.351,82.161,110.463"
            />
          </defs>
          <clipPath id="SVGIDA_167_">
            <use xlink:href="#SVGIDA_166_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_168_"
            cx="-157.0005"
            cy="200.998"
            r="1.0009"
            gradientTransform="matrix(19.8494 -19.3101 -19.3101 -19.8494 7082.9077 1096.0244)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F2F2F2" />
            <stop offset="0.5272" style="stop-color:#CECECE" />
            <stop offset="1" style="stop-color:#F7F7F7" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_167_);fill:url(#SVGIDA_168_);"
            points="29.771,137.256 86,82.554 140.702,138.782
			84.471,193.484 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_169_"
              d="M82.197,110.356l1.788,20.715c-0.222,1.28-1.56,1.831-2.778,1.105l-13.355-15.879
				c-1.922,1.563-2.876,2.484-4.293,4.292l15.918,13.387c0.746,1.063,0.191,2.394-1.179,2.743l-20.68-1.785
				c-0.253,2.351-0.258,3.758,0,6.07l20.717-1.789c1.281,0.219,1.833,1.55,1.118,2.767l-15.894,13.366
				c1.382,1.654,2.334,2.763,4.293,4.292l13.376-15.902c1.059-0.764,2.395-0.217,2.755,1.146l-1.786,20.698
				c2.264,0.258,3.705,0.22,6.069,0l-1.786-20.69c0.204-1.296,1.538-1.857,2.759-1.149l13.372,15.897
				c1.829-1.384,2.717-2.5,4.292-4.292l-15.889-13.362c-0.775-1.063-0.227-2.407,1.143-2.768l20.688,1.786
				c0.267-2.391,0.208-3.86,0-6.07l-20.689,1.786c-1.296-0.208-1.856-1.549-1.137-2.771l15.884-13.359
				c-1.423-1.795-2.422-2.751-4.292-4.292l-13.375,15.901c-1.063,0.759-2.403,0.204-2.755-1.172l1.785-20.671
				c-1.311-0.089-2.349-0.157-3.395-0.157C84.033,110.199,83.19,110.243,82.197,110.356"
            />
          </defs>
          <clipPath id="SVGIDA_170_">
            <use xlink:href="#SVGIDA_169_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_171_"
            cx="-157.001"
            cy="200.998"
            r="1.001"
            gradientTransform="matrix(19.659 -19.659 -19.659 -19.659 7123.1416 1002.9569)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F5F5F5" />
            <stop offset="0.5272" style="stop-color:#D0D0D0" />
            <stop offset="1" style="stop-color:#FAFAFA" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_170_);fill:url(#SVGIDA_171_);"
            :style="rearWheelClass"
            v-on:click="changeSeverity('rearWheel')"
            points="29.539,138.02 85.236,82.323 140.933,138.02
			85.236,193.717 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_172_"
              d="M83.827,133.766c0,0.779,0.632,1.41,1.412,1.41c0.779,0,1.411-0.631,1.411-1.41
				s-0.632-1.412-1.411-1.412C84.459,132.354,83.827,132.986,83.827,133.766"
            />
          </defs>
          <clipPath id="SVGIDA_173_">
            <use xlink:href="#SVGIDA_172_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_174_"
            cx="-157"
            cy="201.001"
            r="1"
            gradientTransform="matrix(1.411 0 0 -1.411 306.758 417.3666)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <rect
            x="83.827"
            y="132.354"
            style="clip-path:url(#SVGIDA_173_);fill:url(#SVGIDA_174_);"
            width="2.823"
            height="2.822"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDA_175_"
              points="84.719,132.865 84.2,133.766 84.719,134.665 85.758,134.665 86.277,133.766 85.758,132.865
				"
            />
          </defs>
          <clipPath id="SVGIDA_176_">
            <use xlink:href="#SVGIDA_175_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_177_"
            cx="-157"
            cy="201"
            r="0.9996"
            gradientTransform="matrix(0.9717 0 0 -0.9717 237.7887 329.0682)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <rect
            x="84.2"
            y="132.865"
            style="clip-path:url(#SVGIDA_176_);fill:url(#SVGIDA_177_);"
            width="2.077"
            height="1.8"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_178_"
              d="M79.776,136.294c-0.242,0.742,0.164,1.538,0.906,1.779c0.741,0.24,1.536-0.165,1.777-0.906
				c0.242-0.741-0.164-1.538-0.905-1.778c-0.145-0.047-0.292-0.069-0.437-0.068C80.522,135.32,79.97,135.699,79.776,136.294"
            />
          </defs>
          <clipPath id="SVGIDA_179_">
            <use xlink:href="#SVGIDA_178_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_180_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(0.4361 -1.3419 -1.3419 -0.4361 419.3058 13.6985)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_179_);fill:url(#SVGIDA_180_);"
            points="78.654,138.027 79.836,134.388 83.581,135.604
			82.398,139.244 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDA_181_"
              points="80.423,135.959 80.101,136.947 80.796,137.718 81.812,137.503 82.134,136.515 81.439,135.743
							"
            />
          </defs>
          <clipPath id="SVGIDA_182_">
            <use xlink:href="#SVGIDA_181_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_183_"
            cx="-157.001"
            cy="201"
            r="1.0004"
            gradientTransform="matrix(0.3003 -0.9241 -0.9241 -0.3003 314.0074 52.0059)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_182_);fill:url(#SVGIDA_183_);"
            points="79.521,137.529 80.295,135.146 82.714,135.932
			81.94,138.315 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_184_"
              d="M81.523,140.737c-0.458,0.631-0.318,1.513,0.312,1.971c0.631,0.458,1.513,0.319,1.971-0.312
				s0.318-1.513-0.312-1.972c-0.25-0.182-0.541-0.269-0.828-0.269C82.229,140.156,81.799,140.357,81.523,140.737"
            />
          </defs>
          <clipPath id="SVGIDA_185_">
            <use xlink:href="#SVGIDA_184_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_186_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(-1.1415 -0.8293 -0.8293 1.1415 70.1396 -218.0881)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_185_);fill:url(#SVGIDA_186_);"
            points="83.159,144.688 79.634,142.126 82.17,138.635
			85.695,141.196 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDA_187_"
              points="81.824,140.956 81.716,141.989 82.556,142.6 83.505,142.177 83.613,141.145 82.773,140.533
				"
            />
          </defs>
          <clipPath id="SVGIDA_188_">
            <use xlink:href="#SVGIDA_187_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_189_"
            cx="-156.999"
            cy="201"
            r="0.9997"
            gradientTransform="matrix(-0.7861 -0.5711 -0.5711 0.7861 74.0389 -106.1002)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_188_);fill:url(#SVGIDA_189_);"
            points="82.958,143.502 80.733,141.886 82.372,139.631
			84.596,141.247 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_190_"
              d="M86.913,140.448c-0.631,0.458-0.771,1.341-0.313,1.971c0.458,0.631,1.34,0.771,1.971,0.313
				c0.63-0.458,0.771-1.342,0.313-1.972c-0.277-0.38-0.707-0.581-1.144-0.581C87.453,140.179,87.163,140.266,86.913,140.448"
            />
          </defs>
          <clipPath id="SVGIDA_191_">
            <use xlink:href="#SVGIDA_190_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_192_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(-1.1415 0.8293 0.8293 1.1415 -258.1737 42.347)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_191_);fill:url(#SVGIDA_192_);"
            points="90.773,142.149 87.248,144.711 84.71,141.219
			88.236,138.657 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDA_193_"
              points="86.793,141.167 86.902,142.2 87.85,142.622 88.691,142.012 88.582,140.979 87.633,140.557
				"
            />
          </defs>
          <clipPath id="SVGIDA_194_">
            <use xlink:href="#SVGIDA_193_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_195_"
            cx="-157.001"
            cy="201"
            r="1.0003"
            gradientTransform="matrix(-0.7861 0.5711 0.5711 0.7861 -150.4644 73.2485)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_194_);fill:url(#SVGIDA_195_);"
            points="89.673,141.908 87.449,143.524 85.811,141.271
			88.035,139.654 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_196_"
              d="M88.896,135.426c-0.74,0.241-1.146,1.037-0.905,1.778c0.24,0.741,1.037,1.146,1.777,0.906
				c0.742-0.241,1.147-1.037,0.907-1.778c-0.194-0.596-0.748-0.975-1.343-0.975C89.188,135.357,89.041,135.379,88.896,135.426"
            />
          </defs>
          <clipPath id="SVGIDA_197_">
            <use xlink:href="#SVGIDA_196_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_198_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(0.4361 1.3419 1.3419 -0.4361 -111.9281 435.0958)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_197_);fill:url(#SVGIDA_198_);"
            points="90.613,134.427 91.795,138.065 88.052,139.281
			86.87,135.643 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDA_199_"
              points="88.317,136.552 88.638,137.54 89.653,137.756 90.349,136.984 90.027,135.997 89.011,135.781
				"
            />
          </defs>
          <clipPath id="SVGIDA_200_">
            <use xlink:href="#SVGIDA_199_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_201_"
            cx="-156.9995"
            cy="201.001"
            r="0.9994"
            gradientTransform="matrix(0.3003 0.9241 0.9241 -0.3003 -49.2591 342.2018)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_200_);fill:url(#SVGIDA_201_);"
            points="90.155,135.184 90.93,137.567 88.511,138.354
			87.736,135.97 		"
          />
        </g>
        <g>
          <path
            style="fill:#080808;"
            d="M47.354,138.013c0,20.914,16.954,37.868,37.875,37.868c20.914,0,37.868-16.954,37.868-37.868
			s-16.954-37.876-37.868-37.876C64.308,100.137,47.354,117.099,47.354,138.013 M57.427,138.013
			c0-15.351,12.444-27.802,27.802-27.802c15.35,0,27.795,12.451,27.795,27.802c0,15.35-12.445,27.794-27.795,27.794
			C69.871,165.807,57.427,153.362,57.427,138.013"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_202_"
              d="M57.427,138.013c0-15.351,12.444-27.802,27.802-27.802c15.35,0,27.794,12.451,27.794,27.802
				s-12.444,27.794-27.794,27.794C69.871,165.807,57.427,153.363,57.427,138.013 M84.771,100.149l-0.433,1.59l-0.464-0.158
				l0.386-1.42c-0.27,0.008-0.541,0.008-0.81,0.021l-0.377,1.608l-0.469-0.142l0.338-1.437c-0.272,0.017-0.542,0.04-0.812,0.063
				l-0.319,1.611l-0.473-0.125l0.286-1.449c-0.271,0.026-0.539,0.059-0.808,0.091l-0.263,1.623l-0.478-0.109l0.235-1.451
				c-0.267,0.036-0.536,0.063-0.802,0.103l-0.208,1.642l-0.48-0.093l0.184-1.461c-0.268,0.044-0.533,0.093-0.8,0.143l-0.148,1.638
				l-0.484-0.075l0.134-1.474c-0.268,0.055-0.531,0.118-0.795,0.179l-0.092,1.641l-0.487-0.059l0.082-1.469
				c-0.263,0.063-0.526,0.121-0.787,0.189l-0.035,1.65l-0.487-0.042l0.03-1.469c-0.261,0.072-0.522,0.145-0.78,0.221l0.022,1.646
				l-0.488-0.024l-0.021-1.477c-0.26,0.082-0.515,0.174-0.772,0.261l0.08,1.639l-0.49-0.008l-0.072-1.468
				c-0.255,0.09-0.51,0.184-0.763,0.278l0.138,1.637l-0.49,0.009l-0.122-1.459c-0.251,0.1-0.505,0.194-0.753,0.297l0.194,1.635
				l-0.489,0.026l-0.173-1.457c-0.25,0.108-0.496,0.223-0.741,0.335l0.25,1.616l-0.489,0.044l-0.224-1.451
				c-0.246,0.117-0.486,0.242-0.728,0.365l0.306,1.604l-0.486,0.061l-0.274-1.432c-0.239,0.124-0.48,0.245-0.717,0.375l0.363,1.597
				l-0.484,0.077l-0.323-1.419c-0.235,0.133-0.47,0.266-0.702,0.404l0.416,1.576l-0.48,0.095l-0.374-1.412
				c-0.231,0.142-0.457,0.293-0.685,0.438l0.469,1.557l-0.477,0.11l-0.42-1.392c-0.226,0.148-0.449,0.302-0.672,0.456l0.524,1.538
				l-0.473,0.128l-0.466-1.37c-0.22,0.157-0.443,0.308-0.659,0.468l0.579,1.524l-0.468,0.144l-0.515-1.354
				c-0.214,0.165-0.427,0.333-0.638,0.503l0.627,1.492l-0.463,0.16l-0.563-1.34c-0.21,0.173-0.41,0.354-0.617,0.531l0.678,1.467
				l-0.457,0.177l-0.605-1.31c-0.202,0.178-0.405,0.356-0.604,0.54l0.73,1.445l-0.45,0.192l-0.65-1.286
				c-0.196,0.187-0.393,0.369-0.585,0.559l0.78,1.42l-0.444,0.208l-0.696-1.266c-0.19,0.192-0.374,0.391-0.56,0.588l0.826,1.385
				l-0.437,0.223l-0.739-1.241c-0.183,0.2-0.36,0.404-0.54,0.608l0.874,1.356l-0.428,0.238l-0.779-1.21
				c-0.176,0.204-0.355,0.406-0.526,0.614l0.925,1.331l-0.419,0.253l-0.822-1.182c-0.168,0.211-0.337,0.422-0.5,0.637l0.967,1.294
				l-0.41,0.268l-0.867-1.159c-0.162,0.218-0.314,0.441-0.472,0.662l1.011,1.258l-0.4,0.281l-0.905-1.125
				c-0.154,0.223-0.304,0.447-0.453,0.674l1.056,1.223l-0.39,0.296l-0.941-1.09c-0.146,0.227-0.296,0.45-0.436,0.681l1.102,1.191
				l-0.38,0.308l-0.981-1.059c-0.137,0.232-0.271,0.468-0.404,0.704l1.139,1.146l-0.369,0.322l-1.023-1.029
				c-0.129,0.237-0.249,0.481-0.374,0.723l1.178,1.105l-0.357,0.336l-1.053-0.99c-0.121,0.242-0.244,0.482-0.36,0.727l1.221,1.068
				l-0.346,0.348l-1.085-0.951c-0.112,0.245-0.227,0.49-0.334,0.738l1.257,1.024l-0.333,0.359l-1.125-0.917
				c-0.104,0.249-0.199,0.504-0.297,0.756l1.287,0.979l-0.32,0.37l-1.154-0.876c-0.095,0.253-0.186,0.509-0.275,0.765l1.324,0.933
				l-0.308,0.382l-1.18-0.833c-0.085,0.256-0.178,0.508-0.259,0.767l1.361,0.891l-0.293,0.393l-1.21-0.793
				c-0.078,0.26-0.151,0.521-0.222,0.781l1.383,0.838l-0.279,0.402l-1.242-0.752c-0.069,0.261-0.126,0.527-0.189,0.792l1.412,0.788
				l-0.267,0.411l-1.259-0.704c-0.058,0.263-0.121,0.524-0.174,0.791l1.443,0.741l-0.251,0.421l-1.282-0.659
				c-0.05,0.265-0.098,0.531-0.143,0.797l1.464,0.69l-0.237,0.428l-1.311-0.617c-0.041,0.267-0.069,0.539-0.103,0.808l1.482,0.635
				l-0.222,0.438l-1.325-0.567c-0.03,0.268-0.061,0.535-0.086,0.805l1.508,0.585l-0.207,0.445l-1.34-0.521
				c-0.021,0.27-0.045,0.537-0.061,0.807l1.526,0.531l-0.19,0.452l-1.364-0.475c-0.012,0.27-0.013,0.541-0.021,0.812l1.538,0.477
				l-0.175,0.458l-1.375-0.426c-0.002,0.139-0.011,0.276-0.011,0.416c0,0.132,0.009,0.263,0.01,0.395l1.558,0.424l-0.159,0.463
				l-1.386-0.377c0.007,0.27,0.009,0.54,0.021,0.808l1.575,0.37l-0.142,0.47l-1.407-0.33c0.016,0.271,0.041,0.54,0.062,0.81
				l1.583,0.313l-0.125,0.473l-1.42-0.28c0.025,0.271,0.055,0.538,0.086,0.808l1.598,0.258l-0.109,0.478l-1.425-0.23
				c0.035,0.267,0.063,0.536,0.102,0.802l1.616,0.204l-0.093,0.48l-1.439-0.182c0.044,0.268,0.093,0.534,0.143,0.799l1.615,0.148
				l-0.075,0.482l-1.451-0.132c0.053,0.268,0.115,0.53,0.174,0.794l1.622,0.09l-0.058,0.487l-1.45-0.081
				c0.062,0.262,0.118,0.527,0.185,0.787l1.637,0.034l-0.042,0.489l-1.455-0.031c0.071,0.261,0.145,0.521,0.221,0.779l1.631-0.022
				l-0.024,0.49l-1.467,0.019c0.082,0.261,0.175,0.515,0.261,0.772l1.628-0.08l-0.007,0.49l-1.457,0.07
				c0.089,0.256,0.179,0.511,0.273,0.764l1.631-0.137l0.01,0.489l-1.453,0.123c0.098,0.251,0.193,0.504,0.296,0.752l1.628-0.194
				l0.027,0.489l-1.455,0.174c0.107,0.249,0.223,0.494,0.335,0.741l1.614-0.25l0.044,0.488l-1.449,0.224
				c0.117,0.245,0.239,0.486,0.361,0.729l1.605-0.307l0.061,0.486l-1.434,0.274c0.124,0.238,0.242,0.481,0.372,0.719l1.602-0.364
				l0.078,0.484l-1.426,0.322c0.133,0.236,0.267,0.472,0.405,0.704l1.582-0.419l0.094,0.481l-1.421,0.375
				c0.141,0.231,0.293,0.457,0.44,0.686l1.564-0.472l0.111,0.477l-1.401,0.424c0.149,0.226,0.299,0.449,0.452,0.673l1.551-0.528
				l0.128,0.473l-1.382,0.471c0.156,0.221,0.307,0.443,0.468,0.66l1.536-0.583l0.145,0.469l-1.37,0.519
				c0.165,0.216,0.333,0.427,0.502,0.64l1.509-0.635l0.16,0.463l-1.356,0.57c0.172,0.209,0.352,0.413,0.529,0.619l1.486-0.687
				l0.176,0.456l-1.329,0.614c0.178,0.203,0.354,0.407,0.537,0.606l1.468-0.741l0.192,0.45l-1.307,0.661
				c0.185,0.195,0.37,0.394,0.559,0.587l1.44-0.792l0.208,0.442l-1.29,0.709c0.192,0.19,0.391,0.375,0.588,0.562l1.409-0.839
				l0.223,0.436l-1.264,0.753c0.199,0.185,0.402,0.363,0.604,0.543l1.383-0.891l0.238,0.428l-1.235,0.796
				c0.204,0.176,0.404,0.357,0.612,0.529l1.359-0.945l0.253,0.42l-1.21,0.842c0.212,0.169,0.424,0.337,0.638,0.501l1.32-0.988
				l0.269,0.411l-1.189,0.889c0.217,0.162,0.442,0.314,0.664,0.472l1.285-1.033l0.282,0.4l-1.153,0.928
				c0.221,0.154,0.445,0.308,0.67,0.456l1.254-1.083l0.296,0.392l-1.12,0.966c0.227,0.147,0.451,0.297,0.681,0.438l1.22-1.13
				l0.31,0.38l-1.092,1.012c0.233,0.138,0.469,0.271,0.705,0.404l1.177-1.169l0.322,0.369l-1.06,1.054
				c0.238,0.129,0.481,0.252,0.721,0.377l1.139-1.212l0.334,0.357l-1.019,1.086c0.241,0.122,0.479,0.247,0.723,0.364l1.102-1.259
				l0.347,0.346l-0.983,1.122c0.245,0.114,0.491,0.227,0.739,0.335l1.056-1.295l0.359,0.334l-0.949,1.164
				c0.249,0.104,0.505,0.199,0.757,0.299l1.009-1.329l0.371,0.32l-0.907,1.195c0.253,0.096,0.508,0.188,0.763,0.279l0.965-1.369
				l0.382,0.308l-0.863,1.224c0.255,0.087,0.509,0.179,0.767,0.261l0.92-1.407l0.392,0.294l-0.823,1.258
				c0.259,0.078,0.521,0.15,0.783,0.223l0.867-1.432l0.402,0.279l-0.781,1.29c0.262,0.069,0.527,0.129,0.792,0.191l0.817-1.462
				l0.411,0.266l-0.732,1.311c0.263,0.06,0.524,0.125,0.791,0.179l0.769-1.499l0.42,0.251l-0.686,1.337
				c0.265,0.05,0.532,0.1,0.8,0.144l0.714-1.519l0.429,0.236l-0.645,1.369c0.269,0.042,0.541,0.068,0.81,0.104l0.661-1.54
				l0.437,0.222l-0.593,1.383c0.269,0.031,0.537,0.063,0.807,0.089l0.608-1.568l0.445,0.206l-0.544,1.4
				c0.27,0.022,0.538,0.046,0.81,0.063l0.553-1.588l0.451,0.191l-0.497,1.427c0.27,0.013,0.543,0.014,0.815,0.021l0.495-1.603
				l0.458,0.174l-0.445,1.44c0.157,0.002,0.312,0.012,0.47,0.012c0.115,0,0.227-0.007,0.342-0.008l0.442-1.625l0.463,0.159
				l-0.395,1.453c0.271-0.007,0.542-0.01,0.811-0.021l0.385-1.642l0.469,0.142l-0.346,1.477c0.272-0.017,0.541-0.041,0.812-0.063
				l0.328-1.651l0.473,0.125l-0.295,1.488c0.271-0.024,0.54-0.054,0.809-0.083l0.27-1.67l0.478,0.109l-0.242,1.496
				c0.268-0.033,0.537-0.063,0.804-0.103l0.213-1.686l0.481,0.092l-0.191,1.512c0.269-0.044,0.535-0.093,0.802-0.143l0.154-1.688
				l0.483,0.075l-0.139,1.524c0.268-0.054,0.532-0.113,0.797-0.173l0.095-1.696l0.486,0.058l-0.085,1.524
				c0.262-0.062,0.529-0.116,0.789-0.184l0.036-1.712l0.489,0.041l-0.033,1.531c0.262-0.071,0.523-0.146,0.782-0.222l-0.023-1.706
				l0.489,0.024l0.022,1.542c0.26-0.081,0.516-0.174,0.774-0.261l-0.084-1.704l0.49,0.008l0.076,1.533
				c0.255-0.09,0.512-0.179,0.765-0.272l-0.144-1.708l0.49-0.011l0.129,1.53c0.252-0.098,0.506-0.194,0.756-0.297l-0.204-1.703
				l0.49-0.027l0.182,1.531c0.25-0.106,0.497-0.223,0.743-0.336l-0.261-1.688l0.488-0.045l0.236,1.524
				c0.245-0.117,0.488-0.239,0.731-0.361l-0.321-1.681l0.486-0.06l0.288,1.509c0.241-0.124,0.484-0.242,0.722-0.372l-0.382-1.677
				l0.485-0.078l0.34,1.501c0.236-0.134,0.472-0.27,0.705-0.406l-0.437-1.656l0.481-0.095l0.396,1.496
				c0.232-0.142,0.458-0.294,0.687-0.441l-0.494-1.637l0.477-0.112l0.445,1.476c0.226-0.15,0.452-0.3,0.676-0.454l-0.553-1.623
				l0.473-0.128l0.495,1.456c0.222-0.157,0.445-0.311,0.662-0.471l-0.61-1.607l0.469-0.145l0.547,1.441
				c0.216-0.165,0.428-0.334,0.641-0.504l-0.664-1.577l0.463-0.161l0.599,1.425c0.211-0.173,0.414-0.353,0.621-0.529l-0.718-1.555
				l0.457-0.177l0.646,1.398c0.203-0.18,0.408-0.356,0.608-0.539l-0.775-1.535l0.45-0.191l0.694,1.373
				c0.198-0.185,0.396-0.371,0.589-0.561l-0.828-1.504l0.444-0.208l0.745,1.354c0.191-0.192,0.376-0.393,0.563-0.59l-0.878-1.472
				l0.437-0.224l0.791,1.328c0.184-0.199,0.364-0.403,0.544-0.607l-0.929-1.442l0.427-0.239l0.835,1.296
				c0.177-0.204,0.359-0.404,0.531-0.613l-0.986-1.417l0.419-0.254l0.882,1.269c0.17-0.212,0.338-0.425,0.504-0.64l-1.031-1.377
				l0.41-0.269l0.932,1.245c0.163-0.218,0.315-0.444,0.473-0.666l-1.077-1.34l0.401-0.281l0.971,1.207
				c0.154-0.223,0.307-0.447,0.457-0.674l-1.127-1.305l0.391-0.296l1.011,1.172c0.147-0.229,0.297-0.453,0.439-0.684l-1.176-1.27
				l0.38-0.31l1.056,1.141c0.138-0.233,0.272-0.47,0.406-0.707l-1.215-1.225l0.369-0.321l1.098,1.106
				c0.131-0.238,0.253-0.481,0.378-0.724l-1.258-1.181l0.358-0.336l1.133,1.063c0.121-0.242,0.246-0.483,0.363-0.727l-1.305-1.144
				l0.346-0.347l1.169,1.023c0.113-0.245,0.228-0.491,0.336-0.74l-1.342-1.096l0.333-0.358l1.21,0.986
				c0.106-0.25,0.201-0.505,0.3-0.759l-1.376-1.045l0.32-0.371l1.242,0.943c0.097-0.253,0.188-0.509,0.278-0.767l-1.414-0.997
				l0.307-0.382l1.271,0.896c0.087-0.256,0.179-0.51,0.26-0.77l-1.453-0.951l0.293-0.393l1.304,0.854
				c0.078-0.261,0.151-0.522,0.223-0.785l-1.478-0.895l0.28-0.402l1.336,0.81c0.069-0.263,0.127-0.53,0.19-0.795l-1.507-0.843
				l0.266-0.411l1.355,0.758c0.06-0.265,0.123-0.526,0.176-0.794l-1.541-0.792l0.251-0.42l1.38,0.708
				c0.05-0.266,0.099-0.533,0.143-0.801l-1.562-0.735l0.237-0.429l1.411,0.664c0.04-0.269,0.068-0.541,0.103-0.813l-1.581-0.678
				l0.221-0.436l1.424,0.609c0.03-0.269,0.061-0.538,0.086-0.81l-1.606-0.623l0.206-0.444l1.44,0.559
				c0.021-0.271,0.045-0.539,0.061-0.811l-1.625-0.567l0.19-0.45l1.463,0.509c0.012-0.271,0.013-0.544,0.021-0.816l-1.637-0.507
				l0.174-0.458l1.475,0.457c0.002-0.137,0.01-0.271,0.01-0.408s-0.008-0.27-0.01-0.405l-1.657-0.451l0.159-0.464l1.486,0.403
				c-0.007-0.27-0.009-0.542-0.021-0.811l-1.675-0.395l0.142-0.469l1.505,0.354c-0.015-0.272-0.039-0.543-0.061-0.813l-1.681-0.332
				l0.126-0.475l1.516,0.301c-0.025-0.271-0.056-0.541-0.087-0.81l-1.695-0.275l0.109-0.479l1.522,0.247
				c-0.034-0.268-0.062-0.539-0.103-0.805l-1.711-0.217l0.092-0.481l1.534,0.194c-0.044-0.27-0.093-0.535-0.143-0.802l-1.71-0.156
				l0.075-0.483l1.546,0.141c-0.053-0.268-0.117-0.532-0.176-0.797l-1.715-0.098l0.058-0.485l1.542,0.087
				c-0.062-0.265-0.12-0.529-0.187-0.79l-1.726-0.037l0.041-0.488l1.544,0.032c-0.072-0.262-0.145-0.523-0.222-0.783l-1.719,0.024
				l0.024-0.489l1.554-0.022c-0.082-0.261-0.176-0.515-0.262-0.773l-1.714,0.084l0.008-0.49l1.543-0.075
				c-0.091-0.257-0.182-0.512-0.278-0.766l-1.713,0.144l-0.009-0.489l1.535-0.128c-0.098-0.253-0.194-0.508-0.298-0.757
				l-1.708,0.203l-0.027-0.489l1.532-0.183c-0.108-0.25-0.222-0.496-0.335-0.744l-1.692,0.263l-0.044-0.488l1.527-0.235
				c-0.117-0.247-0.242-0.487-0.365-0.73l-1.679,0.319l-0.06-0.485l1.507-0.288c-0.124-0.24-0.246-0.483-0.375-0.721l-1.672,0.381
				l-0.078-0.484l1.495-0.34c-0.134-0.236-0.267-0.472-0.406-0.705l-1.65,0.436l-0.095-0.479l1.487-0.394
				c-0.142-0.232-0.293-0.459-0.441-0.688l-1.628,0.491l-0.112-0.478l1.465-0.441c-0.149-0.227-0.302-0.451-0.457-0.675l-1.61,0.549
				l-0.128-0.474l1.443-0.491c-0.157-0.22-0.309-0.443-0.471-0.66l-1.594,0.605l-0.144-0.469l1.425-0.541
				c-0.166-0.216-0.334-0.429-0.503-0.64l-1.562,0.655l-0.161-0.463l1.41-0.592c-0.173-0.21-0.356-0.413-0.534-0.619l-1.534,0.709
				l-0.177-0.457l1.378-0.637c-0.179-0.203-0.358-0.406-0.542-0.606l-1.512,0.765l-0.192-0.45l1.351-0.684
				c-0.185-0.196-0.369-0.396-0.559-0.588l-1.484,0.816l-0.208-0.444l1.33-0.731c-0.194-0.189-0.392-0.375-0.59-0.563l-1.448,0.864
				l-0.223-0.437l1.304-0.777c-0.2-0.185-0.406-0.362-0.609-0.541l-1.418,0.914l-0.238-0.429l1.271-0.819
				c-0.206-0.175-0.408-0.355-0.617-0.526l-1.389,0.965l-0.253-0.419l1.24-0.862c-0.212-0.169-0.424-0.338-0.639-0.502l-1.35,1.01
				l-0.268-0.41l1.215-0.909c-0.218-0.162-0.443-0.314-0.665-0.473l-1.311,1.054l-0.282-0.401l1.179-0.947
				c-0.223-0.154-0.448-0.305-0.675-0.453l-1.275,1.1l-0.296-0.39l1.142-0.986c-0.228-0.146-0.452-0.297-0.682-0.437l-1.241,1.147
				l-0.309-0.38l1.108-1.025c-0.233-0.139-0.469-0.272-0.706-0.406l-1.193,1.186l-0.322-0.369l1.076-1.068
				c-0.238-0.131-0.483-0.25-0.724-0.375l-1.15,1.225l-0.335-0.357l1.032-1.1c-0.242-0.121-0.483-0.244-0.728-0.359l-1.111,1.268
				l-0.347-0.346l0.993-1.134c-0.247-0.111-0.492-0.226-0.74-0.333l-1.065,1.305l-0.359-0.333l0.955-1.171
				c-0.25-0.105-0.505-0.2-0.758-0.299l-1.014,1.335l-0.37-0.32l0.912-1.201c-0.254-0.096-0.511-0.186-0.767-0.276l-0.967,1.371
				l-0.381-0.307l0.865-1.227c-0.256-0.087-0.509-0.18-0.767-0.261l-0.923,1.41l-0.392-0.294l0.822-1.256
				c-0.26-0.078-0.521-0.151-0.783-0.223l-0.865,1.431l-0.403-0.28l0.782-1.289c-0.263-0.068-0.531-0.123-0.796-0.186l-0.814,1.456
				l-0.411-0.268l0.729-1.304c-0.264-0.058-0.526-0.119-0.793-0.173l-0.764,1.487l-0.42-0.251l0.68-1.325
				c-0.265-0.05-0.531-0.1-0.799-0.145l-0.709,1.508l-0.429-0.236l0.637-1.354c-0.269-0.039-0.539-0.067-0.809-0.102l-0.653,1.522
				l-0.437-0.222l0.585-1.366c-0.269-0.029-0.538-0.058-0.809-0.084l-0.599,1.547l-0.445-0.206l0.535-1.379
				c-0.269-0.021-0.537-0.046-0.808-0.062l-0.545,1.565l-0.451-0.19l0.487-1.4c-0.271-0.011-0.542-0.014-0.814-0.02l-0.487,1.573
				l-0.458-0.176l0.437-1.41c-0.119-0.002-0.235-0.01-0.354-0.01C85.075,100.137,84.924,100.147,84.771,100.149"
            />
          </defs>
          <clipPath id="SVGIDA_203_">
            <use xlink:href="#SVGIDA_202_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_204_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(37.8716 0 0 -37.8716 6031.0776 7750.2124)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#272726" />
            <stop offset="0.6946" style="stop-color:#272726" />
            <stop offset="0.9079" style="stop-color:#575756" />
            <stop offset="1" style="stop-color:#2E2D2C" />
          </radialGradient>
          <rect
            x="47.353"
            y="100.137"
            :style="rearWheelClass"
            v-on:click="changeSeverity('rearWheel')"
            style="clip-path:url(#SVGIDA_203_);fill:url(#SVGIDA_204_);"
            width="75.743"
            height="75.743"
          />
        </g>
        <g>
          <path
            d="M378.198,138.009c0,16.028,12.994,29.022,29.023,29.022c16.027,0,29.021-12.994,29.021-29.022
			c0-16.029-12.994-29.022-29.021-29.022C391.192,108.986,378.198,121.979,378.198,138.009"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_205_"
              d="M404.439,118.835c-0.481,0.071-0.961,0.16-1.441,0.267c-0.002,0.001-0.003,0.001-0.005,0.001
				c-0.012,0.004-0.024,0.007-0.036,0.01c-3.089,0.706-6.115,2.219-8.529,4.344c-0.312,0.275-0.617,0.561-0.912,0.857
				c-0.016,0.015-0.03,0.03-0.046,0.046c-0.002,0.001-0.003,0.003-0.004,0.004c-0.682,0.688-1.309,1.424-1.876,2.2
				c-0.586,0.803-1.108,1.647-1.565,2.527c-0.256,0.492-0.489,0.994-0.702,1.507c-0.227,0.545-0.429,1.104-0.606,1.677
				c-0.102,0.326-0.194,0.657-0.28,0.992c-0.121,0.481-0.226,0.968-0.31,1.457c-0.171,0.985-0.266,1.99-0.28,3.003
				c-0.015,1.016,0.053,2.039,0.201,3.064c0.151,1.025,0.384,2.052,0.708,3.072c0.317,1,0.708,1.956,1.164,2.864
				c0.457,0.908,0.979,1.771,1.56,2.579c0.599,0.834,1.258,1.612,1.971,2.332s1.479,1.377,2.29,1.974
				c0.815,0.6,1.677,1.134,2.573,1.599c0.898,0.465,1.83,0.859,2.791,1.18c0.883,0.294,1.787,0.525,2.707,0.691
				c0.54,0.097,1.086,0.171,1.638,0.222c0.018,0.002,0.035,0.003,0.053,0.005c0.009,0.001,0.018,0.001,0.027,0.002
				c3.328,0.289,6.791-0.332,9.763-1.689c0.497-0.228,0.978-0.472,1.444-0.733c0.015-0.009,0.029-0.017,0.046-0.025
				c0.004-0.003,0.009-0.005,0.013-0.009c0.728-0.412,1.422-0.869,2.081-1.364c0.729-0.549,1.414-1.146,2.051-1.783
				c0.001-0.001,0.002-0.002,0.003-0.003c0.016-0.017,0.031-0.032,0.047-0.047c0.009-0.009,0.018-0.019,0.025-0.026
				c0.005-0.005,0.01-0.01,0.015-0.015c0.042-0.043,0.084-0.086,0.126-0.13c0.01-0.01,0.019-0.019,0.026-0.027
				c0.009-0.008,0.017-0.017,0.025-0.025c0.013-0.014,0.025-0.026,0.039-0.041c0.005-0.005,0.01-0.011,0.015-0.016
				c0.164-0.172,0.324-0.347,0.481-0.525l0,0c0.019-0.021,0.036-0.042,0.056-0.063c0.002-0.003,0.004-0.005,0.006-0.007
				c0.018-0.021,0.037-0.043,0.055-0.064c0.001,0,0.001-0.001,0.001-0.002c0.02-0.021,0.038-0.043,0.058-0.064
				c0.005-0.006,0.01-0.012,0.015-0.018c0.012-0.015,0.024-0.029,0.036-0.043c0.01-0.011,0.019-0.021,0.029-0.034
				c0.006-0.007,0.013-0.015,0.02-0.022c0.012-0.016,0.024-0.029,0.036-0.044c0.003-0.002,0.005-0.005,0.007-0.008
				c0.233-0.278,0.458-0.562,0.674-0.85c0.245-0.329,0.48-0.663,0.703-1.004c0.001-0.001,0.001-0.002,0.002-0.002
				c0.01-0.016,0.021-0.033,0.031-0.049c0.008-0.012,0.016-0.024,0.024-0.036c0.007-0.011,0.014-0.022,0.021-0.034
				c0.016-0.024,0.032-0.05,0.047-0.075c0.004-0.004,0.007-0.009,0.01-0.014c0.393-0.616,0.749-1.253,1.069-1.909
				c0.49-1.003,0.894-2.049,1.206-3.126c0.209-0.722,0.377-1.458,0.502-2.204c0.085-0.512,0.15-1.028,0.194-1.549
				c0.002-0.024,0.004-0.05,0.006-0.075c0-0.001,0-0.002,0-0.002c0.035-0.435,0.055-0.871,0.061-1.31
				c0.012-0.997-0.055-2.002-0.2-3.009c-0.014-0.088-0.026-0.178-0.04-0.266c-0.001-0.004-0.003-0.008-0.003-0.012
				c-0.004-0.021-0.007-0.043-0.011-0.064c0-0.003-0.001-0.006-0.001-0.009c-0.006-0.038-0.013-0.076-0.019-0.112
				c-0.002-0.011-0.004-0.021-0.005-0.029c-0.003-0.016-0.006-0.03-0.009-0.045c-0.002-0.015-0.005-0.028-0.007-0.041
				c-0.003-0.015-0.005-0.028-0.008-0.042c-0.003-0.021-0.007-0.041-0.011-0.063c-0.001-0.006-0.002-0.013-0.004-0.02
				c-0.005-0.029-0.012-0.06-0.017-0.089c-0.001-0.003-0.001-0.008-0.002-0.011c-0.006-0.028-0.011-0.058-0.017-0.087
				c0-0.001,0-0.002,0-0.003c-0.142-0.729-0.328-1.461-0.56-2.188c-0.322-1.02-0.722-1.994-1.19-2.917
				c-0.468-0.927-1.004-1.801-1.602-2.621c-0.596-0.82-1.252-1.587-1.958-2.293c-0.616-0.617-1.271-1.19-1.961-1.715
				c-0.008-0.007-0.015-0.013-0.022-0.019c-0.012-0.009-0.023-0.017-0.035-0.025c-0.115-0.088-0.231-0.174-0.348-0.258
				c-0.774-0.558-1.587-1.057-2.431-1.495c-0.628-0.325-1.273-0.616-1.934-0.872c-0.016-0.007-0.032-0.013-0.048-0.019
				c-0.006-0.003-0.013-0.005-0.019-0.008c-0.312-0.119-0.628-0.23-0.946-0.334c-0.234-0.076-0.471-0.148-0.708-0.215
				c-0.003-0.002-0.008-0.003-0.012-0.004c-0.023-0.008-0.048-0.014-0.071-0.021c-0.012-0.003-0.021-0.006-0.032-0.009
				c-0.018-0.005-0.034-0.009-0.051-0.014c-0.021-0.007-0.042-0.012-0.063-0.018c-0.007-0.001-0.013-0.003-0.019-0.005
				c-0.569-0.153-1.147-0.281-1.73-0.381c-0.987-0.17-1.991-0.266-3.005-0.28c-0.092-0.002-0.184-0.002-0.276-0.002
				C406.303,118.632,405.371,118.698,404.439,118.835"
            />
          </defs>
          <clipPath id="SVGIDA_206_">
            <use xlink:href="#SVGIDA_205_" style="overflow:visible;" />
          </clipPath>
          <g style="clip-path:url(#SVGIDA_206_);">
            <g>
              <defs>
                <rect
                  id="SVGIDA_207_"
                  x="387.831"
                  y="118.632"
                  width="38.777"
                  height="38.968"
                />
              </defs>
              <clipPath id="SVGIDA_208_">
                <use xlink:href="#SVGIDA_207_" style="overflow:visible;" />
              </clipPath>
              <g
                transform="matrix(1 0 0 1 4.120229e-006 2.610213e-006)"
                style="clip-path:url(#SVGIDA_208_);"
              >
                <image
                  style="overflow:visible;"
                  width="81"
                  height="82"
                  xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA
EAMCAwYAAAISAAADdAAABWX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX
Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa
JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAFMAUwMBIgACEQEDEQH/
xACVAAACAwEBAQAAAAAAAAAAAAAABAMFBgECBwEBAAAAAAAAAAAAAAAAAAAAABAAAgMAAQMEAwEA
AAAAAAAAAwQBAgUAERITEBQVBiBQIjERAAEDAwICBgcIAwAAAAAAAAEAEQIhEgMxQYEEEGFxMhMU
IFGRsSJCgvChwVJicsIzY4OjEgEAAAAAAAAAAAAAAAAAAABQ/9oADAMBAAIRAxEAAAD6ACpJHjbo
lp7rPmskhzZtO5jTHQCNWurR2qv1B6jfiG6Ri6PTdLVm4KwF668gKOd6Mi5PACb/AASnfnFx4K6u
1UBWNdzpY9bQB5LyLK69cUNCHUX+GFsXmRWpbrzSZbXVwtplnAAAAPIFCiBpWAOgAAf/2gAIAQIA
AQUA/Sf/2gAIAQMAAQUA/Sf/2gAIAQEAAQUA9GG11qicg0ajTdIBpaNipHNYfyS1LxMWj1ealcLR
WJYyWotzWp1ElXqzEwFbRam98JxkHImJjhi1CPvGxGlm90KFusdmYOllC73NhuAiUVuyVRKgaiaH
BOfZHL0stp2HK2kE9dTL8lchmSgx6RRm9S6bgRLojb2KxJNEsk+Wr26SUsM3yLTy2cyOQOvqz3Au
e1Z7ffhVGSuizI8g1uDx5jnsbeNk1aGlsccvqApPyViyaLUpbpXhGH1eV+wU4PaWtymkC3Pdj6b9
jiaGq2fiuPSOHMtniQ8jjCEQ4FB+y92Mtdip8sg5mpxz7Q/icWqxQYKUhx6gKEKV5iw4UzcAnQu0
p0Jl6dqTHiZpXKoQ/bX00vIITbNzXx0/62r9oMe/aZ0UGAyKwS5LZS3HXtr6TETDn1wViprWBXaJ
15mW6EH/AGE+MZq+fmLIU/G3+a3i6I+38i3Ts/D/2gAIAQICBj8AE//aAAgBAwIGPwAT/9oACAEB
AQY/AOh80xEnSO57AngGHWiYZZQ/aW9ytPM5CH0uKBySu7VZllYdidECC4OhHoEwD5CPhHq60cua
RlMmpKAJRkE3WnPqRiF4c3nhOx+XsQI0PQckywCrqUZRCEZUqrxWiI9RVgNWVxGpQMkMT693t6MX
Lw078/cEHKsmdV42CpFaLJy0+/EGhXMZJaYyUbXOMHVC4i4IiJQnEl4lwrmDeW8x9V1lvtUpkPoA
iwT43TZYGcN1HnOUNuSP9uE0JG7LNjxyEI5sl08hoI42B+914HIYzM6GbalGUgQDsnk6qFb/AIfC
4X3qQP2otVUhW4cJmTu1EMnMxhAktDHEAzkU8yIgTsMyLhGTAh32QM8OPLD5ZxDJp4rT2LQBbJ/0
3cHZROMExyRoesapzIh0JTqetExAuGgUuez1hjBMAdFzeKdbpGQ7UeT5n4oO0XV+Jqo2qhKtY3eS
v+vxL/ayDh5RLxWjIiJqrdYuiBQkKY/MV4sAx1QxzOiejlRuHwAueC02bh0HJAEx+ZtlaChIhWDY
LinZ6Jwo4oAykdkAdd+ljUFHPyptJrLGdOCaUbSER0N1JgLI7yKbEHme9kOp9LbipX+W4+I//NC3
y7/7/wCSDWfS/wCPo//Z"
                  transform="matrix(0.48 0 0 0.48 387.8311 118.6318)"
                ></image>
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_209_"
              d="M393.625,138.009c0,7.508,6.087,13.595,13.596,13.595c7.508,0,13.596-6.087,13.596-13.595
				c0-7.509-6.088-13.595-13.596-13.595C399.712,124.414,393.625,130.5,393.625,138.009"
            />
          </defs>
          <clipPath id="SVGIDA_210_">
            <use xlink:href="#SVGIDA_209_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_211_"
            cx="-156.9995"
            cy="201"
            r="1"
            gradientTransform="matrix(-13.595 0 0 -13.595 -1727.2001 2870.6135)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.8368" style="stop-color:#1A1A1A" />
            <stop offset="1" style="stop-color:#4E4D4D" />
          </radialGradient>
          <rect
            x="393.625"
            y="124.414"
            style="clip-path:url(#SVGIDA_210_);fill:url(#SVGIDA_211_);"
            width="27.191"
            height="27.189"
          />
        </g>
        <g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_212_"
                  x="387.844"
                  y="118.65"
                  width="38.754"
                  height="38.734"
                />
              </defs>
              <clipPath id="SVGIDA_213_">
                <use xlink:href="#SVGIDA_212_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_213_);">
                <defs>
                  <path
                    id="SVGIDA_214_"
                    d="M387.844,138.018c0,10.696,8.675,19.367,19.377,19.367c10.701,0,19.377-8.671,19.377-19.367
							s-8.676-19.367-19.377-19.367C396.519,118.65,387.844,127.321,387.844,138.018"
                  />
                </defs>
                <clipPath id="SVGIDA_215_">
                  <use xlink:href="#SVGIDA_214_" style="overflow:visible;" />
                </clipPath>

                <radialGradient
                  id="SVGIDA_216_"
                  cx="-156.9995"
                  cy="201.001"
                  r="1"
                  gradientTransform="matrix(-19.3771 0 0 -19.3673 -2634.9814 4030.8518)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" style="stop-color:#FFFFFF" />
                  <stop offset="0.5732" style="stop-color:#FFFFFF" />
                  <stop offset="0.7573" style="stop-color:#808080" />
                  <stop offset="1" style="stop-color:#676767" />
                </radialGradient>
                <rect
                  x="387.844"
                  y="118.65"
                  style="clip-path:url(#SVGIDA_215_);fill:url(#SVGIDA_216_);"
                  width="38.754"
                  height="38.734"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_217_"
              d="M398.37,118.891c-2.229,1.068-4.313,2.546-6.13,4.432c-1.354,1.402-2.734,3.45-3.409,4.625
				c-1.231,2.142-2.021,4.582-2.4,7.173c-0.38,2.597-0.275,5.156,0.245,7.583c0.018,0.084,1.254,4.132,2.205,5.867
				c0.157,0.286,0.507,0.406,0.812,0.289l4.117-1.774c0.791-0.282,1.273-1.083,1.152-1.915c-0.279-1.123-0.556-2.15-0.798-3.127
				c-0.434-1.756-0.599-3.564-0.469-5.354c0.079-1.091,0.367-2.158,0.771-3.175c0.007-0.017,0.015-0.033,0.021-0.051
				c0.983-2.468,2.495-4.702,4.501-6.445c0.702-0.607,1.47-1.201,2.367-1.84c0.575-0.597,0.649-1.517,0.178-2.199l-2.313-3.844
				c-0.129-0.195-0.346-0.308-0.567-0.308C398.558,118.827,398.461,118.848,398.37,118.891"
            />
          </defs>
          <clipPath id="SVGIDA_218_">
            <use xlink:href="#SVGIDA_217_" style="overflow:visible;" />
          </clipPath>

          <linearGradient
            id="SVGIDA_219_"
            gradientUnits="userSpaceOnUse"
            x1="-157"
            y1="201"
            x2="-156"
            y2="201"
            gradientTransform="matrix(0 -30.0773 30.0773 0 -5651.5166 -4573.2407)"
          >
            <stop offset="0" style="stop-color:#0E0405" />
            <stop offset="0.5021" style="stop-color:#681418" />
            <stop offset="1" style="stop-color:#0E0405" />
          </linearGradient>
          <rect
            x="386.051"
            y="118.827"
            style="clip-path:url(#SVGIDA_218_);fill:url(#SVGIDA_219_);"
            width="15.954"
            height="30.149"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_220_"
              d="M384.521,138.013c0-12.538,10.166-22.696,22.702-22.696c12.53,0,22.697,10.158,22.697,22.696
				c0,12.537-10.167,22.696-22.697,22.696C394.688,160.709,384.521,150.55,384.521,138.013 M379.422,138.013
				c0,15.351,12.445,27.794,27.802,27.794c15.352,0,27.795-12.443,27.795-27.794s-12.443-27.802-27.795-27.802
				C391.867,110.211,379.422,122.662,379.422,138.013"
            />
          </defs>
          <clipPath id="SVGIDA_221_">
            <use xlink:href="#SVGIDA_220_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_222_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(-27.7983 0 0 -27.7983 -3957.1201 5725.4673)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#7C7C7B" />
            <stop offset="0.8536" style="stop-color:#7C7C7B" />
            <stop offset="1" style="stop-color:#F0F0F0" />
          </radialGradient>
          <rect
            x="379.422"
            y="110.211"
            style="clip-path:url(#SVGIDA_221_);fill:url(#SVGIDA_222_);"
            :style="frontWheelClass"
            v-on:click="changeSeverity('frontWheel')"
            width="55.597"
            height="55.596"
          />
        </g>
        <g>
          <path
            style="fill:#4D4D4D;"
            d="M397.939,131.574l-9.794-5.875l6.749-6.754l5.901,9.825c1.705,1.217,3.854,0.325,4.415-1.88
			l-2.822-11.06h9.652l-2.829,11.131c0.356,2.054,2.5,2.936,4.452,1.773l5.872-9.792l6.754,6.753l-9.854,5.923
			c-1.195,1.702-0.307,3.835,1.89,4.396l11.088-2.775v9.545l-11.147-2.77c-2.053,0.35-2.938,2.482-1.793,4.432l9.815,5.882
			l-6.749,6.75l-5.909-9.818c-1.698-1.222-3.838-0.346-4.416,1.839l2.78,11.104l-9.502,0.042l2.722-11.134
			c-0.327-2.077-2.465-2.979-4.422-1.844l-5.887,9.81l-6.75-6.749l9.793-5.875c1.241-1.702,0.362-3.856-1.831-4.436l-11.087,2.766
			v-9.545l11.088,2.777C398.195,135.682,399.093,133.534,397.939,131.574"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_223_"
              d="M402.424,115.724l2.801,11.249c-0.557,2.189-2.688,3.073-4.382,1.866l-6.048-9.945
				c-0.037,0.03-6.673,6.671-6.701,6.705l9.914,6.023c1.145,1.945,0.253,4.078-1.809,4.409l-11.275-2.759
				c-0.004,0.043-0.005,9.43,0,9.477l11.275-2.746c2.178,0.575,3.05,2.714,1.816,4.402l-9.912,6.021
				c0.03,0.035,6.665,6.675,6.701,6.702l6.034-9.929c1.943-1.127,4.065-0.232,4.39,1.829l-2.703,11.321
				c0.046,0.005,9.39-0.036,9.435-0.042l-2.76-11.292c0.573-2.169,2.696-3.038,4.383-1.824l6.055,9.937
				c0.038-0.03,6.675-6.669,6.701-6.702l-9.935-6.027c-1.136-1.936-0.258-4.053,1.78-4.399l11.334,2.749
				c0.007-0.045,0.007-9.43,0-9.476l-11.275,2.757c-2.179-0.558-3.063-2.674-1.875-4.364l9.972-6.07
				c-0.027-0.035-6.667-6.673-6.705-6.704l-6.019,9.911c-1.938,1.155-4.065,0.28-4.419-1.76l2.808-11.319
				c-0.018-0.002-1.724-0.003-3.692-0.003C405.626,115.721,402.45,115.723,402.424,115.724"
            />
          </defs>
          <clipPath id="SVGIDA_224_">
            <use xlink:href="#SVGIDA_223_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_225_"
            cx="-156.9995"
            cy="200.999"
            r="1.0002"
            gradientTransform="matrix(22.0569 -0.3168 0.3168 -22.6906 3806.4812 4649.0767)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#737372" />
            <stop offset="0.5272" style="stop-color:#727271" />
            <stop offset="1" style="stop-color:#737372" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_224_);fill:url(#SVGIDA_225_);"
            points="384.919,115.721 430.157,115.071 429.525,160.355
			384.287,161.005 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_226_"
              d="M402.459,115.618l2.782,11.437c-0.554,2.173-2.67,3.051-4.351,1.853l-6.195-10.064
				c-0.072,0.061-6.597,6.587-6.652,6.657l10.033,6.169c1.137,1.931,0.252,4.048-1.795,4.376l-11.464-2.738
				c-0.009,0.087-0.011,9.315,0,9.408l11.464-2.726c2.162,0.569,3.026,2.692,1.804,4.37l-10.032,6.168
				c0.063,0.069,6.581,6.598,6.653,6.652l6.181-10.048c1.929-1.118,4.034-0.23,4.356,1.815l-2.686,11.51
				c0.094,0.008,9.279-0.032,9.368-0.042l-2.741-11.48c0.568-2.151,2.678-3.016,4.351-1.812l6.202,10.057
				c0.077-0.06,6.599-6.588,6.652-6.652l-10.053-6.177c-1.129-1.92-0.257-4.021,1.767-4.365l11.521,2.73
				c0.01-0.091,0.01-9.316,0-9.409l-11.464,2.737c-2.163-0.552-3.039-2.654-1.86-4.33l10.091-6.217
				c-0.056-0.071-6.582-6.595-6.657-6.656l-6.166,10.03c-1.924,1.146-4.034,0.277-4.386-1.747l2.787-11.506
				c-0.039-0.005-1.919-0.006-3.998-0.006C405.393,115.612,402.51,115.614,402.459,115.618"
            />
          </defs>
          <clipPath id="SVGIDA_227_">
            <use xlink:href="#SVGIDA_226_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_228_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(21.9324 -0.6527 0.6527 -23.2377 3719.4304 4706.3369)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#767675" />
            <stop offset="0.5272" style="stop-color:#747473" />
            <stop offset="1" style="stop-color:#767675" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_227_);fill:url(#SVGIDA_228_);"
            points="384.807,115.612 430.934,114.239 429.635,160.465
			383.509,161.838 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_229_"
              d="M402.494,115.512l2.761,11.625c-0.549,2.156-2.648,3.027-4.317,1.839l-6.342-10.185
				c-0.108,0.091-6.521,6.504-6.604,6.61l10.152,6.314c1.128,1.917,0.25,4.019-1.78,4.345l-11.652-2.72
				c-0.012,0.13-0.015,9.199,0,9.341l11.652-2.708c2.145,0.566,3.004,2.674,1.789,4.337l-10.151,6.315
				c0.093,0.105,6.497,6.523,6.605,6.605l6.327-10.167c1.914-1.111,4.004-0.23,4.324,1.801l-2.667,11.696
				c0.141,0.014,9.168-0.024,9.301-0.039l-2.722-11.67c0.564-2.136,2.658-2.991,4.318-1.798l6.348,10.177
				c0.115-0.091,6.523-6.509,6.605-6.605l-10.174-6.322c-1.118-1.906-0.254-3.992,1.754-4.334l11.711,2.712
				c0.015-0.136,0.015-9.203,0-9.34l-11.653,2.718c-2.147-0.549-3.017-2.635-1.847-4.3l10.211-6.361
				c-0.084-0.106-6.496-6.517-6.61-6.608l-6.312,10.15c-1.908,1.137-4.005,0.274-4.354-1.734l2.767-11.695
				c-0.057-0.006-1.846-0.009-3.851-0.009C405.507,115.502,402.572,115.506,402.494,115.512"
            />
          </defs>
          <clipPath id="SVGIDA_230_">
            <use xlink:href="#SVGIDA_229_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_231_"
            cx="-156.999"
            cy="201"
            r="0.9995"
            gradientTransform="matrix(21.8166 -1.0101 1.0101 -23.8367 3629.3884 4770.6138)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#797978" />
            <stop offset="0.5272" style="stop-color:#767675" />
            <stop offset="1" style="stop-color:#797978" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_230_);fill:url(#SVGIDA_231_);"
            points="384.696,115.502 431.749,113.323 429.747,160.575
			382.693,162.754 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_232_"
              d="M402.529,115.405l2.742,11.813c-0.547,2.141-2.631,3.004-4.285,1.825l-6.489-10.303
				c-0.146,0.12-6.444,6.42-6.556,6.561l10.271,6.462c1.119,1.903,0.248,3.987-1.768,4.312l-11.84-2.7
				c-0.017,0.174-0.022,9.085,0,9.273l11.84-2.689c2.129,0.563,2.98,2.653,1.775,4.304l-10.271,6.462
				c0.124,0.142,6.413,6.449,6.557,6.559l6.475-10.288c1.899-1.102,3.975-0.227,4.29,1.789l-2.646,11.883
				c0.185,0.017,9.054-0.019,9.233-0.039l-2.702-11.855c0.56-2.12,2.637-2.972,4.285-1.785l6.493,10.296
				c0.154-0.121,6.449-6.427,6.558-6.558l-10.292-6.469c-1.111-1.893-0.253-3.962,1.741-4.301l11.896,2.692
				c0.021-0.182,0.021-9.09,0-9.272l-11.841,2.698c-2.131-0.545-2.993-2.614-1.833-4.267l10.329-6.509
				c-0.11-0.142-6.409-6.438-6.562-6.56l-6.458,10.269c-1.895,1.129-3.975,0.274-4.32-1.72l2.747-11.883
				c-0.078-0.009-1.916-0.014-3.945-0.014C405.44,115.392,402.632,115.398,402.529,115.405"
            />
          </defs>
          <clipPath id="SVGIDA_233_">
            <use xlink:href="#SVGIDA_232_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_234_"
            cx="-157.0005"
            cy="200.998"
            r="1.0011"
            gradientTransform="matrix(21.7109 -1.3921 1.3921 -24.4951 3536.0317 4842.9658)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#7C7C7C" />
            <stop offset="0.5272" style="stop-color:#787877" />
            <stop offset="1" style="stop-color:#7C7C7C" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_233_);fill:url(#SVGIDA_234_);"
            points="384.583,115.392 432.607,112.313 429.857,160.684
			381.834,163.764 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_235_"
              d="M402.564,115.298l2.721,12.003c-0.541,2.124-2.61,2.982-4.253,1.812l-6.634-10.422
				c-0.184,0.15-6.369,6.337-6.509,6.512l10.392,6.609c1.11,1.888,0.246,3.956-1.754,4.278l-12.029-2.681
				c-0.02,0.217-0.027,8.97,0,9.204l12.028-2.668c2.112,0.557,2.959,2.631,1.763,4.271l-10.39,6.609
				c0.153,0.176,6.329,6.373,6.508,6.508l6.622-10.406c1.885-1.093,3.943-0.225,4.259,1.775l-2.63,12.072
				c0.23,0.021,8.942-0.015,9.165-0.039l-2.683-12.045c0.557-2.104,2.617-2.948,4.253-1.771l6.641,10.415
				c0.192-0.15,6.373-6.347,6.509-6.509l-10.411-6.616c-1.103-1.877-0.251-3.931,1.728-4.269l12.085,2.673
				c0.024-0.227,0.024-8.975,0-9.204l-12.029,2.679c-2.115-0.54-2.97-2.593-1.818-4.232l10.448-6.656
				c-0.14-0.177-6.325-6.357-6.513-6.51l-6.606,10.387c-1.88,1.121-3.943,0.271-4.287-1.707l2.727-12.071
				c-0.098-0.011-1.875-0.015-3.853-0.015C405.512,115.283,402.693,115.29,402.564,115.298"
            />
          </defs>
          <clipPath id="SVGIDA_236_">
            <use xlink:href="#SVGIDA_235_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_237_"
            cx="-157.0005"
            cy="200.998"
            r="1.0011"
            gradientTransform="matrix(21.6174 -1.8023 1.8023 -25.222 3438.8945 4924.666)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#807F7F" />
            <stop offset="0.5272" style="stop-color:#7A7A7A" />
            <stop offset="1" style="stop-color:#807F7F" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_236_);fill:url(#SVGIDA_237_);"
            points="384.471,115.283 433.514,111.194 429.969,160.795
			380.927,164.884 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_238_"
              d="M402.599,115.192l2.7,12.19c-0.536,2.107-2.589,2.959-4.219,1.797l-6.781-10.542
				c-0.22,0.183-6.293,6.253-6.461,6.465l10.511,6.757c1.104,1.873,0.244,3.927-1.739,4.246l-12.219-2.662
				c-0.023,0.26-0.03,8.854,0,9.136l12.218-2.649c2.097,0.553,2.937,2.612,1.75,4.239l-10.511,6.755
				c0.186,0.211,6.245,6.297,6.46,6.46l6.769-10.523c1.871-1.086,3.914-0.226,4.226,1.76l-2.611,12.259
				c0.277,0.026,8.833-0.007,9.099-0.038l-2.663-12.232c0.552-2.089,2.598-2.926,4.22-1.758l6.787,10.534
				c0.23-0.181,6.298-6.266,6.46-6.46l-10.53-6.764c-1.094-1.863-0.247-3.9,1.716-4.235l12.271,2.654
				c0.031-0.273,0.03-8.859,0-9.137l-12.216,2.66c-2.099-0.536-2.949-2.574-1.806-4.201l10.566-6.803
				c-0.166-0.212-6.237-6.278-6.464-6.463l-6.752,10.508c-1.866,1.111-3.915,0.27-4.256-1.693l2.707-12.259
				c-0.117-0.014-1.888-0.02-3.85-0.02C405.517,115.173,402.754,115.182,402.599,115.192"
            />
          </defs>
          <clipPath id="SVGIDA_239_">
            <use xlink:href="#SVGIDA_238_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_240_"
            cx="-156.9995"
            cy="201"
            r="0.9998"
            gradientTransform="matrix(21.5381 -2.2451 2.2451 -26.0284 3337.427 5017.2417)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#838282" />
            <stop offset="0.5272" style="stop-color:#7C7C7C" />
            <stop offset="1" style="stop-color:#838282" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_239_);fill:url(#SVGIDA_240_);"
            points="384.36,115.173 434.477,109.949 430.081,160.905
			379.965,166.129 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_241_"
              d="M402.634,115.086l2.682,12.379c-0.533,2.091-2.57,2.937-4.188,1.783l-6.928-10.66
				c-0.257,0.211-6.217,6.169-6.412,6.416l10.63,6.902c1.093,1.859,0.242,3.896-1.727,4.213l-12.406-2.643
				c-0.029,0.305-0.037,8.74,0,9.069l12.405-2.631c2.081,0.548,2.913,2.592,1.735,4.206l-10.629,6.903
				c0.216,0.245,6.16,6.222,6.412,6.411l6.914-10.645c1.857-1.077,3.884-0.222,4.194,1.747l-2.594,12.446
				c0.324,0.03,8.721-0.001,9.031-0.037l-2.644-12.421c0.548-2.071,2.576-2.902,4.188-1.743l6.935,10.652
				c0.268-0.21,6.222-6.185,6.411-6.411l-10.649-6.909c-1.086-1.851-0.247-3.872,1.701-4.203l12.46,2.634
				c0.035-0.318,0.035-8.745,0-9.069l-12.404,2.642c-2.083-0.532-2.925-2.554-1.791-4.169l10.686-6.948
				c-0.194-0.248-6.152-6.2-6.416-6.415l-6.899,10.627c-1.851,1.104-3.884,0.269-4.222-1.681l2.686-12.446
				c-0.137-0.016-1.918-0.021-3.875-0.021C405.501,115.064,402.813,115.074,402.634,115.086"
            />
          </defs>
          <clipPath id="SVGIDA_242_">
            <use xlink:href="#SVGIDA_241_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_243_"
            cx="-157"
            cy="200.999"
            r="1.0004"
            gradientTransform="matrix(21.4758 -2.726 2.726 -26.9278 3231.0027 5122.521)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#868585" />
            <stop offset="0.5272" style="stop-color:#7F7E7E" />
            <stop offset="1" style="stop-color:#868585" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_242_);fill:url(#SVGIDA_243_);"
            points="384.248,115.064 435.501,108.559 430.191,161.015
			378.938,167.521 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_244_"
              d="M402.669,114.979l2.66,12.568c-0.528,2.076-2.55,2.913-4.154,1.77l-7.074-10.779
				c-0.294,0.242-6.141,6.086-6.363,6.367l10.749,7.05c1.086,1.844,0.24,3.866-1.713,4.18l-12.595-2.622
				c-0.032,0.347-0.042,8.624,0,9l12.593-2.611c2.064,0.544,2.892,2.571,1.723,4.173l-10.748,7.05
				c0.246,0.282,6.077,6.146,6.364,6.364l7.061-10.765c1.841-1.068,3.854-0.221,4.161,1.733l-2.575,12.634
				c0.371,0.035,8.608,0.005,8.964-0.036l-2.625-12.608c0.544-2.057,2.558-2.881,4.156-1.73l7.08,10.772
				c0.307-0.24,6.146-6.104,6.364-6.364l-10.77-7.056c-1.078-1.834-0.245-3.842,1.688-4.171l12.647,2.615
				c0.04-0.362,0.039-8.631,0-9l-12.593,2.621c-2.066-0.527-2.903-2.535-1.778-4.137l10.806-7.094
				c-0.223-0.283-6.066-6.121-6.368-6.366l-7.046,10.746c-1.837,1.094-3.854,0.265-4.188-1.668l2.664-12.636
				c-0.153-0.018-1.879-0.023-3.787-0.023C405.569,114.955,402.876,114.965,402.669,114.979"
            />
          </defs>
          <clipPath id="SVGIDA_245_">
            <use xlink:href="#SVGIDA_244_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_246_"
            cx="-157"
            cy="200.999"
            r="1.0004"
            gradientTransform="matrix(21.4336 -3.2515 3.2515 -27.9367 3118.7263 5242.7896)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#898888" />
            <stop offset="0.5272" style="stop-color:#818080" />
            <stop offset="1" style="stop-color:#898888" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_245_);fill:url(#SVGIDA_246_);"
            points="384.137,114.955 436.604,106.996 430.303,161.125
			377.837,169.084 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_247_"
              d="M402.705,114.873l2.639,12.756c-0.523,2.06-2.529,2.89-4.122,1.755l-7.22-10.897
				c-0.331,0.271-6.066,6.002-6.317,6.318l10.87,7.196c1.076,1.83,0.238,3.836-1.699,4.148l-12.783-2.604
				c-0.036,0.39-0.047,8.509,0,8.931l12.781-2.592c2.049,0.54,2.868,2.552,1.709,4.142l-10.868,7.196
				c0.277,0.316,5.993,6.071,6.315,6.315l7.208-10.884c1.828-1.061,3.824-0.219,4.128,1.72l-2.556,12.822
				c0.417,0.038,8.497,0.01,8.897-0.035l-2.605-12.798c0.539-2.04,2.537-2.857,4.123-1.717l7.226,10.892
				c0.347-0.271,6.071-6.024,6.315-6.315l-10.887-7.204c-1.069-1.819-0.243-3.81,1.674-4.137l12.836,2.596
				c0.046-0.407,0.045-8.517,0-8.932l-12.781,2.603c-2.05-0.524-2.88-2.516-1.763-4.104l10.923-7.241
				c-0.25-0.318-5.98-6.043-6.319-6.318l-7.192,10.865c-1.822,1.086-3.824,0.264-4.157-1.654l2.645-12.822
				c-0.175-0.021-1.887-0.028-3.774-0.028C405.581,114.845,402.936,114.857,402.705,114.873"
            />
          </defs>
          <clipPath id="SVGIDA_248_">
            <use xlink:href="#SVGIDA_247_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_249_"
            cx="-157.0005"
            cy="201"
            r="1.0002"
            gradientTransform="matrix(21.4153 -3.8301 3.8301 -29.0755 2999.5879 5380.853)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#8B8B8B" />
            <stop offset="0.5272" style="stop-color:#838282" />
            <stop offset="1" style="stop-color:#8B8B8B" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_248_);fill:url(#SVGIDA_249_);"
            points="384.025,114.845 437.793,105.229 430.415,161.234
			376.647,170.851 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_250_"
              d="M402.74,114.766l2.619,12.945c-0.521,2.043-2.511,2.868-4.091,1.742l-7.365-11.019
				c-0.368,0.303-5.989,5.919-6.269,6.271l10.988,7.343c1.068,1.816,0.237,3.805-1.688,4.114l-12.97-2.583
				c-0.041,0.434-0.052,8.395,0,8.864l12.97-2.573c2.032,0.536,2.846,2.532,1.695,4.107l-10.988,7.344
				c0.31,0.351,5.909,5.996,6.269,6.267l7.354-11.003c1.813-1.051,3.793-0.217,4.096,1.706l-2.538,13.009
				c0.463,0.043,8.385,0.017,8.829-0.034l-2.585-12.984c0.533-2.024,2.517-2.835,4.09-1.703l7.373,11.01
				c0.384-0.299,5.997-5.942,6.268-6.267l-11.007-7.351c-1.063-1.806-0.242-3.78,1.661-4.104l13.022,2.577
				c0.051-0.453,0.05-8.403,0-8.864l-12.969,2.582c-2.034-0.52-2.857-2.495-1.75-4.071l11.043-7.388
				c-0.277-0.354-5.895-5.963-6.271-6.27l-7.339,10.985c-1.809,1.077-3.795,0.261-4.124-1.642l2.624-13.012
				c-0.194-0.021-1.893-0.03-3.76-0.03C405.596,114.735,402.997,114.749,402.74,114.766"
            />
          </defs>
          <clipPath id="SVGIDA_251_">
            <use xlink:href="#SVGIDA_250_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_252_"
            cx="-156.9995"
            cy="200.999"
            r="1.0001"
            gradientTransform="matrix(21.4259 -4.4722 4.4722 -30.3702 2872.1877 5540.3018)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#8E8E8E" />
            <stop offset="0.5272" style="stop-color:#858584" />
            <stop offset="1" style="stop-color:#8E8E8E" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_251_);fill:url(#SVGIDA_252_);"
            points="383.914,114.735 439.084,103.22 430.525,161.344
			375.354,172.859 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_253_"
              d="M402.775,114.66l2.598,13.133c-0.516,2.027-2.489,2.845-4.056,1.729l-7.515-11.138
				c-0.403,0.333-5.912,5.835-6.219,6.224l11.107,7.488c1.06,1.803,0.234,3.776-1.675,4.082l-13.157-2.563
				c-0.045,0.477-0.058,8.279,0,8.796l13.157-2.554c2.018,0.531,2.823,2.512,1.684,4.074l-11.108,7.491
				c0.339,0.386,5.825,5.92,6.219,6.219l7.502-11.123c1.799-1.043,3.764-0.215,4.063,1.693l-2.52,13.196
				c0.51,0.047,8.272,0.021,8.762-0.034l-2.566-13.173c0.53-2.007,2.497-2.813,4.058-1.69l7.52,11.131
				c0.422-0.331,5.921-5.862,6.22-6.219l-11.127-7.497c-1.052-1.791-0.238-3.752,1.648-4.073l13.211,2.559
				c0.056-0.499,0.055-8.289,0-8.796l-13.157,2.563c-2.018-0.516-2.834-2.476-1.734-4.041l11.16-7.533
				c-0.305-0.389-5.809-5.885-6.223-6.221l-7.486,11.104c-1.794,1.068-3.763,0.259-4.091-1.629l2.604-13.198
				c-0.214-0.025-1.896-0.034-3.742-0.034C405.612,114.626,403.057,114.641,402.775,114.66"
            />
          </defs>
          <clipPath id="SVGIDA_254_">
            <use xlink:href="#SVGIDA_253_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_255_"
            cx="-157.0005"
            cy="200.999"
            r="1.0006"
            gradientTransform="matrix(21.4713 -5.1912 5.1912 -31.8537 2734.7915 5725.6055)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#919190" />
            <stop offset="0.5272" style="stop-color:#878786" />
            <stop offset="1" style="stop-color:#919190" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_254_);fill:url(#SVGIDA_255_);"
            points="383.802,114.626 440.503,100.917 430.637,161.454
			373.937,175.163 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_256_"
              d="M402.81,114.553l2.578,13.322c-0.512,2.011-2.469,2.822-4.023,1.714l-7.66-11.256
				c-0.44,0.363-5.837,5.752-6.172,6.174l11.228,7.637c1.051,1.786,0.233,3.745-1.661,4.05l-13.346-2.545
				c-0.049,0.521-0.063,8.165,0,8.728l13.346-2.535c2,0.528,2.801,2.492,1.668,4.043l-11.227,7.638
				c0.371,0.421,5.742,5.845,6.172,6.171l7.648-11.242c1.784-1.035,3.732-0.213,4.03,1.68l-2.502,13.382
				c0.557,0.053,8.161,0.028,8.695-0.031l-2.546-13.362c0.524-1.991,2.477-2.79,4.024-1.676l7.666,11.25
				c0.461-0.36,5.846-5.782,6.171-6.171l-11.245-7.645c-1.043-1.777-0.237-3.721,1.635-4.039l13.398,2.538
				c0.061-0.544,0.06-8.174,0-8.728l-13.346,2.544c-2.001-0.512-2.811-2.455-1.722-4.008l11.281-7.68
				c-0.334-0.425-5.724-5.806-6.176-6.174l-7.633,11.224c-1.778,1.061-3.732,0.259-4.058-1.614l2.584-13.388
				c-0.233-0.025-1.885-0.036-3.699-0.036C405.646,114.517,403.119,114.533,402.81,114.553"
            />
          </defs>
          <clipPath id="SVGIDA_257_">
            <use xlink:href="#SVGIDA_256_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_258_"
            cx="-156.9995"
            cy="201"
            r="0.9998"
            gradientTransform="matrix(21.5595 -6.0048 6.0048 -33.569 2585.0972 5942.6289)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#949493" />
            <stop offset="0.5272" style="stop-color:#898988" />
            <stop offset="1" style="stop-color:#949493" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_257_);fill:url(#SVGIDA_258_);"
            points="383.689,114.517 442.072,98.256 430.748,161.564
			372.364,177.825 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_259_"
              d="M402.845,114.447l2.559,13.51c-0.509,1.994-2.45,2.799-3.992,1.7l-7.806-11.375
				c-0.477,0.392-5.762,5.669-6.123,6.126l11.346,7.783c1.043,1.772,0.23,3.715-1.647,4.017l-13.534-2.525
				c-0.054,0.563-0.068,8.05,0,8.659l13.534-2.516c1.984,0.522,2.778,2.472,1.655,4.011l-11.347,7.783
				c0.401,0.457,5.657,5.771,6.124,6.123l7.795-11.361c1.769-1.025,3.702-0.212,3.997,1.666l-2.483,13.57
				c0.603,0.056,8.05,0.034,8.628-0.032l-2.526-13.549c0.521-1.977,2.457-2.769,3.991-1.663l7.813,11.369
				c0.499-0.391,5.771-5.701,6.124-6.122l-11.365-7.791c-1.036-1.763-0.236-3.691,1.621-4.007l13.587,2.519
				c0.065-0.589,0.064-8.06,0-8.659l-13.534,2.524c-1.984-0.507-2.789-2.436-1.707-3.975l11.398-7.826
				c-0.36-0.46-5.636-5.728-6.126-6.125l-7.779,11.343c-1.765,1.052-3.703,0.254-4.024-1.603l2.563-13.574
				c-0.253-0.029-1.888-0.04-3.68-0.04C405.664,114.407,403.18,114.424,402.845,114.447"
            />
          </defs>
          <clipPath id="SVGIDA_260_">
            <use xlink:href="#SVGIDA_259_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_261_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(21.7004 -6.9361 6.9361 -35.5726 2420.0393 6199.1431)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#979796" />
            <stop offset="0.5272" style="stop-color:#8B8A8A" />
            <stop offset="1" style="stop-color:#979796" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_260_);fill:url(#SVGIDA_261_);"
            points="383.578,114.407 443.83,95.148 430.859,161.674
			370.606,180.933 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_262_"
              d="M402.88,114.341l2.538,13.698c-0.504,1.978-2.43,2.776-3.96,1.686l-7.952-11.493
				c-0.513,0.423-5.685,5.585-6.075,6.077l11.466,7.931c1.034,1.758,0.229,3.684-1.634,3.983l-13.723-2.506
				c-0.057,0.607-0.074,7.935,0,8.591l13.722-2.496c1.97,0.519,2.756,2.45,1.643,3.978l-11.467,7.931
				c0.434,0.491,5.573,5.694,6.075,6.075l7.941-11.481c1.756-1.019,3.673-0.21,3.966,1.652l-2.465,13.758
				c0.65,0.061,7.938,0.04,8.561-0.03l-2.508-13.738c0.519-1.959,2.438-2.745,3.96-1.649l7.959,11.489
				c0.537-0.421,5.695-5.622,6.074-6.075l-11.483-7.937c-1.026-1.748-0.233-3.661,1.608-3.976l13.774,2.5
				c0.069-0.635,0.068-7.945,0-8.591l-13.723,2.505c-1.969-0.503-2.766-2.416-1.692-3.941l11.518-7.974
				c-0.389-0.496-5.551-5.647-6.078-6.076l-7.927,11.462c-1.751,1.043-3.672,0.253-3.992-1.59l2.543-13.762
				c-0.272-0.031-1.891-0.044-3.66-0.044C405.682,114.297,403.24,114.316,402.88,114.341"
            />
          </defs>
          <clipPath id="SVGIDA_263_">
            <use xlink:href="#SVGIDA_262_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_264_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(21.9079 -8.0165 8.0165 -37.9408 2235.4375 6505.5283)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#9A9999" />
            <stop offset="0.5272" style="stop-color:#8D8C8C" />
            <stop offset="1" style="stop-color:#9A9999" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_263_);fill:url(#SVGIDA_264_);"
            points="383.466,114.297 445.824,91.479 430.97,161.784
			368.611,184.603 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_265_"
              d="M402.915,114.235l2.517,13.887c-0.499,1.961-2.408,2.753-3.926,1.672l-8.1-11.614
				c-0.549,0.453-5.608,5.502-6.027,6.03l11.586,8.076c1.026,1.743,0.228,3.655-1.62,3.951l-13.911-2.486
				c-0.061,0.65-0.078,7.82,0,8.523l13.91-2.478c1.952,0.514,2.733,2.431,1.628,3.944l-11.585,8.078
				c0.463,0.526,5.489,5.619,6.027,6.025l8.088-11.599c1.741-1.01,3.642-0.209,3.933,1.638l-2.446,13.945
				c0.695,0.064,7.826,0.046,8.493-0.03l-2.488-13.926c0.514-1.943,2.417-2.723,3.927-1.635l8.106,11.607
				c0.575-0.451,5.62-5.541,6.025-6.026l-11.603-8.084c-1.019-1.734-0.231-3.632,1.595-3.941l13.962,2.48
				c0.076-0.681,0.075-7.832,0-8.523l-13.91,2.485c-1.953-0.499-2.742-2.396-1.679-3.91l11.636-8.118
				c-0.417-0.532-5.464-5.57-6.028-6.029l-8.073,11.581c-1.736,1.036-3.644,0.252-3.96-1.575l2.522-13.949
				c-0.292-0.034-1.878-0.047-3.615-0.047C405.718,114.188,403.302,114.209,402.915,114.235"
            />
          </defs>
          <clipPath id="SVGIDA_266_">
            <use xlink:href="#SVGIDA_265_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_267_"
            cx="-156.999"
            cy="201"
            r="0.9995"
            gradientTransform="matrix(22.2081 -9.2927 9.2927 -40.7935 2026.0454 6878.5586)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#9C9C9C" />
            <stop offset="0.5272" style="stop-color:#8F8E8E" />
            <stop offset="1" style="stop-color:#9C9C9C" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_266_);fill:url(#SVGIDA_267_);"
            points="383.354,114.188 448.123,87.087 431.082,161.894
			366.313,188.995 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_268_"
              d="M402.95,114.128l2.497,14.075c-0.495,1.945-2.391,2.73-3.895,1.658l-8.246-11.732
				c-0.586,0.483-5.532,5.419-5.979,5.981l11.706,8.224c1.016,1.728,0.224,3.624-1.607,3.918l-14.1-2.467
				c-0.065,0.692-0.084,7.705,0,8.455l14.099-2.458c1.936,0.51,2.71,2.411,1.615,3.912l-11.706,8.225
				c0.494,0.562,5.406,5.543,5.979,5.978l8.234-11.72c1.728-1.001,3.613-0.207,3.901,1.625l-2.429,14.133
				c0.741,0.069,7.715,0.053,8.426-0.028l-2.469-14.115c0.51-1.927,2.396-2.699,3.896-1.622l8.251,11.729
				c0.614-0.48,5.545-5.461,5.979-5.979l-11.723-8.23c-1.01-1.721-0.229-3.602,1.582-3.91l14.149,2.462
				c0.081-0.727,0.079-7.718,0-8.455l-14.098,2.466c-1.937-0.495-2.721-2.376-1.666-3.877l11.755-8.265
				c-0.443-0.567-5.378-5.491-5.98-5.981l-8.22,11.701c-1.722,1.026-3.612,0.249-3.927-1.563l2.502-14.138
				c-0.311-0.036-1.875-0.05-3.587-0.05C405.743,114.078,403.363,114.1,402.95,114.128"
            />
          </defs>
          <clipPath id="SVGIDA_269_">
            <use xlink:href="#SVGIDA_268_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_270_"
            cx="-157.001"
            cy="200.999"
            r="1.0008"
            gradientTransform="matrix(22.7241 -10.8744 10.8744 -44.4728 1789.1698 7369.7817)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#9F9F9F" />
            <stop offset="0.5272" style="stop-color:#909090" />
            <stop offset="1" style="stop-color:#9F9F9F" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_269_);fill:url(#SVGIDA_270_);"
            points="383.243,114.078 450.818,81.74 431.193,162.004
			363.617,194.342 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_271_"
              d="M402.985,114.021l2.477,14.264c-0.491,1.929-2.37,2.708-3.862,1.645l-8.392-11.852
				c-0.623,0.513-5.456,5.335-5.93,5.933l11.823,8.37c1.01,1.715,0.224,3.594-1.593,3.886l-14.289-2.446
				c-0.068,0.736-0.089,7.589,0,8.387l14.288-2.439c1.919,0.506,2.688,2.391,1.602,3.88l-11.825,8.37
				c0.525,0.598,5.321,5.47,5.931,5.931l8.382-11.839c1.711-0.993,3.582-0.204,3.868,1.61l-2.41,14.321
				c0.787,0.073,7.604,0.057,8.358-0.029l-2.449-14.302c0.505-1.911,2.377-2.677,3.862-1.608l8.397,11.847
				c0.652-0.512,5.47-5.379,5.931-5.931l-11.842-8.378c-1.002-1.704-0.228-3.569,1.568-3.876l14.337,2.443
				c0.086-0.772,0.085-7.605,0-8.387l-14.285,2.445c-1.921-0.49-2.698-2.355-1.652-3.845l11.876-8.412
				c-0.474-0.603-5.293-5.411-5.935-5.932l-8.365,11.82c-1.708,1.018-3.582,0.246-3.896-1.55l2.483-14.326
				c-0.332-0.037-1.887-0.053-3.58-0.053C405.751,113.969,403.422,113.992,402.985,114.021"
            />
          </defs>
          <clipPath id="SVGIDA_272_">
            <use xlink:href="#SVGIDA_271_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_273_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(23.3928 -12.819 12.819 -49.0308 1503.2892 7980.645)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A2A2A1" />
            <stop offset="0.5272" style="stop-color:#929292" />
            <stop offset="1" style="stop-color:#A2A2A1" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_272_);fill:url(#SVGIDA_273_);"
            points="383.131,113.969 454.053,75.105 431.304,162.114
			360.383,200.978 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_274_"
              d="M403.021,113.915l2.455,14.452c-0.486,1.913-2.35,2.685-3.828,1.631l-8.539-11.971
				c-0.66,0.544-5.381,5.252-5.884,5.885l11.944,8.517c1,1.7,0.222,3.563-1.579,3.854l-14.477-2.429
				c-0.074,0.78-0.095,7.475,0,8.318l14.476-2.419c1.902,0.502,2.665,2.37,1.587,3.846l-11.943,8.519
				c0.556,0.632,5.236,5.393,5.882,5.882l8.528-11.958c1.698-0.985,3.553-0.203,3.835,1.598l-2.391,14.508
				c0.834,0.076,7.491,0.063,8.29-0.028l-2.429-14.49c0.501-1.894,2.356-2.655,3.83-1.595l8.544,11.966
				c0.69-0.54,5.394-5.298,5.882-5.882l-11.961-8.524c-0.992-1.69-0.227-3.54,1.556-3.843l14.525,2.422
				c0.09-0.815,0.089-7.488,0-8.318l-14.475,2.428c-1.904-0.487-2.676-2.336-1.638-3.813l11.993-8.558
				c-0.499-0.638-5.206-5.333-5.885-5.884l-8.514,11.939c-1.692,1.009-3.551,0.244-3.86-1.538l2.462-14.513
				c-0.353-0.04-1.888-0.056-3.559-0.056C405.771,113.859,403.483,113.884,403.021,113.915"
            />
          </defs>
          <clipPath id="SVGIDA_275_">
            <use xlink:href="#SVGIDA_274_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_276_"
            cx="-157.001"
            cy="201"
            r="1.0005"
            gradientTransform="matrix(24.2748 -15.2724 15.2724 -54.8197 1148.6201 8759.0137)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A5A5A4" />
            <stop offset="0.5272" style="stop-color:#949494" />
            <stop offset="1" style="stop-color:#A5A5A4" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_275_);fill:url(#SVGIDA_276_);"
            points="383.02,113.859 458.038,66.662 431.415,162.223
			356.397,209.42 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_277_"
              d="M403.056,113.809l2.437,14.641c-0.483,1.896-2.33,2.662-3.797,1.617l-8.686-12.091
				c-0.697,0.574-5.305,5.168-5.835,5.838l12.064,8.663c0.991,1.685,0.219,3.532-1.567,3.819l-14.665-2.408
				c-0.077,0.823-0.099,7.359,0,8.25l14.665-2.399c1.886,0.498,2.641,2.351,1.574,3.813l-12.064,8.664
				c0.587,0.668,5.153,5.319,5.834,5.834l8.676-12.078c1.684-0.975,3.521-0.2,3.803,1.585l-2.374,14.694
				c0.881,0.082,7.38,0.07,8.225-0.027l-2.411-14.678c0.497-1.878,2.338-2.631,3.799-1.581l8.689,12.085
				c0.73-0.569,5.319-5.217,5.834-5.834l-12.079-8.67c-0.985-1.677-0.224-3.51,1.542-3.812l14.712,2.403
				c0.096-0.86,0.095-7.374,0-8.25l-14.662,2.407c-1.888-0.481-2.651-2.316-1.625-3.78l12.114-8.704
				c-0.529-0.674-5.122-5.254-5.837-5.836l-8.661,12.061c-1.678,1-3.521,0.242-3.827-1.525l2.44-14.701
				c-0.369-0.042-1.877-0.059-3.516-0.059C405.804,113.75,403.545,113.776,403.056,113.809"
            />
          </defs>
          <clipPath id="SVGIDA_278_">
            <use xlink:href="#SVGIDA_277_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_279_"
            cx="-156.999"
            cy="201"
            r="0.9995"
            gradientTransform="matrix(25.4679 -18.4707 18.4707 -62.4092 693.0732 9782.3594)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A8A8A7" />
            <stop offset="0.5272" style="stop-color:#969695" />
            <stop offset="1" style="stop-color:#A8A8A7" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_278_);fill:url(#SVGIDA_279_);"
            points="382.908,113.75 463.122,55.574 431.526,162.333
			351.312,220.509 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_280_"
              d="M403.091,113.703l2.415,14.828c-0.479,1.88-2.309,2.64-3.764,1.603l-8.832-12.209
				c-0.733,0.604-5.229,5.085-5.785,5.788l12.181,8.811c0.984,1.672,0.22,3.503-1.552,3.787l-14.853-2.389
				c-0.081,0.867-0.105,7.244,0,8.182l14.853-2.381c1.87,0.494,2.619,2.331,1.561,3.781l-12.184,8.812
				c0.617,0.702,5.068,5.243,5.785,5.786l8.823-12.196c1.668-0.97,3.491-0.2,3.77,1.569l-2.354,14.884
				c0.927,0.085,7.268,0.073,8.155-0.027l-2.391-14.867c0.492-1.862,2.318-2.608,3.766-1.566l8.837,12.204
				c0.768-0.601,5.243-5.138,5.785-5.785l-12.198-8.818c-0.977-1.662-0.223-3.48,1.529-3.778l14.899,2.386
				c0.101-0.907,0.099-7.262,0-8.184l-14.85,2.388c-1.872-0.478-2.631-2.296-1.61-3.748l12.23-8.85
				c-0.555-0.709-5.034-5.175-5.788-5.787l-8.806,12.178c-1.666,0.991-3.493,0.24-3.797-1.512l2.421-14.889
				c-0.388-0.044-1.868-0.063-3.477-0.063C405.836,113.64,403.607,113.668,403.091,113.703"
            />
          </defs>
          <clipPath id="SVGIDA_281_">
            <use xlink:href="#SVGIDA_280_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_282_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(27.1413 -22.8219 22.8219 -72.785 81.196 11184.7646)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#ABAAAA" />
            <stop offset="0.5272" style="stop-color:#989897" />
            <stop offset="1" style="stop-color:#ABAAAA" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_281_);fill:url(#SVGIDA_282_);"
            points="382.796,113.64 469.907,40.392 431.638,162.443
			344.526,235.691 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_283_"
              d="M403.126,113.596l2.396,15.018c-0.476,1.863-2.29,2.615-3.732,1.589l-8.979-12.328
				c-0.77,0.635-5.151,5.002-5.737,5.74l12.302,8.957c0.975,1.656,0.216,3.472-1.539,3.755l-15.041-2.37
				c-0.086,0.91-0.111,7.13,0,8.115l15.041-2.363c1.854,0.489,2.596,2.31,1.547,3.749l-12.303,8.958
				c0.648,0.738,4.984,5.168,5.737,5.738l8.969-12.317c1.655-0.959,3.461-0.198,3.737,1.557l-2.336,15.07
				c0.974,0.09,7.155,0.081,8.088-0.024l-2.37-15.056c0.486-1.846,2.296-2.587,3.731-1.554l8.984,12.324
				c0.805-0.631,5.168-5.058,5.737-5.738l-12.318-8.965c-0.968-1.647-0.221-3.449,1.516-3.744l15.087,2.365
				c0.106-0.953,0.105-7.147,0-8.115l-15.037,2.369c-1.856-0.475-2.607-2.277-1.598-3.715l12.352-8.997
				c-0.583-0.745-4.949-5.097-5.74-5.74l-8.953,12.299c-1.65,0.983-3.462,0.237-3.763-1.499l2.399-15.077
				c-0.408-0.047-1.876-0.064-3.466-0.064C405.848,113.531,403.666,113.559,403.126,113.596"
            />
          </defs>
          <clipPath id="SVGIDA_284_">
            <use xlink:href="#SVGIDA_283_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_285_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(29.6243 -29.1075 29.1075 -87.8392 -792.3778 13223.8125)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#ADADAD" />
            <stop offset="0.5272" style="stop-color:#9A9A99" />
            <stop offset="1" style="stop-color:#ADADAD" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_284_);fill:url(#SVGIDA_285_);"
            points="382.684,113.531 479.523,18.381 431.749,162.553
			334.909,257.703 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_286_"
              d="M403.161,113.489l2.375,15.206c-0.471,1.849-2.271,2.594-3.699,1.576l-9.125-12.448
				c-0.807,0.665-5.076,4.917-5.69,5.691l12.422,9.104c0.967,1.642,0.214,3.441-1.526,3.721l-15.228-2.35
				c-0.091,0.954-0.116,7.015,0,8.046l15.228-2.342c1.838,0.483,2.574,2.289,1.533,3.715l-12.422,9.104
				c0.68,0.773,4.9,5.094,5.688,5.69l9.116-12.437c1.64-0.95,3.431-0.195,3.706,1.543l-2.319,15.258
				c1.021,0.095,7.045,0.088,8.021-0.024l-2.352-15.243c0.484-1.83,2.276-2.563,3.699-1.54l9.131,12.443
				c0.845-0.66,5.093-4.977,5.689-5.69l-12.438-9.109c-0.96-1.635-0.218-3.42,1.503-3.714l15.274,2.346
				c0.111-0.997,0.109-7.032,0-8.046l-15.226,2.349c-1.84-0.469-2.586-2.256-1.582-3.682l12.469-9.144
				c-0.612-0.78-4.863-5.018-5.692-5.691l-9.1,12.418c-1.635,0.974-3.433,0.235-3.73-1.486l2.38-15.265
				c-0.428-0.048-1.873-0.067-3.438-0.067C405.872,113.422,403.729,113.451,403.161,113.489"
            />
          </defs>
          <clipPath id="SVGIDA_287_">
            <use xlink:href="#SVGIDA_286_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_288_"
            cx="-156.998"
            cy="201"
            r="0.999"
            gradientTransform="matrix(33.7052 -39.1085 39.1085 -111.9221 -2161.874 16494.2852)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B0B0B0" />
            <stop offset="0.5272" style="stop-color:#9C9C9B" />
            <stop offset="1" style="stop-color:#B0B0B0" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_287_);fill:url(#SVGIDA_288_);"
            points="382.573,113.422 494.409,-16.343 431.86,162.663
			320.023,292.428 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_289_"
              d="M403.196,113.383l2.354,15.396c-0.466,1.831-2.25,2.569-3.665,1.56l-9.271-12.565
				c-0.844,0.694-5.001,4.834-5.642,5.643l12.539,9.252c0.959,1.627,0.213,3.411-1.512,3.689l-15.418-2.331
				c-0.093,0.996-0.12,6.898,0,7.977l15.417-2.323c1.823,0.48,2.552,2.27,1.521,3.684l-12.542,9.252
				c0.711,0.808,4.816,5.017,5.642,5.641l9.263-12.556c1.625-0.942,3.4-0.194,3.672,1.529l-2.3,15.445
				c1.066,0.1,6.933,0.093,7.954-0.022l-2.332-15.432c0.48-1.814,2.257-2.542,3.667-1.527l9.277,12.563
				c0.883-0.689,5.017-4.896,5.641-5.641l-12.557-9.258c-0.95-1.619-0.216-3.391,1.489-3.681l15.464,2.326
				c0.115-1.043,0.113-6.918,0-7.977l-15.415,2.33c-1.823-0.467-2.562-2.238-1.568-3.652l12.588-9.288
				c-0.639-0.816-4.777-4.94-5.644-5.643l-9.247,12.536c-1.621,0.966-3.401,0.234-3.697-1.473l2.36-15.453
				c-0.448-0.051-1.874-0.071-3.415-0.071C405.892,113.312,403.788,113.343,403.196,113.383"
            />
          </defs>
          <clipPath id="SVGIDA_290_">
            <use xlink:href="#SVGIDA_289_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_291_"
            cx="-157.0015"
            cy="201"
            r="1.0007"
            gradientTransform="matrix(41.1426 -57.1839 57.1839 -155.5104 -4627.3594 22417.748)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B3B3B2" />
            <stop offset="0.5272" style="stop-color:#9E9D9D" />
            <stop offset="1" style="stop-color:#B3B3B2" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_290_);fill:url(#SVGIDA_291_);"
            points="382.461,113.313 520.929,-79.144 431.972,162.773
			293.504,355.229 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_292_"
              d="M403.232,113.277l2.334,15.583c-0.463,1.814-2.23,2.548-3.636,1.547l-9.418-12.687
				c-0.879,0.727-4.923,4.751-5.593,5.596l12.66,9.396c0.949,1.614,0.21,3.383-1.499,3.657l-15.606-2.312
				c-0.098,1.04-0.126,6.784,0,7.91l15.605-2.305c1.807,0.476,2.529,2.25,1.507,3.65l-12.661,9.398
				c0.741,0.844,4.732,4.942,5.592,5.594l9.41-12.675c1.611-0.935,3.371-0.192,3.641,1.517l-2.282,15.632
				c1.112,0.103,6.821,0.099,7.887-0.023l-2.312-15.619c0.475-1.799,2.235-2.519,3.634-1.513l9.423,12.682
				c0.921-0.721,4.943-4.814,5.592-5.594l-12.675-9.404c-0.943-1.604-0.214-3.359,1.476-3.647l15.651,2.308
				c0.12-1.089,0.119-6.804,0-7.91l-15.603,2.311c-1.808-0.461-2.539-2.217-1.555-3.618l12.707-9.435
				c-0.667-0.853-4.691-4.86-5.595-5.597l-9.394,12.657c-1.607,0.957-3.371,0.231-3.664-1.459l2.339-15.641
				c-0.468-0.055-1.875-0.075-3.393-0.075C405.913,113.202,403.849,113.235,403.232,113.277"
            />
          </defs>
          <clipPath id="SVGIDA_293_">
            <use xlink:href="#SVGIDA_292_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_294_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(58.6545 -99.586 99.586 -257.8265 -10400.7734 36326.2031)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B6B5B5" />
            <stop offset="0.5272" style="stop-color:#A09F9F" />
            <stop offset="1" style="stop-color:#B6B5B5" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_293_);fill:url(#SVGIDA_294_);"
            points="382.349,113.202 582.585,-226.768 432.082,162.883
			231.846,502.853 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_295_"
              d="M403.266,113.17l2.314,15.771c-0.458,1.8-2.209,2.525-3.602,1.533l-9.564-12.804
				c-0.916,0.755-4.847,4.666-5.545,5.546l12.779,9.544c0.941,1.6,0.209,3.353-1.485,3.623l-15.794-2.291
				c-0.103,1.084-0.131,6.669,0,7.842l15.793-2.284c1.79,0.471,2.507,2.229,1.493,3.616l-12.78,9.547
				c0.771,0.878,4.648,4.865,5.544,5.544l9.557-12.793c1.597-0.928,3.341-0.191,3.607,1.503l-2.264,15.817
				c1.159,0.108,6.71,0.105,7.818-0.021l-2.292-15.807c0.472-1.781,2.217-2.498,3.603-1.501l9.568,12.803
				c0.96-0.751,4.867-4.735,5.546-5.545l-12.796-9.553c-0.934-1.59-0.212-3.33,1.464-3.614l15.838,2.288
				c0.126-1.134,0.124-6.689,0-7.842l-15.791,2.291c-1.79-0.458-2.517-2.197-1.54-3.586l12.825-9.582
				c-0.694-0.886-4.605-4.781-5.547-5.546l-9.541,12.775c-1.592,0.948-3.34,0.229-3.631-1.446l2.319-15.829
				c-0.487-0.056-1.872-0.077-3.364-0.077C405.938,113.093,403.909,113.126,403.266,113.17"
            />
          </defs>
          <clipPath id="SVGIDA_296_">
            <use xlink:href="#SVGIDA_295_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_297_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(148.7076 -317.1234 317.1234 -782.9544 -39987.6016 107723)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B8B8B8" />
            <stop offset="0.5272" style="stop-color:#A1A1A1" />
            <stop offset="1" style="stop-color:#B8B8B8" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_296_);fill:url(#SVGIDA_297_);"
            points="382.238,113.093 897.219,-985.118 432.194,162.993
			-82.787,1261.205 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_298_"
              d="M403.301,113.064l2.294,15.959c-0.454,1.782-2.189,2.502-3.568,1.521l-9.711-12.925
				c-0.953,0.786-4.772,4.584-5.497,5.499l12.898,9.69c0.933,1.584,0.207,3.321-1.472,3.592l-15.983-2.273
				c-0.104,1.127-0.136,6.555,0,7.774l15.982-2.268c1.773,0.468,2.482,2.21,1.479,3.586l-12.9,9.692
				c0.803,0.914,4.564,4.791,5.497,5.496l9.703-12.913c1.582-0.918,3.31-0.189,3.573,1.49l-2.243,16.006
				c1.204,0.111,6.598,0.11,7.75-0.021l-2.272-15.995c0.467-1.766,2.197-2.474,3.569-1.486l9.716,12.92
				c0.999-0.78,4.792-4.653,5.497-5.496l-12.914-9.698c-0.926-1.576-0.211-3.3,1.449-3.582l16.025,2.27
				c0.132-1.18,0.129-6.576,0-7.774l-15.978,2.272c-1.775-0.454-2.493-2.179-1.527-3.554l12.945-9.729
				c-0.724-0.922-4.521-4.702-5.499-5.498l-9.688,12.895c-1.578,0.939-3.311,0.229-3.599-1.433l2.299-16.017
				c-0.506-0.059-1.866-0.081-3.329-0.081C405.965,112.983,403.971,113.019,403.301,113.064"
            />
          </defs>
          <clipPath id="SVGIDA_299_">
            <use xlink:href="#SVGIDA_298_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_300_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(111.1583 -310.4069 310.4069 -731.972 -44532.625 98530.6328)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#BBBBBA" />
            <stop offset="0.5272" style="stop-color:#A3A3A3" />
            <stop offset="1" style="stop-color:#BBBBBA" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_299_);fill:url(#SVGIDA_300_);"
            points="432.306,163.104 820.108,-919.825 382.126,112.983
			-5.676,1195.911 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_301_"
              d="M403.337,112.958l2.273,16.147c-0.45,1.767-2.17,2.479-3.536,1.506l-9.858-13.043
				c-0.99,0.815-4.694,4.5-5.449,5.45l13.019,9.838c0.924,1.569,0.205,3.291-1.458,3.558l-16.171-2.253
				c-0.11,1.17-0.143,6.439,0,7.705l16.17-2.246c1.758,0.463,2.461,2.188,1.466,3.552l-13.021,9.84
				c0.835,0.949,4.48,4.715,5.448,5.448l9.851-13.033c1.567-0.909,3.28-0.187,3.542,1.477l-2.227,16.192
				c1.251,0.117,6.485,0.117,7.685-0.019l-2.254-16.185c0.463-1.75,2.177-2.451,3.537-1.472l9.862,13.039
				c1.036-0.81,4.716-4.573,5.447-5.448l-13.033-9.845c-0.917-1.562-0.208-3.27,1.438-3.55l16.213,2.25
				c0.136-1.226,0.134-6.462,0-7.706l-16.166,2.252c-1.759-0.449-2.472-2.157-1.514-3.521l13.063-9.875
				c-0.749-0.958-4.433-4.624-5.45-5.449l-9.834,13.014c-1.563,0.932-3.28,0.225-3.564-1.42l2.277-16.204
				c-0.525-0.061-1.871-0.084-3.312-0.084C405.981,112.874,404.031,112.911,403.337,112.958"
            />
          </defs>
          <clipPath id="SVGIDA_302_">
            <use xlink:href="#SVGIDA_301_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_303_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(28.3249 -110.8638 110.8638 -250.0526 -17429.4004 32992.957)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#BDBDBD" />
            <stop offset="0.5272" style="stop-color:#A5A5A5" />
            <stop offset="1" style="stop-color:#BDBDBD" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_302_);fill:url(#SVGIDA_303_);"
            points="432.416,163.213 531.313,-223.867 382.014,112.874
			283.118,499.954 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_304_"
              d="M403.372,112.851l2.252,16.336c-0.445,1.752-2.15,2.457-3.504,1.492l-10.004-13.161
				c-1.026,0.847-4.619,4.416-5.4,5.402l13.138,9.984c0.915,1.555,0.203,3.26-1.445,3.525l-16.358-2.233
				c-0.115,1.213-0.146,6.323,0,7.637l16.358-2.227c1.741,0.459,2.438,2.169,1.453,3.519l-13.141,9.986
				c0.865,0.983,4.396,4.64,5.4,5.399l9.997-13.151c1.553-0.901,3.25-0.187,3.509,1.462l-2.209,16.381
				c1.298,0.12,6.375,0.122,7.618-0.02l-2.235-16.372c0.459-1.732,2.157-2.429,3.505-1.459l10.01,13.159
				c1.073-0.841,4.641-4.492,5.399-5.399l-13.152-9.992c-0.909-1.547-0.207-3.239,1.423-3.518l16.401,2.231
				c0.142-1.27,0.139-6.348,0-7.637l-16.354,2.232c-1.743-0.445-2.448-2.139-1.499-3.489l13.183-10.021
				c-0.778-0.993-4.348-4.544-5.403-5.402l-9.979,13.135c-1.549,0.922-3.25,0.223-3.533-1.407l2.257-16.394
				c-0.545-0.062-1.869-0.087-3.287-0.087C406.002,112.764,404.092,112.802,403.372,112.851"
            />
          </defs>
          <clipPath id="SVGIDA_305_">
            <use xlink:href="#SVGIDA_304_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_306_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(11.2145 -69.999 69.999 -151.2126 -11901.8838 19541.8418)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C0C0C0" />
            <stop offset="0.5272" style="stop-color:#A7A7A7" />
            <stop offset="1" style="stop-color:#C0C0C0" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_305_);fill:url(#SVGIDA_306_);"
            points="432.528,163.324 471.709,-81.235 381.903,112.764
			342.723,357.323 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_307_"
              d="M403.407,112.744l2.231,16.524c-0.44,1.734-2.13,2.436-3.471,1.479l-10.151-13.282
				c-1.063,0.877-4.543,4.334-5.352,5.355l13.257,10.13c0.907,1.542,0.2,3.229-1.432,3.493l-16.547-2.214
				c-0.118,1.256-0.153,6.209,0,7.568l16.547-2.209c1.724,0.455,2.415,2.15,1.438,3.487l-13.26,10.133
				c0.897,1.019,4.313,4.566,5.353,5.352l10.144-13.271c1.539-0.893,3.22-0.185,3.476,1.448l-2.188,16.568
				c1.344,0.124,6.263,0.128,7.55-0.019l-2.215-16.561c0.453-1.717,2.136-2.405,3.472-1.444l10.155,13.277
				c1.113-0.869,4.564-4.411,5.351-5.352l-13.271-10.138c-0.9-1.533-0.205-3.21,1.41-3.484l16.589,2.211
				c0.146-1.314,0.144-6.232,0-7.568l-16.543,2.213c-1.727-0.441-2.426-2.118-1.485-3.456l13.301-10.168
				c-0.805-1.028-4.261-4.466-5.353-5.354l-10.128,13.253c-1.534,0.914-3.219,0.222-3.5-1.394l2.236-16.581
				c-0.563-0.064-1.861-0.089-3.248-0.089C406.033,112.655,404.154,112.694,403.407,112.744"
            />
          </defs>
          <clipPath id="SVGIDA_308_">
            <use xlink:href="#SVGIDA_307_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_309_"
            cx="-156.9985"
            cy="201"
            r="0.9993"
            gradientTransform="matrix(3.7485 -52.4275 52.4275 -108.6035 -9542.2061 13736.2344)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C3C2C2" />
            <stop offset="0.5272" style="stop-color:#A9A9A9" />
            <stop offset="1" style="stop-color:#C3C2C2" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_308_);fill:url(#SVGIDA_309_);"
            points="432.639,163.436 445.741,-19.82 381.79,112.655
			368.688,295.911 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_310_"
              d="M403.443,112.638l2.211,16.714c-0.438,1.718-2.11,2.41-3.438,1.465l-10.298-13.401
				c-1.1,0.907-4.467,4.25-5.304,5.307l13.376,10.277c0.897,1.526,0.199,3.199-1.418,3.459l-16.736-2.194
				c-0.121,1.301-0.157,6.095,0,7.501l16.736-2.188c1.708,0.45,2.392,2.128,1.425,3.454l-13.378,10.279
				c0.926,1.055,4.227,4.489,5.304,5.305l10.289-13.392c1.525-0.885,3.19-0.183,3.445,1.435l-2.172,16.756
				c1.39,0.129,6.149,0.134,7.481-0.019l-2.195-16.746c0.449-1.702,2.116-2.385,3.439-1.434l10.302,13.399
				c1.152-0.901,4.491-4.331,5.304-5.305l-13.392-10.284c-0.892-1.52-0.202-3.181,1.397-3.453l16.776,2.192
				c0.151-1.359,0.148-6.118,0-7.501l-16.73,2.193c-1.71-0.436-2.402-2.098-1.472-3.423l13.421-10.314
				c-0.833-1.063-4.176-4.387-5.306-5.305l-10.274,13.372c-1.521,0.906-3.189,0.22-3.466-1.38l2.216-16.77
				c-0.583-0.066-1.862-0.093-3.227-0.093C406.054,112.545,404.215,112.586,403.443,112.638"
            />
          </defs>
          <clipPath id="SVGIDA_311_">
            <use xlink:href="#SVGIDA_310_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_312_"
            cx="-156.999"
            cy="201"
            r="0.9995"
            gradientTransform="matrix(-0.4827 -42.7191 42.7191 -84.9556 -8255.1172 10507.2109)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C5C5C5" />
            <stop offset="0.5272" style="stop-color:#ABABAA" />
            <stop offset="1" style="stop-color:#C5C5C5" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_311_);fill:url(#SVGIDA_312_);"
            points="433.313,162.426 431.628,13.212 381.115,113.666
			382.802,262.88 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_313_"
              d="M403.479,112.532l2.19,16.901c-0.434,1.701-2.091,2.389-3.406,1.45l-10.443-13.519
				c-1.138,0.936-4.392,4.166-5.257,5.257l13.496,10.424c0.891,1.512,0.197,3.17-1.404,3.428l-16.924-2.176
				c-0.127,1.344-0.163,5.979,0,7.434l16.924-2.171c1.691,0.446,2.369,2.108,1.412,3.422l-13.498,10.427
				c0.956,1.089,4.143,4.414,5.255,5.256l10.437-13.511c1.509-0.876,3.159-0.181,3.411,1.421l-2.153,16.943
				c1.438,0.135,6.039,0.141,7.415-0.017l-2.176-16.936c0.446-1.687,2.097-2.361,3.407-1.418l10.448,13.517
				c1.189-0.931,4.416-4.251,5.256-5.256l-13.51-10.433c-0.885-1.504-0.202-3.148,1.383-3.419l16.964,2.174
				c0.156-1.406,0.154-6.005,0-7.434l-16.919,2.175c-1.694-0.433-2.38-2.078-1.457-3.392l13.539-10.46
				c-0.861-1.099-4.089-4.308-5.257-5.257l-10.42,13.492c-1.508,0.896-3.16,0.217-3.437-1.368l2.197-16.956
				c-0.604-0.069-1.862-0.097-3.202-0.097C406.075,112.436,404.275,112.478,403.479,112.532"
            />
          </defs>
          <clipPath id="SVGIDA_314_">
            <use xlink:href="#SVGIDA_313_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_315_"
            cx="-157.001"
            cy="201"
            r="1.0005"
            gradientTransform="matrix(-3.2536 -36.658 36.658 -70.0623 -7471.8364 8465.2129)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C8C8C7" />
            <stop offset="0.5272" style="stop-color:#ADADAC" />
            <stop offset="1" style="stop-color:#C8C8C7" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_314_);fill:url(#SVGIDA_315_);"
            points="436.748,156.23 425.422,28.619 377.68,119.865
			389.006,247.477 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_316_"
              d="M403.513,112.426l2.171,17.09c-0.43,1.686-2.069,2.365-3.374,1.437l-10.59-13.639
				c-1.173,0.967-4.314,4.084-5.208,5.21l13.615,10.57c0.881,1.498,0.195,3.14-1.391,3.395l-17.112-2.155
				c-0.131,1.386-0.168,5.864,0,7.364l17.112-2.151c1.675,0.442,2.347,2.088,1.396,3.389l-13.617,10.574
				c0.988,1.124,4.061,4.339,5.208,5.207l10.583-13.63c1.496-0.868,3.129-0.178,3.378,1.407l-2.134,17.132
				c1.484,0.137,5.928,0.146,7.349-0.016l-2.156-17.125c0.44-1.669,2.076-2.338,3.374-1.405l10.594,13.637
				c1.229-0.961,4.34-4.17,5.207-5.207l-13.629-10.58c-0.875-1.488-0.199-3.118,1.37-3.385l17.15,2.153
				c0.162-1.452,0.16-5.891,0-7.364l-17.105,2.154c-1.677-0.429-2.357-2.059-1.443-3.359l13.658-10.605
				c-0.889-1.136-4.003-4.229-5.209-5.209l-10.567,13.61c-1.491,0.888-3.129,0.215-3.401-1.354l2.176-17.145
				c-0.624-0.072-1.866-0.1-3.183-0.1C406.093,112.326,404.335,112.37,403.513,112.426"
            />
          </defs>
          <clipPath id="SVGIDA_317_">
            <use xlink:href="#SVGIDA_316_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_318_"
            cx="-157.002"
            cy="201"
            r="1.001"
            gradientTransform="matrix(-5.2462 -32.5104 32.5104 -59.7746 -6951.0254 7048.561)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CACACA" />
            <stop offset="0.5272" style="stop-color:#AFAFAE" />
            <stop offset="1" style="stop-color:#CACACA" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_317_);fill:url(#SVGIDA_318_);"
            points="439.374,152 421.185,39.28 375.054,124.098
			393.243,236.817 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_319_"
              d="M403.548,112.318l2.15,17.279c-0.425,1.668-2.05,2.343-3.341,1.422l-10.737-13.757
				c-1.209,0.996-4.239,3.999-5.159,5.161l13.734,10.717c0.873,1.483,0.193,3.109-1.377,3.361l-17.302-2.135
				c-0.134,1.43-0.173,5.749,0,7.296l17.301-2.131c1.659,0.437,2.324,2.067,1.385,3.355l-13.737,10.721
				c1.02,1.158,3.976,4.264,5.159,5.159l10.729-13.75c1.482-0.858,3.1-0.177,3.348,1.395l-2.117,17.318
				c1.53,0.142,5.816,0.151,7.281-0.016l-2.137-17.313c0.437-1.652,2.056-2.315,3.341-1.392l10.74,13.757
				c1.268-0.99,4.266-4.09,5.159-5.159l-13.748-10.727c-0.867-1.475-0.196-3.089,1.357-3.354l17.339,2.135
				c0.167-1.497,0.164-5.776,0-7.296l-17.295,2.135c-1.661-0.424-2.334-2.038-1.429-3.327l13.776-10.752
				c-0.917-1.17-3.917-4.149-5.161-5.161l-10.714,13.731c-1.478,0.88-3.099,0.213-3.368-1.342l2.155-17.333
				c-0.642-0.073-1.857-0.102-3.146-0.102C406.123,112.217,404.396,112.261,403.548,112.318"
            />
          </defs>
          <clipPath id="SVGIDA_320_">
            <use xlink:href="#SVGIDA_319_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_321_"
            cx="-157.002"
            cy="200.999"
            r="1.0012"
            gradientTransform="matrix(-6.7731 -29.5014 29.5014 -52.2298 -6585.9385 6004.4546)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CDCDCD" />
            <stop offset="0.5272" style="stop-color:#B1B0B0" />
            <stop offset="1" style="stop-color:#CDCDCD" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_320_);fill:url(#SVGIDA_321_);"
            points="441.518,148.951 418.131,47.088 372.91,127.147
			396.297,229.011 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_322_"
              d="M403.583,112.212l2.13,17.468c-0.421,1.652-2.03,2.319-3.308,1.408l-10.884-13.876
				c-1.245,1.027-4.162,3.916-5.111,5.113l13.854,10.864c0.864,1.468,0.192,3.078-1.364,3.328l-17.488-2.116
				c-0.14,1.473-0.179,5.634,0,7.228l17.487-2.113c1.645,0.435,2.303,2.05,1.371,3.324l-13.855,10.868
				c1.049,1.194,3.891,4.187,5.111,5.111l10.876-13.869c1.467-0.852,3.068-0.176,3.313,1.38l-2.098,17.505
				c1.576,0.147,5.704,0.159,7.214-0.014l-2.118-17.5c0.434-1.638,2.037-2.294,3.309-1.378l10.889,13.876
				c1.305-1.022,4.188-4.011,5.111-5.111l-13.868-10.873c-0.858-1.461-0.196-3.059,1.343-3.321l17.527,2.115
				c0.172-1.542,0.169-5.662,0-7.228l-17.483,2.115c-1.646-0.421-2.312-2.019-1.415-3.294l13.896-10.899
				c-0.944-1.205-3.832-4.071-5.112-5.112l-10.862,13.85c-1.462,0.871-3.068,0.212-3.336-1.327l2.136-17.521
				c-0.662-0.075-1.858-0.104-3.123-0.104C406.143,112.107,404.458,112.153,403.583,112.212"
            />
          </defs>
          <clipPath id="SVGIDA_323_">
            <use xlink:href="#SVGIDA_322_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_324_"
            cx="-157.001"
            cy="201"
            r="1.0005"
            gradientTransform="matrix(-7.9998 -27.2301 27.2301 -46.4604 -6322.0029 5201.4429)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D0CFCF" />
            <stop offset="0.5272" style="stop-color:#B2B2B2" />
            <stop offset="1" style="stop-color:#D0CFCF" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_323_);fill:url(#SVGIDA_324_);"
            points="443.349,146.669 415.845,53.05 371.078,129.432
			398.582,223.051 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_325_"
              d="M403.618,112.106l2.11,17.654c-0.418,1.638-2.011,2.297-3.276,1.396l-11.03-13.996
				c-1.282,1.058-4.087,3.833-5.063,5.064l13.973,11.012c0.855,1.455,0.189,3.049-1.351,3.296l-17.678-2.098
				c-0.143,1.518-0.183,5.52,0,7.161l17.677-2.094c1.628,0.429,2.279,2.028,1.358,3.29l-13.977,11.015
				c1.081,1.229,3.808,4.113,5.063,5.063l11.024-13.988c1.453-0.842,3.038-0.173,3.281,1.368l-2.079,17.693
				c1.62,0.149,5.591,0.163,7.146-0.015l-2.098-17.688c0.428-1.621,2.016-2.271,3.275-1.365l11.034,13.995
				c1.343-1.051,4.114-3.928,5.063-5.063l-13.987-11.02c-0.849-1.446-0.192-3.028,1.331-3.288l17.714,2.097
				c0.177-1.588,0.175-5.548,0-7.161l-17.671,2.097c-1.629-0.416-2.288-1.998-1.401-3.262l14.016-11.046
				c-0.974-1.239-3.746-3.991-5.064-5.063L412,131.129c-1.448,0.863-3.039,0.209-3.303-1.314l2.115-17.708
				c-0.683-0.078-1.858-0.108-3.099-0.108C406.165,111.998,404.518,112.045,403.618,112.106"
            />
          </defs>
          <clipPath id="SVGIDA_326_">
            <use xlink:href="#SVGIDA_325_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_327_"
            cx="-157.001"
            cy="201"
            r="1.0005"
            gradientTransform="matrix(-9.0224 -25.4642 25.4642 -41.906 -6127.6089 4563.2344)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D2D2D2" />
            <stop offset="0.5272" style="stop-color:#B4B4B4" />
            <stop offset="1" style="stop-color:#D2D2D2" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_326_);fill:url(#SVGIDA_327_);"
            points="444.969,144.913 414.085,57.75 369.459,131.19
			400.342,218.354 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_328_"
              d="M403.653,112l2.09,17.843c-0.413,1.62-1.991,2.275-3.244,1.382l-11.176-14.114
				c-1.319,1.087-4.011,3.749-5.016,5.016l14.094,11.158c0.847,1.439,0.188,3.018-1.339,3.263l-17.864-2.078
				c-0.147,1.561-0.19,5.404,0,7.092l17.864-2.072c1.611,0.425,2.257,2.007,1.345,3.257l-14.097,11.161
				c1.112,1.265,3.724,4.038,5.016,5.015l11.171-14.107c1.437-0.833,3.007-0.173,3.248,1.354l-2.063,17.88
				c1.669,0.155,5.481,0.169,7.079-0.013l-2.079-17.876c0.426-1.605,1.997-2.249,3.245-1.352l11.181,14.114
				c1.382-1.081,4.038-3.848,5.014-5.015l-14.106-11.166c-0.841-1.434-0.19-2.998,1.317-3.256l17.902,2.076
				c0.182-1.632,0.179-5.433,0-7.092l-17.858,2.077c-1.613-0.412-2.267-1.979-1.388-3.229l14.133-11.192
				c-1-1.276-3.659-3.913-5.015-5.016l-11.155,14.089c-1.435,0.854-3.008,0.207-3.271-1.304L410.777,112
				c-0.7-0.08-1.854-0.112-3.067-0.112C406.191,111.888,404.58,111.937,403.653,112"
            />
          </defs>
          <clipPath id="SVGIDA_329_">
            <use xlink:href="#SVGIDA_328_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_330_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(-9.9004 -24.0599 24.0599 -38.2195 -5983.189 4042.7405)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D5D5D5" />
            <stop offset="0.5272" style="stop-color:#B6B6B6" />
            <stop offset="1" style="stop-color:#D5D5D5" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_329_);fill:url(#SVGIDA_330_);"
            points="446.438,143.532 412.701,61.544 367.987,132.572
			401.725,214.561 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_331_"
              d="M403.688,111.893l2.069,18.032c-0.408,1.605-1.97,2.252-3.21,1.368l-11.324-14.234
				c-1.354,1.118-3.934,3.666-4.966,4.969l14.212,11.305c0.839,1.424,0.186,2.987-1.325,3.229l-18.053-2.059
				c-0.149,1.604-0.194,5.29,0,7.024l18.053-2.056c1.597,0.421,2.234,1.988,1.331,3.227l-14.215,11.308
				c1.144,1.299,3.64,3.962,4.967,4.966l11.316-14.227c1.424-0.826,2.979-0.171,3.216,1.34l-2.043,18.067
				c1.716,0.158,5.37,0.176,7.013-0.012l-2.06-18.064c0.42-1.589,1.976-2.227,3.211-1.337l11.327,14.232
				c1.42-1.11,3.964-3.767,4.966-4.966l-14.225-11.313c-0.833-1.418-0.19-2.97,1.304-3.224l18.089,2.058
				c0.188-1.678,0.186-5.319,0-7.024l-18.046,2.058c-1.597-0.407-2.244-1.959-1.374-3.196l14.253-11.338
				c-1.027-1.313-3.574-3.835-4.968-4.968l-11.301,14.207c-1.42,0.847-2.979,0.205-3.238-1.289l2.075-18.084
				c-0.721-0.082-1.854-0.113-3.043-0.113C406.212,111.779,404.64,111.829,403.688,111.893"
            />
          </defs>
          <clipPath id="SVGIDA_332_">
            <use xlink:href="#SVGIDA_331_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_333_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(-10.7344 -23.0565 23.0565 -35.3787 -5912.4497 3629.2476)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D7D7D7" />
            <stop offset="0.5272" style="stop-color:#B8B8B7" />
            <stop offset="1" style="stop-color:#D7D7D7" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_332_);fill:url(#SVGIDA_333_);"
            points="447.8,142.431 411.598,64.672 366.627,133.676
			402.829,211.436 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_334_"
              d="M403.723,111.787l2.049,18.221c-0.403,1.588-1.95,2.229-3.178,1.354l-11.47-14.354
				c-1.392,1.149-3.858,3.582-4.918,4.92l14.331,11.451c0.831,1.412,0.184,2.958-1.312,3.198l-18.24-2.038
				c-0.155,1.646-0.2,5.174,0,6.955l18.24-2.035c1.58,0.416,2.212,1.967,1.318,3.192l-14.336,11.455
				c1.174,1.335,3.556,3.887,4.919,4.918l11.464-14.347c1.409-0.816,2.948-0.168,3.184,1.326l-2.024,18.255
				c1.761,0.163,5.256,0.182,6.944-0.01l-2.04-18.253c0.415-1.574,1.956-2.204,3.179-1.324l11.473,14.353
				c1.458-1.141,3.889-3.687,4.918-4.918l-14.344-11.461c-0.825-1.402-0.188-2.938,1.29-3.189l18.278,2.039
				c0.191-1.725,0.188-5.206,0-6.956l-18.235,2.037c-1.581-0.403-2.221-1.938-1.359-3.164l14.37-11.484
				c-1.055-1.347-3.486-3.756-4.919-4.92l-11.446,14.328c-1.406,0.837-2.949,0.202-3.205-1.277l2.053-18.271
				c-0.74-0.085-1.854-0.118-3.019-0.118C406.233,111.669,404.701,111.721,403.723,111.787"
            />
          </defs>
          <clipPath id="SVGIDA_335_">
            <use xlink:href="#SVGIDA_334_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_336_"
            cx="-157.001"
            cy="201"
            r="1.0004"
            gradientTransform="matrix(-11.5036 -22.2592 22.2592 -33.0149 -5872.9512 3279.3008)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#DADADA" />
            <stop offset="0.5272" style="stop-color:#BAB9B9" />
            <stop offset="1" style="stop-color:#DADADA" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_335_);fill:url(#SVGIDA_336_);"
            points="449.078,141.541 410.705,67.291 365.347,134.566
			403.72,208.817 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_337_"
              d="M403.758,111.68l2.029,18.41c-0.4,1.571-1.93,2.205-3.146,1.339l-11.616-14.472
				c-1.43,1.178-3.782,3.498-4.87,4.871l14.451,11.598c0.82,1.397,0.182,2.928-1.299,3.165l-18.429-2.019
				c-0.16,1.689-0.206,5.059,0,6.888l18.429-2.017c1.563,0.412,2.189,1.946,1.305,3.159l-14.455,11.602
				c1.205,1.37,3.472,3.812,4.871,4.87l11.609-14.465c1.396-0.81,2.918-0.167,3.151,1.312l-2.006,18.443
				c1.808,0.167,5.145,0.187,6.877-0.011l-2.021-18.44c0.411-1.557,1.938-2.181,3.147-1.312l11.619,14.473
				c1.497-1.17,3.813-3.605,4.87-4.87l-14.465-11.606c-0.815-1.39-0.185-2.908,1.278-3.157l18.465,2.02
				c0.197-1.769,0.194-5.092,0-6.888l-18.423,2.019c-1.563-0.399-2.198-1.92-1.346-3.132l14.49-11.632
				c-1.083-1.382-3.402-3.677-4.87-4.871l-11.596,14.447c-1.392,0.829-2.918,0.2-3.172-1.264l2.032-18.46
				c-0.759-0.086-1.853-0.12-2.992-0.12C406.255,111.56,404.761,111.612,403.758,111.68"
            />
          </defs>
          <clipPath id="SVGIDA_338_">
            <use xlink:href="#SVGIDA_337_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_339_"
            cx="-157.001"
            cy="200.999"
            r="1.0007"
            gradientTransform="matrix(-12.2227 -21.6176 21.6176 -31.0125 -5856.8862 2977.5439)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#DCDCDC" />
            <stop offset="0.5272" style="stop-color:#BBBBBB" />
            <stop offset="1" style="stop-color:#DCDCDC" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_338_);fill:url(#SVGIDA_339_);"
            points="450.294,140.818 409.979,69.517 364.13,135.292
			404.444,206.594 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_340_"
              d="M403.794,111.574l2.008,18.598c-0.396,1.555-1.91,2.182-3.114,1.325l-11.762-14.591
				c-1.466,1.209-3.706,3.414-4.822,4.822l14.57,11.745c0.814,1.383,0.18,2.897-1.284,3.133l-18.618-2
				c-0.162,1.732-0.209,4.943,0,6.818l18.618-1.997c1.548,0.408,2.166,1.928,1.29,3.128l-14.573,11.747
				c1.235,1.406,3.387,3.737,4.821,4.823l11.758-14.586c1.38-0.8,2.889-0.164,3.118,1.3l-1.987,18.629
				c1.854,0.173,5.033,0.194,6.809-0.009l-2-18.629c0.407-1.541,1.916-2.158,3.114-1.297l11.765,14.592
				c1.536-1.201,3.738-3.526,4.822-4.823l-14.583-11.753c-0.808-1.374-0.184-2.878,1.265-3.124l18.652,1.999
				c0.203-1.813,0.199-4.977,0-6.818l-18.611,1.999c-1.548-0.396-2.175-1.899-1.332-3.101l14.61-11.777
				c-1.112-1.417-3.317-3.597-4.823-4.821l-11.742,14.564c-1.376,0.82-2.888,0.199-3.139-1.25l2.012-18.646
				c-0.776-0.089-1.848-0.124-2.961-0.124C406.281,111.45,404.823,111.505,403.794,111.574"
            />
          </defs>
          <clipPath id="SVGIDA_341_">
            <use xlink:href="#SVGIDA_340_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_342_"
            cx="-157.0005"
            cy="201"
            r="1.0002"
            gradientTransform="matrix(-12.9045 -21.1001 21.1001 -29.2958 -5859.9063 2713.7498)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#DFDFDF" />
            <stop offset="0.5272" style="stop-color:#BDBDBD" />
            <stop offset="1" style="stop-color:#DFDFDF" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_341_);fill:url(#SVGIDA_342_);"
            points="451.463,140.228 409.387,71.429 362.962,135.886
			405.038,204.684 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_343_"
              d="M403.829,111.467l1.988,18.787c-0.394,1.539-1.892,2.16-3.081,1.313l-11.91-14.713
				c-1.502,1.24-3.629,3.332-4.773,4.776l14.69,11.893c0.804,1.366,0.178,2.865-1.271,3.099l-18.807-1.981
				c-0.166,1.777-0.215,4.829,0,6.751l18.807-1.977c1.53,0.403,2.144,1.906,1.277,3.094l-14.694,11.896
				c1.267,1.439,3.304,3.662,4.774,4.773l11.904-14.705c1.365-0.792,2.857-0.163,3.086,1.286l-1.971,18.817
				c1.9,0.177,4.923,0.199,6.742-0.009l-1.98-18.817c0.402-1.524,1.896-2.136,3.081-1.283l11.912,14.711
				c1.574-1.23,3.662-3.443,4.773-4.773l-14.702-11.9c-0.8-1.36-0.182-2.848,1.252-3.093l18.839,1.98
				c0.207-1.858,0.205-4.861,0-6.751l-18.799,1.98c-1.532-0.392-2.152-1.88-1.317-3.067l14.728-11.924
				c-1.138-1.454-3.23-3.519-4.773-4.775l-11.89,14.687c-1.36,0.812-2.856,0.197-3.104-1.237l1.99-18.836
				c-0.797-0.091-1.847-0.126-2.934-0.126C406.305,111.341,404.884,111.396,403.829,111.467"
            />
          </defs>
          <clipPath id="SVGIDA_344_">
            <use xlink:href="#SVGIDA_343_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_345_"
            cx="-157.001"
            cy="201"
            r="1.0004"
            gradientTransform="matrix(-13.5581 -20.6835 20.6835 -27.8088 -5878.7813 2480.2891)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E1E1E1" />
            <stop offset="0.5272" style="stop-color:#BFBFBE" />
            <stop offset="1" style="stop-color:#E1E1E1" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_344_);fill:url(#SVGIDA_345_);"
            points="452.591,139.743 408.899,73.091 361.832,136.372
			405.523,203.024 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_346_"
              d="M403.864,111.361l1.967,18.975c-0.388,1.522-1.87,2.137-3.048,1.297l-12.057-14.829
				c-1.539,1.27-3.554,3.248-4.726,4.727l14.81,12.038c0.797,1.354,0.177,2.837-1.257,3.067l-18.995-1.962
				c-0.171,1.82-0.22,4.714,0,6.685l18.994-1.959c1.516,0.398,2.121,1.887,1.264,3.061l-14.813,12.042
				c1.298,1.476,3.221,3.586,4.726,4.726l12.052-14.823c1.352-0.784,2.828-0.162,3.053,1.271l-1.951,19.004
				c1.946,0.182,4.811,0.206,6.675-0.007l-1.962-19.005c0.399-1.508,1.877-2.113,3.048-1.27l12.06,14.829
				c1.612-1.261,3.588-3.363,4.725-4.726l-14.82-12.046c-0.79-1.347-0.18-2.819,1.238-3.06l19.027,1.962
				c0.213-1.905,0.209-4.749,0-6.685l-18.987,1.961c-1.515-0.387-2.129-1.859-1.304-3.035l14.847-12.069
				c-1.167-1.489-3.144-3.44-4.726-4.727l-12.035,14.805c-1.348,0.803-2.827,0.194-3.074-1.225l1.973-19.022
				c-0.818-0.094-1.85-0.13-2.913-0.13C406.324,111.231,404.944,111.288,403.864,111.361"
            />
          </defs>
          <clipPath id="SVGIDA_347_">
            <use xlink:href="#SVGIDA_346_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_348_"
            cx="-157.001"
            cy="201"
            r="1.0004"
            gradientTransform="matrix(-14.1907 -20.3498 20.3498 -26.5089 -5911.0278 2271.3821)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E4E4E4" />
            <stop offset="0.5272" style="stop-color:#C1C0C0" />
            <stop offset="1" style="stop-color:#E4E4E4" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_347_);fill:url(#SVGIDA_348_);"
            points="453.69,139.347 408.502,74.544 360.733,136.771
			405.922,201.573 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_349_"
              d="M403.899,111.255l1.946,19.162c-0.384,1.507-1.851,2.115-3.015,1.285l-12.203-14.949
				c-1.576,1.299-3.478,3.164-4.677,4.678l14.928,12.186c0.788,1.339,0.175,2.806-1.243,3.034l-19.183-1.941
				c-0.176,1.863-0.227,4.599,0,6.615l19.182-1.94c1.498,0.396,2.099,1.867,1.25,3.029l-14.932,12.188
				c1.327,1.513,3.135,3.512,4.677,4.68l12.198-14.944c1.336-0.776,2.797-0.16,3.02,1.258l-1.933,19.192
				c1.994,0.185,4.699,0.211,6.608-0.007l-1.942-19.193c0.394-1.492,1.854-2.091,3.016-1.256l12.205,14.95
				c1.65-1.292,3.513-3.285,4.677-4.679l-14.939-12.193c-0.783-1.331-0.178-2.788,1.225-3.026l19.215,1.942
				c0.218-1.951,0.215-4.634,0-6.615l-19.176,1.94c-1.499-0.383-2.106-1.841-1.289-3.002l14.965-12.217
				c-1.194-1.524-3.057-3.36-4.678-4.678l-12.181,14.924c-1.334,0.794-2.797,0.192-3.041-1.211l1.951-19.211
				c-0.837-0.096-1.849-0.133-2.888-0.133C406.346,111.122,405.004,111.18,403.899,111.255"
            />
          </defs>
          <clipPath id="SVGIDA_350_">
            <use xlink:href="#SVGIDA_349_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_351_"
            cx="-157.0015"
            cy="200.998"
            r="1.0012"
            gradientTransform="matrix(-14.8075 -20.0855 20.0855 -25.3635 -5954.7314 2082.6582)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E6E6E6" />
            <stop offset="0.5272" style="stop-color:#C2C2C2" />
            <stop offset="1" style="stop-color:#E6E6E6" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_350_);fill:url(#SVGIDA_351_);"
            points="454.765,139.022 408.177,75.828 359.658,137.097
			406.246,200.291 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_352_"
              d="M403.934,111.148l1.928,19.351c-0.38,1.491-1.831,2.092-2.983,1.271l-12.349-15.067
				c-1.612,1.33-3.402,3.081-4.629,4.63l15.048,12.332c0.778,1.324,0.173,2.775-1.231,3.001l-19.371-1.922
				c-0.179,1.906-0.23,4.483,0,6.547l19.371-1.921c1.482,0.391,2.076,1.847,1.236,2.997l-15.051,12.335
				c1.357,1.546,3.051,3.436,4.628,4.63l12.345-15.063c1.323-0.767,2.767-0.158,2.988,1.244l-1.915,19.38
				c2.04,0.189,4.587,0.217,6.541-0.006l-1.924-19.382c0.391-1.476,1.836-2.068,2.983-1.242l12.353,15.069
				c1.688-1.321,3.437-3.203,4.629-4.63l-15.061-12.34c-0.773-1.317-0.176-2.759,1.212-2.995l19.403,1.924
				c0.222-1.996,0.219-4.521,0-6.547l-19.364,1.921c-1.482-0.379-2.084-1.819-1.275-2.97l15.085-12.363
				c-1.223-1.56-2.973-3.282-4.629-4.63l-12.329,15.044c-1.319,0.786-2.768,0.19-3.008-1.197l1.931-19.399
				c-0.856-0.098-1.844-0.137-2.857-0.137C406.371,111.012,405.066,111.072,403.934,111.148"
            />
          </defs>
          <clipPath id="SVGIDA_353_">
            <use xlink:href="#SVGIDA_352_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_354_"
            cx="-157.0015"
            cy="200.999"
            r="1.0009"
            gradientTransform="matrix(-15.413 -19.8801 19.8801 -24.3473 -6008.5234 1910.6442)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E9E9E8" />
            <stop offset="0.5272" style="stop-color:#C4C4C4" />
            <stop offset="1" style="stop-color:#E9E9E8" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_353_);fill:url(#SVGIDA_354_);"
            points="455.82,138.761 407.913,76.968 358.602,137.359
			406.509,199.152 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_355_"
              d="M403.969,111.042l1.906,19.54c-0.375,1.473-1.81,2.068-2.95,1.256l-12.495-15.187
				c-1.648,1.359-3.326,2.998-4.581,4.582l15.167,12.479c0.771,1.31,0.172,2.744-1.218,2.968l-19.558-1.902
				c-0.185,1.949-0.237,4.369,0,6.478l19.558-1.901c1.467,0.388,2.053,1.827,1.224,2.965L385.85,154.8
				c1.391,1.582,2.969,3.361,4.581,4.581l12.491-15.182c1.309-0.758,2.737-0.155,2.955,1.23l-1.896,19.567
				c2.086,0.194,4.475,0.223,6.473-0.005l-1.903-19.57c0.387-1.46,1.816-2.044,2.951-1.228L424,159.382
				c1.727-1.352,3.362-3.123,4.581-4.582l-15.179-12.485c-0.766-1.305-0.174-2.729,1.198-2.963l19.591,1.903
				c0.228-2.04,0.224-4.405,0-6.478l-19.553,1.901c-1.467-0.375-2.061-1.8-1.261-2.938l15.203-12.509
				c-1.25-1.596-2.886-3.203-4.581-4.581l-12.475,15.162c-1.306,0.777-2.737,0.188-2.977-1.185l1.911-19.587
				c-0.876-0.1-1.844-0.139-2.832-0.139C406.393,110.903,405.127,110.964,403.969,111.042"
            />
          </defs>
          <clipPath id="SVGIDA_356_">
            <use xlink:href="#SVGIDA_355_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_357_"
            cx="-157.0005"
            cy="200.998"
            r="1.0008"
            gradientTransform="matrix(-16.0114 -19.7263 19.7263 -23.4413 -6071.5718 1752.674)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#EBEBEB" />
            <stop offset="0.5272" style="stop-color:#C6C6C5" />
            <stop offset="1" style="stop-color:#EBEBEB" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_356_);fill:url(#SVGIDA_357_);"
            points="456.861,138.552 407.702,77.987 357.562,137.571
			406.72,198.136 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_358_"
              d="M404.004,110.935l1.887,19.729c-0.372,1.457-1.791,2.046-2.918,1.242L390.331,116.6
				c-1.687,1.391-3.25,2.914-4.533,4.533l15.287,12.625c0.762,1.296,0.168,2.716-1.205,2.938l-19.747-1.885
				c-0.188,1.994-0.242,4.255,0,6.411l19.747-1.882c1.45,0.382,2.031,1.807,1.21,2.93L385.799,154.9
				c1.42,1.616,2.883,3.283,4.532,4.532l12.639-15.301c1.293-0.751,2.706-0.155,2.922,1.216l-1.878,19.755
				c2.133,0.198,4.364,0.229,6.406-0.004l-1.883-19.758c0.381-1.443,1.795-2.022,2.917-1.216l12.645,15.308
				c1.767-1.381,3.286-3.042,4.533-4.532l-15.298-12.635c-0.757-1.288-0.172-2.696,1.185-2.929l19.778,1.885
				c0.232-2.086,0.229-4.292,0-6.411l-19.739,1.884c-1.45-0.371-2.039-1.78-1.249-2.905l15.323-12.656
				c-1.278-1.631-2.8-3.125-4.533-4.533l-12.622,15.282c-1.289,0.769-2.705,0.187-2.941-1.171l1.89-19.776
				c-0.896-0.102-1.844-0.142-2.808-0.142C406.415,110.793,405.188,110.855,404.004,110.935"
            />
          </defs>
          <clipPath id="SVGIDA_359_">
            <use xlink:href="#SVGIDA_358_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_360_"
            cx="-157.002"
            cy="200.999"
            r="1.0011"
            gradientTransform="matrix(-16.6079 -19.6201 19.6201 -22.6323 -6143.8726 1606.7317)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#EDEDED" />
            <stop offset="0.5272" style="stop-color:#C8C7C7" />
            <stop offset="1" style="stop-color:#EDEDED" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_359_);fill:url(#SVGIDA_360_);"
            points="457.887,138.387 407.536,78.904 356.533,137.736
			406.884,197.22 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_361_"
              d="M404.039,110.829l1.866,19.917c-0.367,1.44-1.771,2.022-2.886,1.229l-12.787-15.426
				c-1.724,1.421-3.175,2.831-4.485,4.485l15.406,12.771c0.753,1.282,0.166,2.687-1.191,2.903l-19.936-1.863
				c-0.19,2.036-0.246,4.139,0,6.343l19.936-1.863c1.435,0.378,2.008,1.786,1.196,2.898l-15.41,12.775
				c1.451,1.652,2.799,3.21,4.484,4.485l12.784-15.421c1.28-0.742,2.677-0.153,2.891,1.204l-1.86,19.941
				c2.179,0.201,4.252,0.234,6.339-0.004l-1.864-19.946c0.377-1.428,1.776-2,2.887-1.201l12.79,15.427
				c1.804-1.411,3.212-2.961,4.483-4.485l-15.417-12.781c-0.748-1.272-0.17-2.667,1.173-2.896l19.967,1.866
				c0.236-2.132,0.233-4.178,0-6.343l-19.929,1.862c-1.435-0.366-2.016-1.76-1.233-2.872l15.44-12.802
				c-1.306-1.666-2.714-3.046-4.484-4.485l-12.77,15.401c-1.274,0.761-2.676,0.185-2.909-1.158l1.87-19.963
				c-0.915-0.104-1.84-0.146-2.777-0.146C406.44,110.684,405.249,110.747,404.039,110.829"
            />
          </defs>
          <clipPath id="SVGIDA_362_">
            <use xlink:href="#SVGIDA_361_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_363_"
            cx="-157.001"
            cy="200.998"
            r="1.001"
            gradientTransform="matrix(-17.2058 -19.5566 19.5566 -21.9074 -6224.959 1470.9965)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F0F0F0" />
            <stop offset="0.5272" style="stop-color:#C9C9C9" />
            <stop offset="1" style="stop-color:#F0F0F0" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_362_);fill:url(#SVGIDA_363_);"
            points="458.904,138.263 407.41,79.732 355.517,137.864
			407.011,196.395 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_364_"
              d="M404.074,110.723l1.846,20.105c-0.363,1.425-1.751,2-2.853,1.215l-12.935-15.545
				c-1.76,1.451-3.098,2.747-4.438,4.437l15.525,12.919c0.746,1.267,0.165,2.655-1.177,2.87l-20.124-1.844
				c-0.195,2.08-0.252,4.024,0,6.274l20.124-1.845c1.418,0.374,1.985,1.767,1.183,2.866l-15.53,12.923
				c1.482,1.687,2.716,3.135,4.437,4.437l12.933-15.54c1.264-0.734,2.646-0.151,2.856,1.19l-1.841,20.129
				c2.224,0.207,4.14,0.239,6.271-0.004l-1.845-20.133c0.372-1.412,1.756-1.978,2.854-1.188l12.937,15.545
				c1.843-1.441,3.136-2.88,4.437-4.437l-15.536-12.928c-0.74-1.26-0.168-2.637,1.159-2.863l20.153,1.847
				c0.242-2.178,0.238-4.063,0-6.274l-20.116,1.843c-1.419-0.361-1.993-1.739-1.221-2.841l15.561-12.947
				c-1.332-1.701-2.628-2.967-4.437-4.437l-12.916,15.521c-1.26,0.751-2.646,0.183-2.876-1.145l1.851-20.151
				c-0.936-0.106-1.841-0.148-2.754-0.148C406.462,110.574,405.309,110.639,404.074,110.723"
            />
          </defs>
          <clipPath id="SVGIDA_365_">
            <use xlink:href="#SVGIDA_364_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_366_"
            cx="-157.0015"
            cy="200.998"
            r="1.0012"
            gradientTransform="matrix(-17.8107 -19.5352 19.5352 -21.2597 -6315.6182 1344.1824)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F2F2F2" />
            <stop offset="0.5272" style="stop-color:#CBCBCB" />
            <stop offset="1" style="stop-color:#F2F2F2" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_365_);fill:url(#SVGIDA_366_);"
            points="459.913,138.172 407.317,80.483 354.507,137.956
			407.103,195.645 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_367_"
              d="M404.109,110.617l1.825,20.293c-0.358,1.408-1.73,1.977-2.82,1.2l-13.08-15.663
				c-1.797,1.479-3.023,2.664-4.39,4.389l15.646,13.065c0.736,1.252,0.163,2.625-1.164,2.838l-20.312-1.825
				c-0.2,2.123-0.258,3.909,0,6.206l20.312-1.825c1.401,0.37,1.962,1.746,1.169,2.833l-15.65,13.07
				c1.514,1.722,2.633,3.059,4.39,4.389l13.077-15.661c1.251-0.725,2.617-0.148,2.824,1.178l-1.821,20.315
				c2.271,0.212,4.027,0.247,6.204-0.001l-1.826-20.322c0.369-1.395,1.736-1.955,2.82-1.175l13.084,15.666
				c1.881-1.472,3.061-2.8,4.389-4.389l-15.656-13.074c-0.73-1.245-0.166-2.608,1.146-2.831l20.342,1.827
				c0.247-2.223,0.244-3.949,0-6.206l-20.304,1.824c-1.402-0.358-1.971-1.722-1.206-2.809l15.679-13.095
				c-1.362-1.737-2.543-2.887-4.389-4.388l-13.062,15.64c-1.248,0.743-2.617,0.18-2.844-1.132l1.828-20.338
				c-0.953-0.11-1.838-0.152-2.727-0.152C406.484,110.465,405.369,110.531,404.109,110.617"
            />
          </defs>
          <clipPath id="SVGIDA_368_">
            <use xlink:href="#SVGIDA_367_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_369_"
            cx="-157.001"
            cy="200.998"
            r="1.001"
            gradientTransform="matrix(-18.4218 -19.5487 19.5487 -20.6757 -6414.2881 1224.6814)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F5F5F5" />
            <stop offset="0.5272" style="stop-color:#CDCDCC" />
            <stop offset="1" style="stop-color:#F5F5F5" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_368_);fill:url(#SVGIDA_369_);"
            points="460.916,138.111 407.256,81.169 353.504,138.02
			407.164,194.962 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_370_"
              d="M404.145,110.509l1.805,20.483c-0.355,1.392-1.71,1.955-2.787,1.187l-13.229-15.782
				c-1.833,1.511-2.944,2.58-4.34,4.34l15.765,13.213c0.728,1.237,0.16,2.594-1.15,2.804l-20.5-1.805
				c-0.205,2.166-0.263,3.794,0,6.138l20.5-1.805c1.385,0.365,1.938,1.725,1.156,2.8l-15.771,13.217
				c1.544,1.756,2.547,2.983,4.341,4.34l13.225-15.779c1.235-0.717,2.586-0.148,2.792,1.164l-1.805,20.504
				c2.318,0.215,3.916,0.252,6.138-0.001l-1.808-20.512c0.365-1.379,1.717-1.933,2.788-1.161l13.23,15.785
				c1.92-1.501,2.986-2.719,4.34-4.34l-15.774-13.222c-0.724-1.23-0.164-2.577,1.133-2.798l20.528,1.808
				c0.253-2.268,0.248-3.835,0-6.138l-20.491,1.805c-1.387-0.354-1.948-1.701-1.193-2.776l15.798-13.24
				c-1.389-1.772-2.456-2.81-4.34-4.34l-13.208,15.76c-1.233,0.733-2.586,0.178-2.812-1.119l1.809-20.528
				c-0.974-0.11-1.836-0.153-2.699-0.153C406.507,110.355,405.431,110.423,404.145,110.509"
            />
          </defs>
          <clipPath id="SVGIDA_371_">
            <use xlink:href="#SVGIDA_370_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_372_"
            cx="-157.0015"
            cy="200.998"
            r="1.0012"
            gradientTransform="matrix(-19.038 -19.5914 19.5914 -20.1449 -6519.626 1111.2689)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F7F7F7" />
            <stop offset="0.5272" style="stop-color:#CECECE" />
            <stop offset="1" style="stop-color:#F7F7F7" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_371_);fill:url(#SVGIDA_372_);"
            points="461.914,138.077 407.221,81.794 352.506,138.056
			407.199,194.339 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_373_"
              d="M404.18,110.403l1.784,20.671c-0.351,1.377-1.69,1.932-2.755,1.173l-13.374-15.902
				c-1.87,1.541-2.87,2.497-4.293,4.292l15.885,13.359c0.72,1.223,0.159,2.563-1.137,2.771l-20.689-1.785
				c-0.208,2.21-0.268,3.679,0,6.069l20.688-1.786c1.37,0.361,1.918,1.706,1.143,2.769l-15.89,13.363
				c1.575,1.792,2.464,2.907,4.293,4.292l13.372-15.898c1.221-0.71,2.555-0.147,2.759,1.149l-1.786,20.69
				c2.364,0.219,3.806,0.258,6.069,0l-1.786-20.698c0.36-1.363,1.695-1.91,2.756-1.147l13.375,15.904
				c1.959-1.531,2.911-2.64,4.292-4.292l-15.894-13.368c-0.714-1.218-0.162-2.548,1.119-2.766l20.717,1.788
				c0.258-2.313,0.254-3.721,0-6.069l-20.68,1.785c-1.37-0.35-1.926-1.681-1.18-2.742l15.917-13.389
				c-1.416-1.808-2.37-2.729-4.292-4.292l-13.354,15.88c-1.218,0.726-2.557,0.176-2.778-1.106l1.788-20.715
				c-0.992-0.113-1.835-0.157-2.673-0.157C406.53,110.246,405.491,110.315,404.18,110.403"
            />
          </defs>
          <clipPath id="SVGIDA_374_">
            <use xlink:href="#SVGIDA_373_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_375_"
            cx="-157.001"
            cy="200.998"
            r="1.001"
            gradientTransform="matrix(-19.659 -19.659 19.659 -19.659 -6630.6982 1003.0203)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#FAFAFA" />
            <stop offset="0.5272" style="stop-color:#D0D0D0" />
            <stop offset="1" style="stop-color:#FAFAFA" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_374_);fill:url(#SVGIDA_375_);"
            :style="frontWheelClass"
            v-on:click="changeSeverity('frontWheel')"
            points="462.907,138.067 407.209,82.369 351.512,138.067
			407.209,193.766"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_376_"
              d="M405.796,133.812c0,0.78,0.632,1.411,1.411,1.411c0.78,0,1.411-0.631,1.411-1.411
				c0-0.778-0.631-1.41-1.411-1.41C406.428,132.401,405.796,133.033,405.796,133.812"
            />
          </defs>
          <clipPath id="SVGIDA_377_">
            <use xlink:href="#SVGIDA_376_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_378_"
            cx="-157"
            cy="201.002"
            r="0.9995"
            gradientTransform="matrix(-1.411 0 0 -1.411 185.6799 417.4236)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <rect
            x="405.796"
            y="132.401"
            style="clip-path:url(#SVGIDA_377_);fill:url(#SVGIDA_378_);"
            width="2.822"
            height="2.821"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDA_379_"
              points="406.688,132.913 406.169,133.812 406.688,134.712 407.727,134.712 408.246,133.812
				407.727,132.913 			"
            />
          </defs>
          <clipPath id="SVGIDA_380_">
            <use xlink:href="#SVGIDA_379_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_381_"
            cx="-157.001"
            cy="200.999"
            r="1.001"
            gradientTransform="matrix(-0.9716 0 0 -0.9716 254.6601 329.1111)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <rect
            x="406.169"
            y="132.913"
            style="clip-path:url(#SVGIDA_380_);fill:url(#SVGIDA_381_);"
            width="2.077"
            height="1.799"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_382_"
              d="M410.892,135.436c-0.74,0.241-1.146,1.037-0.904,1.778c0.241,0.741,1.036,1.147,1.776,0.906
				c0.742-0.241,1.147-1.037,0.906-1.778c-0.194-0.597-0.747-0.975-1.342-0.975C411.184,135.367,411.037,135.389,410.892,135.436"
            />
          </defs>
          <clipPath id="SVGIDA_383_">
            <use xlink:href="#SVGIDA_382_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_384_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(-0.436 -1.3419 1.3419 -0.436 73.147 13.7407)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_383_);fill:url(#SVGIDA_384_);"
            points="413.791,138.075 412.608,134.437 408.865,135.653
			410.047,139.291 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDA_385_"
              points="410.313,136.562 410.634,137.55 411.65,137.766 412.344,136.994 412.023,136.007
				411.007,135.79 			"
            />
          </defs>
          <clipPath id="SVGIDA_386_">
            <use xlink:href="#SVGIDA_385_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_387_"
            cx="-156.9995"
            cy="201"
            r="0.9998"
            gradientTransform="matrix(-0.3003 -0.9241 0.9241 -0.3003 178.4411 52.048)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_386_);fill:url(#SVGIDA_387_);"
            points="412.925,137.577 412.15,135.192 409.731,135.979
			410.506,138.363 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_388_"
              d="M408.952,140.472c-0.631,0.458-0.771,1.342-0.313,1.972c0.458,0.631,1.341,0.771,1.972,0.313
				c0.63-0.458,0.77-1.341,0.312-1.971c-0.276-0.38-0.707-0.582-1.143-0.582C409.492,140.203,409.203,140.29,408.952,140.472"
            />
          </defs>
          <clipPath id="SVGIDA_389_">
            <use xlink:href="#SVGIDA_388_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_390_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(1.1415 -0.8294 0.8294 1.1415 422.298 -218.0432)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_389_);fill:url(#SVGIDA_390_);"
            points="409.287,144.735 412.813,142.174 410.275,138.682
			406.75,141.243 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDA_391_"
              points="408.833,141.191 408.941,142.225 409.89,142.647 410.73,142.036 410.622,141.003
				409.672,140.581 			"
            />
          </defs>
          <clipPath id="SVGIDA_392_">
            <use xlink:href="#SVGIDA_391_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_393_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(0.7861 -0.5711 0.5711 0.7861 418.4003 -106.0515)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_392_);fill:url(#SVGIDA_393_);"
            points="409.488,143.549 411.713,141.934 410.074,139.679
			407.851,141.295 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_394_"
              d="M403.563,140.808c-0.459,0.631-0.317,1.514,0.313,1.971c0.63,0.458,1.513,0.318,1.971-0.312
				c0.458-0.631,0.318-1.513-0.313-1.971c-0.25-0.182-0.54-0.271-0.828-0.271C404.269,140.226,403.838,140.428,403.563,140.808"
            />
          </defs>
          <clipPath id="SVGIDA_395_">
            <use xlink:href="#SVGIDA_394_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_396_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(1.1415 0.8293 -0.8293 1.1415 750.6146 42.404)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_395_);fill:url(#SVGIDA_396_);"
            points="401.673,142.196 405.198,144.758 407.735,141.266
			404.21,138.704 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDA_397_"
              points="403.864,141.027 403.755,142.06 404.595,142.67 405.544,142.248 405.653,141.215
				404.813,140.604 			"
            />
          </defs>
          <clipPath id="SVGIDA_398_">
            <use xlink:href="#SVGIDA_397_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_399_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(0.7861 0.5711 -0.5711 0.7861 642.9149 73.3005)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_398_);fill:url(#SVGIDA_399_);"
            points="402.772,141.956 404.997,143.572 406.636,141.317
			404.411,139.701 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_400_"
              d="M401.771,136.379c-0.24,0.742,0.164,1.537,0.906,1.779c0.74,0.24,1.537-0.165,1.777-0.907
				c0.241-0.741-0.165-1.537-0.905-1.777c-0.145-0.047-0.293-0.069-0.437-0.069C402.518,135.404,401.965,135.783,401.771,136.379"
            />
          </defs>
          <clipPath id="SVGIDA_401_">
            <use xlink:href="#SVGIDA_400_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_402_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(-0.436 1.3419 -1.3419 -0.436 604.3799 435.135)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_401_);fill:url(#SVGIDA_402_);"
            points="401.833,134.474 400.651,138.112 404.394,139.328
			405.576,135.689 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDA_403_"
              points="402.418,136.043 402.097,137.032 402.793,137.804 403.809,137.588 404.129,136.6
				403.435,135.827 			"
            />
          </defs>
          <clipPath id="SVGIDA_404_">
            <use xlink:href="#SVGIDA_403_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_405_"
            cx="-157"
            cy="201"
            r="1"
            gradientTransform="matrix(-0.3003 0.9241 -0.9241 -0.3003 541.7151 342.254)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            style="clip-path:url(#SVGIDA_404_);fill:url(#SVGIDA_405_);"
            points="402.291,135.229 401.516,137.615 403.935,138.401
			404.71,136.016 		"
          />
        </g>
        <g>
          <path
            style="fill:#080808;"
            d="M369.35,138.013c0,20.914,16.954,37.868,37.875,37.868c20.914,0,37.868-16.954,37.868-37.868
			s-16.954-37.876-37.868-37.876C386.304,100.137,369.35,117.099,369.35,138.013 M379.423,138.013
			c0-15.351,12.443-27.802,27.802-27.802c15.35,0,27.795,12.451,27.795,27.802c0,15.35-12.445,27.794-27.795,27.794
			C391.866,165.807,379.423,153.362,379.423,138.013"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_406_"
              d="M379.422,138.013c0-15.351,12.445-27.802,27.802-27.802c15.352,0,27.795,12.451,27.795,27.802
				s-12.443,27.794-27.795,27.794C391.867,165.807,379.422,153.363,379.422,138.013 M406.766,100.149l-0.433,1.59l-0.462-0.158
				l0.385-1.42c-0.27,0.008-0.541,0.008-0.809,0.021l-0.378,1.608l-0.469-0.142l0.337-1.437c-0.271,0.017-0.541,0.04-0.811,0.063
				l-0.32,1.611l-0.473-0.125l0.286-1.449c-0.271,0.026-0.539,0.059-0.808,0.091l-0.264,1.623l-0.478-0.109l0.234-1.451
				c-0.267,0.036-0.537,0.063-0.802,0.103l-0.208,1.642l-0.48-0.093l0.185-1.461c-0.268,0.044-0.534,0.093-0.8,0.143l-0.149,1.638
				l-0.483-0.075l0.134-1.474c-0.268,0.055-0.53,0.118-0.794,0.179l-0.092,1.641l-0.487-0.059l0.083-1.469
				c-0.263,0.063-0.528,0.121-0.789,0.189l-0.034,1.65l-0.488-0.042l0.031-1.469c-0.261,0.072-0.521,0.145-0.78,0.221l0.022,1.646
				l-0.489-0.024l-0.02-1.477c-0.261,0.082-0.516,0.174-0.773,0.261l0.081,1.639l-0.49-0.008l-0.071-1.468
				c-0.257,0.09-0.51,0.184-0.763,0.278l0.137,1.637l-0.489,0.009l-0.123-1.459c-0.251,0.1-0.504,0.194-0.753,0.297l0.195,1.635
				l-0.489,0.026l-0.174-1.457c-0.249,0.108-0.495,0.223-0.741,0.335l0.251,1.616l-0.489,0.044l-0.224-1.451
				c-0.246,0.117-0.486,0.242-0.729,0.365l0.307,1.604l-0.486,0.061l-0.274-1.432c-0.238,0.124-0.479,0.245-0.717,0.375l0.363,1.597
				l-0.484,0.077l-0.322-1.419c-0.235,0.133-0.472,0.266-0.703,0.404l0.417,1.576l-0.481,0.095l-0.373-1.412
				c-0.23,0.142-0.456,0.293-0.685,0.438l0.47,1.557l-0.477,0.11l-0.422-1.392c-0.225,0.148-0.449,0.302-0.672,0.456l0.524,1.538
				l-0.472,0.128l-0.469-1.37c-0.219,0.157-0.441,0.308-0.657,0.468l0.577,1.524l-0.468,0.144l-0.515-1.354
				c-0.214,0.165-0.426,0.333-0.639,0.503l0.629,1.492l-0.463,0.16l-0.563-1.34c-0.209,0.173-0.411,0.354-0.617,0.531l0.678,1.467
				l-0.457,0.177l-0.604-1.31c-0.203,0.178-0.405,0.356-0.604,0.54l0.73,1.445l-0.45,0.192l-0.649-1.286
				c-0.195,0.187-0.394,0.369-0.587,0.559l0.78,1.42l-0.442,0.208l-0.696-1.266c-0.19,0.192-0.374,0.391-0.562,0.588l0.827,1.385
				l-0.436,0.223l-0.741-1.241c-0.182,0.2-0.36,0.404-0.539,0.608l0.874,1.356l-0.428,0.238l-0.78-1.21
				c-0.175,0.204-0.354,0.406-0.525,0.614l0.926,1.331l-0.42,0.253l-0.821-1.182c-0.169,0.211-0.337,0.422-0.501,0.637l0.968,1.294
				l-0.411,0.268l-0.866-1.159c-0.161,0.218-0.313,0.441-0.472,0.662l1.011,1.258l-0.4,0.281l-0.904-1.125
				c-0.153,0.223-0.304,0.447-0.453,0.674l1.056,1.223l-0.391,0.296l-0.939-1.09c-0.146,0.227-0.297,0.45-0.438,0.681l1.104,1.191
				l-0.382,0.308l-0.98-1.059c-0.138,0.232-0.271,0.468-0.404,0.704l1.139,1.146l-0.369,0.322l-1.022-1.029
				c-0.13,0.237-0.249,0.481-0.374,0.723l1.178,1.105l-0.357,0.336l-1.053-0.99c-0.12,0.242-0.244,0.482-0.359,0.727l1.222,1.068
				l-0.347,0.348l-1.085-0.951c-0.113,0.245-0.228,0.49-0.334,0.738l1.257,1.024l-0.334,0.359l-1.124-0.917
				c-0.103,0.249-0.199,0.504-0.298,0.756l1.288,0.979l-0.32,0.37l-1.154-0.876c-0.096,0.253-0.186,0.509-0.275,0.765l1.324,0.933
				l-0.308,0.382l-1.18-0.833c-0.086,0.256-0.179,0.508-0.26,0.767l1.362,0.891l-0.294,0.393l-1.211-0.793
				c-0.077,0.26-0.149,0.521-0.221,0.781l1.384,0.838l-0.281,0.402l-1.241-0.752c-0.068,0.261-0.125,0.527-0.188,0.792l1.411,0.788
				l-0.265,0.411l-1.261-0.704c-0.059,0.263-0.122,0.524-0.175,0.791l1.444,0.741l-0.251,0.421l-1.283-0.659
				c-0.049,0.265-0.098,0.531-0.142,0.797l1.464,0.69l-0.237,0.428l-1.312-0.617c-0.04,0.267-0.068,0.539-0.103,0.808l1.481,0.635
				l-0.222,0.438l-1.323-0.567c-0.031,0.268-0.062,0.535-0.087,0.805l1.507,0.585l-0.206,0.445l-1.34-0.521
				c-0.021,0.27-0.045,0.537-0.062,0.807l1.526,0.531l-0.191,0.452l-1.363-0.475c-0.012,0.27-0.014,0.541-0.02,0.812l1.537,0.477
				l-0.174,0.458l-1.376-0.426c-0.001,0.139-0.011,0.276-0.011,0.416c0,0.132,0.009,0.263,0.011,0.395l1.557,0.424l-0.159,0.463
				l-1.386-0.377c0.006,0.27,0.008,0.54,0.021,0.808l1.576,0.37l-0.142,0.47l-1.408-0.33c0.016,0.271,0.04,0.54,0.063,0.81
				l1.583,0.313l-0.127,0.473l-1.419-0.28c0.025,0.271,0.056,0.538,0.085,0.808l1.6,0.258l-0.109,0.478l-1.425-0.23
				c0.034,0.267,0.063,0.536,0.103,0.802l1.614,0.204l-0.092,0.48l-1.438-0.182c0.044,0.268,0.093,0.534,0.143,0.799l1.615,0.148
				l-0.075,0.482l-1.451-0.132c0.053,0.268,0.115,0.53,0.173,0.794l1.623,0.09l-0.058,0.487l-1.45-0.081
				c0.063,0.262,0.118,0.527,0.185,0.787l1.637,0.034l-0.041,0.489l-1.455-0.031c0.071,0.261,0.145,0.521,0.221,0.779l1.631-0.022
				l-0.023,0.49l-1.468,0.019c0.081,0.261,0.176,0.515,0.263,0.772l1.628-0.08l-0.008,0.49l-1.458,0.07
				c0.089,0.256,0.179,0.511,0.273,0.764l1.631-0.137l0.011,0.489l-1.454,0.123c0.098,0.251,0.193,0.504,0.297,0.752l1.627-0.194
				l0.026,0.489l-1.453,0.174c0.107,0.249,0.222,0.494,0.335,0.741l1.613-0.25l0.044,0.488l-1.448,0.224
				c0.116,0.245,0.238,0.486,0.359,0.729l1.606-0.307l0.061,0.486l-1.434,0.274c0.124,0.238,0.243,0.481,0.371,0.719l1.602-0.364
				l0.079,0.484l-1.426,0.322c0.133,0.236,0.266,0.472,0.404,0.704l1.583-0.419l0.094,0.481l-1.421,0.375
				c0.142,0.231,0.293,0.457,0.439,0.686l1.563-0.472l0.112,0.477l-1.402,0.424c0.149,0.226,0.3,0.449,0.454,0.673l1.55-0.528
				l0.128,0.473l-1.383,0.471c0.157,0.221,0.309,0.443,0.469,0.66l1.536-0.583l0.144,0.469l-1.368,0.519
				c0.163,0.216,0.333,0.427,0.502,0.64l1.508-0.635l0.161,0.463l-1.356,0.57c0.172,0.209,0.353,0.413,0.528,0.619l1.486-0.687
				l0.177,0.456l-1.33,0.614c0.18,0.203,0.355,0.407,0.539,0.606l1.467-0.741l0.191,0.45l-1.308,0.661
				c0.187,0.195,0.37,0.394,0.56,0.587l1.439-0.792l0.208,0.442l-1.289,0.709c0.192,0.19,0.393,0.375,0.588,0.562l1.41-0.839
				l0.223,0.436l-1.266,0.753c0.2,0.185,0.403,0.363,0.606,0.543l1.382-0.891l0.238,0.428l-1.235,0.796
				c0.205,0.176,0.403,0.357,0.612,0.529l1.357-0.945l0.254,0.42l-1.21,0.842c0.211,0.169,0.424,0.337,0.639,0.501l1.32-0.988
				l0.268,0.411l-1.189,0.889c0.218,0.162,0.443,0.314,0.665,0.472l1.285-1.033l0.281,0.4l-1.152,0.928
				c0.222,0.154,0.444,0.308,0.67,0.456l1.254-1.083l0.296,0.392l-1.121,0.966c0.228,0.147,0.452,0.297,0.683,0.438l1.22-1.13
				l0.31,0.38l-1.092,1.012c0.233,0.138,0.47,0.271,0.705,0.404l1.177-1.169l0.322,0.369l-1.06,1.054
				c0.237,0.129,0.479,0.252,0.721,0.377l1.138-1.212l0.335,0.357l-1.02,1.086c0.242,0.122,0.479,0.247,0.724,0.364l1.103-1.259
				l0.347,0.346l-0.983,1.122c0.245,0.114,0.491,0.227,0.739,0.335l1.057-1.295l0.358,0.334l-0.95,1.164
				c0.251,0.104,0.505,0.199,0.759,0.299l1.009-1.329l0.371,0.32l-0.907,1.195c0.253,0.096,0.507,0.188,0.763,0.279l0.966-1.369
				l0.381,0.308l-0.863,1.224c0.256,0.087,0.51,0.179,0.768,0.261l0.921-1.407l0.392,0.294l-0.823,1.258
				c0.259,0.078,0.521,0.15,0.783,0.223l0.867-1.432l0.401,0.279l-0.781,1.29c0.262,0.069,0.527,0.129,0.791,0.191l0.818-1.462
				l0.411,0.266l-0.733,1.311c0.265,0.06,0.526,0.125,0.791,0.179l0.771-1.499l0.42,0.251l-0.688,1.337
				c0.268,0.05,0.533,0.1,0.802,0.144l0.714-1.519l0.429,0.236l-0.644,1.369c0.267,0.042,0.54,0.068,0.81,0.104l0.66-1.54
				l0.436,0.222l-0.592,1.383c0.269,0.031,0.537,0.063,0.807,0.089l0.608-1.568l0.445,0.206l-0.544,1.4
				c0.27,0.022,0.539,0.046,0.81,0.063l0.552-1.588l0.451,0.191l-0.496,1.427c0.271,0.013,0.543,0.014,0.815,0.021l0.496-1.603
				l0.457,0.174l-0.445,1.44c0.157,0.002,0.313,0.012,0.469,0.012c0.116,0,0.229-0.007,0.344-0.008l0.44-1.625l0.464,0.159
				l-0.395,1.453c0.271-0.007,0.541-0.01,0.811-0.021l0.386-1.642l0.469,0.142l-0.348,1.477c0.273-0.017,0.543-0.041,0.813-0.063
				l0.327-1.651l0.474,0.125l-0.295,1.488c0.271-0.024,0.54-0.054,0.81-0.083l0.27-1.67l0.479,0.109l-0.242,1.496
				c0.268-0.033,0.537-0.063,0.803-0.103l0.214-1.686l0.481,0.092l-0.192,1.512c0.269-0.044,0.536-0.093,0.802-0.143l0.154-1.688
				l0.483,0.075l-0.139,1.524c0.268-0.054,0.532-0.113,0.796-0.173l0.097-1.696l0.485,0.058l-0.086,1.524
				c0.265-0.062,0.529-0.116,0.791-0.184l0.035-1.712l0.488,0.041l-0.032,1.531c0.262-0.071,0.523-0.146,0.783-0.222l-0.024-1.706
				l0.489,0.024l0.022,1.542c0.26-0.081,0.515-0.174,0.773-0.261l-0.084-1.704l0.491,0.008l0.074,1.533
				c0.256-0.09,0.512-0.179,0.765-0.272l-0.143-1.708l0.489-0.011l0.128,1.53c0.254-0.098,0.507-0.194,0.758-0.297l-0.204-1.703
				l0.489-0.027l0.183,1.531c0.25-0.106,0.496-0.223,0.743-0.336l-0.262-1.688l0.488-0.045l0.235,1.524
				c0.246-0.117,0.488-0.239,0.731-0.361l-0.32-1.681l0.486-0.06l0.287,1.509c0.24-0.124,0.484-0.242,0.723-0.372l-0.383-1.677
				l0.484-0.078l0.341,1.501c0.237-0.134,0.472-0.27,0.706-0.406l-0.438-1.656l0.48-0.095l0.396,1.496
				c0.231-0.142,0.458-0.294,0.688-0.441l-0.494-1.637l0.478-0.112l0.444,1.476c0.227-0.15,0.452-0.3,0.676-0.454l-0.553-1.623
				l0.474-0.128l0.495,1.456c0.221-0.157,0.444-0.311,0.661-0.471l-0.609-1.607l0.468-0.145l0.547,1.441
				c0.216-0.165,0.429-0.334,0.642-0.504l-0.663-1.577l0.463-0.161l0.599,1.425c0.211-0.173,0.414-0.353,0.621-0.529l-0.718-1.555
				l0.457-0.177l0.645,1.398c0.204-0.18,0.409-0.356,0.609-0.539l-0.775-1.535l0.451-0.191l0.694,1.373
				c0.196-0.185,0.395-0.371,0.587-0.561l-0.827-1.504l0.444-0.208l0.745,1.354c0.19-0.192,0.375-0.393,0.563-0.59l-0.877-1.472
				l0.436-0.224l0.791,1.328c0.185-0.199,0.364-0.403,0.545-0.607l-0.931-1.442l0.428-0.239l0.835,1.296
				c0.178-0.204,0.358-0.404,0.53-0.613l-0.983-1.417l0.419-0.254l0.881,1.269c0.17-0.212,0.339-0.425,0.503-0.64l-1.03-1.377
				l0.41-0.269l0.932,1.245c0.163-0.218,0.316-0.444,0.474-0.666l-1.077-1.34l0.4-0.281l0.971,1.207
				c0.154-0.223,0.308-0.447,0.458-0.674l-1.127-1.305l0.39-0.296l1.012,1.172c0.147-0.229,0.297-0.453,0.438-0.684l-1.175-1.27
				l0.38-0.31l1.055,1.141c0.139-0.233,0.273-0.47,0.407-0.707l-1.216-1.225l0.369-0.321l1.099,1.106
				c0.132-0.238,0.253-0.481,0.379-0.724l-1.258-1.181l0.356-0.336l1.133,1.063c0.123-0.242,0.246-0.483,0.363-0.727l-1.305-1.144
				l0.346-0.347l1.17,1.023c0.112-0.245,0.227-0.491,0.334-0.74l-1.342-1.096l0.333-0.358l1.212,0.986
				c0.104-0.25,0.2-0.505,0.3-0.759l-1.377-1.045l0.32-0.371l1.243,0.943c0.095-0.253,0.187-0.509,0.278-0.767l-1.415-0.997
				l0.307-0.382l1.271,0.896c0.086-0.256,0.179-0.51,0.26-0.77l-1.454-0.951l0.295-0.393l1.303,0.854
				c0.077-0.261,0.15-0.522,0.224-0.785l-1.479-0.895l0.28-0.402l1.337,0.81c0.069-0.263,0.127-0.53,0.189-0.795l-1.508-0.843
				l0.268-0.411l1.354,0.758c0.061-0.265,0.122-0.526,0.177-0.794l-1.542-0.792l0.251-0.42l1.38,0.708
				c0.051-0.266,0.1-0.533,0.144-0.801l-1.563-0.735l0.237-0.429l1.41,0.664c0.041-0.269,0.069-0.541,0.104-0.813l-1.582-0.678
				l0.224-0.436l1.423,0.609c0.03-0.269,0.063-0.538,0.087-0.81l-1.606-0.623l0.207-0.444l1.438,0.559
				c0.021-0.271,0.045-0.539,0.062-0.811l-1.627-0.567l0.19-0.45l1.464,0.509c0.011-0.271,0.014-0.544,0.021-0.816l-1.638-0.507
				l0.176-0.458l1.475,0.457c0.002-0.137,0.011-0.271,0.011-0.408s-0.009-0.27-0.011-0.405l-1.657-0.451l0.158-0.464l1.486,0.403
				c-0.007-0.27-0.01-0.542-0.021-0.811l-1.675-0.395l0.142-0.469l1.506,0.354c-0.017-0.272-0.04-0.543-0.062-0.813l-1.682-0.332
				l0.126-0.475l1.517,0.301c-0.024-0.271-0.056-0.541-0.087-0.81l-1.695-0.275l0.109-0.479l1.521,0.247
				c-0.034-0.268-0.062-0.539-0.103-0.805l-1.711-0.217l0.092-0.481l1.534,0.194c-0.044-0.27-0.093-0.535-0.145-0.802l-1.709-0.156
				l0.075-0.483l1.545,0.141c-0.053-0.268-0.116-0.532-0.175-0.797l-1.716-0.098l0.059-0.485l1.542,0.087
				c-0.062-0.265-0.119-0.529-0.188-0.79l-1.727-0.037l0.043-0.488l1.545,0.032c-0.072-0.262-0.146-0.523-0.223-0.783l-1.72,0.024
				l0.024-0.489l1.553-0.022c-0.081-0.261-0.174-0.515-0.261-0.773l-1.715,0.084l0.008-0.49l1.544-0.075
				c-0.09-0.257-0.183-0.512-0.278-0.766l-1.713,0.144l-0.009-0.489l1.535-0.128c-0.1-0.253-0.194-0.508-0.299-0.757l-1.709,0.203
				l-0.025-0.489l1.533-0.183c-0.109-0.25-0.223-0.496-0.338-0.744l-1.69,0.263l-0.044-0.488l1.525-0.235
				c-0.116-0.247-0.241-0.487-0.363-0.73l-1.68,0.319l-0.061-0.485l1.508-0.288c-0.124-0.24-0.246-0.483-0.375-0.721l-1.673,0.381
				l-0.077-0.484l1.495-0.34c-0.133-0.236-0.269-0.472-0.406-0.705l-1.65,0.436l-0.095-0.479l1.487-0.394
				c-0.143-0.232-0.294-0.459-0.441-0.688l-1.629,0.491l-0.11-0.478l1.466-0.441c-0.15-0.227-0.303-0.451-0.458-0.675l-1.61,0.549
				l-0.128-0.474l1.443-0.491c-0.157-0.22-0.31-0.443-0.471-0.66l-1.595,0.605l-0.144-0.469l1.425-0.541
				c-0.165-0.216-0.334-0.429-0.503-0.64l-1.563,0.655l-0.159-0.463l1.409-0.592c-0.173-0.21-0.355-0.413-0.532-0.619l-1.536,0.709
				l-0.177-0.457l1.379-0.637c-0.18-0.203-0.358-0.406-0.542-0.606l-1.513,0.765l-0.192-0.45l1.353-0.684
				c-0.186-0.196-0.37-0.396-0.561-0.588l-1.484,0.816l-0.208-0.444l1.332-0.731c-0.194-0.189-0.393-0.375-0.591-0.563l-1.448,0.864
				l-0.223-0.437l1.304-0.777c-0.2-0.185-0.405-0.362-0.609-0.541l-1.417,0.914l-0.238-0.429l1.27-0.819
				c-0.205-0.175-0.407-0.355-0.616-0.526l-1.39,0.965l-0.253-0.419l1.241-0.862c-0.212-0.169-0.423-0.338-0.64-0.502l-1.35,1.01
				l-0.27-0.41l1.217-0.909c-0.219-0.162-0.443-0.314-0.665-0.473l-1.312,1.054l-0.281-0.401l1.179-0.947
				c-0.224-0.154-0.448-0.305-0.675-0.453l-1.275,1.1l-0.295-0.39l1.141-0.986c-0.228-0.146-0.451-0.297-0.682-0.437l-1.241,1.147
				l-0.309-0.38l1.107-1.025c-0.232-0.139-0.469-0.272-0.705-0.406l-1.193,1.186l-0.322-0.369l1.077-1.068
				c-0.239-0.131-0.484-0.25-0.727-0.375l-1.149,1.225l-0.335-0.357l1.033-1.1c-0.242-0.121-0.483-0.244-0.729-0.359l-1.111,1.268
				l-0.346-0.346l0.991-1.134c-0.246-0.111-0.491-0.226-0.739-0.333l-1.064,1.305l-0.359-0.333l0.955-1.171
				c-0.251-0.105-0.505-0.2-0.758-0.299l-1.015,1.335l-0.369-0.32l0.91-1.201c-0.253-0.096-0.51-0.186-0.766-0.276l-0.967,1.371
				l-0.382-0.307l0.865-1.227c-0.256-0.087-0.509-0.18-0.768-0.261l-0.922,1.41l-0.393-0.294l0.822-1.256
				c-0.26-0.078-0.52-0.151-0.783-0.223l-0.865,1.431l-0.402-0.28l0.781-1.289c-0.264-0.068-0.53-0.123-0.795-0.186l-0.814,1.456
				l-0.411-0.268l0.729-1.304c-0.265-0.058-0.527-0.119-0.793-0.173l-0.765,1.487l-0.421-0.251l0.683-1.325
				c-0.268-0.05-0.532-0.1-0.801-0.145l-0.709,1.508l-0.429-0.236l0.636-1.354c-0.268-0.039-0.539-0.067-0.809-0.102l-0.652,1.522
				l-0.438-0.222l0.586-1.366c-0.27-0.029-0.538-0.058-0.81-0.084l-0.599,1.547l-0.445-0.206l0.536-1.379
				c-0.27-0.021-0.539-0.046-0.809-0.062l-0.545,1.565l-0.452-0.19l0.488-1.4c-0.271-0.011-0.543-0.014-0.814-0.02l-0.487,1.573
				l-0.458-0.176l0.438-1.41c-0.119-0.002-0.236-0.01-0.355-0.01C407.07,100.137,406.919,100.147,406.766,100.149"
            />
          </defs>
          <clipPath id="SVGIDA_407_">
            <use xlink:href="#SVGIDA_406_" style="overflow:visible;" />
          </clipPath>

          <radialGradient
            id="SVGIDA_408_"
            cx="-156.9995"
            cy="201"
            r="1"
            gradientTransform="matrix(37.8716 0 0 -37.8716 6353.0464 7750.2124)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#272726" />
            <stop offset="0.6946" style="stop-color:#272726" />
            <stop offset="0.9079" style="stop-color:#575756" />
            <stop offset="1" style="stop-color:#2E2D2C" />
          </radialGradient>
          <rect
            x="369.35"
            y="100.137"
            style="clip-path:url(#SVGIDA_407_);fill:url(#SVGIDA_408_);"
            :style="frontWheelClass"
            v-on:click="changeSeverity('frontWheel')"
            width="75.743"
            height="75.743"
          />
        </g>
        <g>
          <path
            style="fill:#D9D9D9;"
            :style="rearBumperClass"
            v-on:click="changeSeverity('rearBumper')"
            d="M107.509,7.108C89.683,9.904,72.1,13.225,52.475,16.671c-0.506,0.083-0.942,0.425-1.142,0.896
			c-0.282,0.61-0.141,1.329,0.33,1.8l2.447,2.447c-0.012,0.012-0.012,0.012-0.024,0.012l17.648,0.941L37.615,49.461
			c-6.894,1.824-11.154,2.071-17.731,2.412c-1.211,1.177-2.423,2.365-3.658,3.589c-3.848,3.813-6.036,9.013-6.036,14.437v22.118
			c-7.659,8.729-8.318,19.543-7.424,35.461c0.2,3.611,2.106,7.117,4.894,9.564l6.424,5.978c2.059,1.8,4.624,2.953,7.342,3.282
			l15.189,1.848l4.059,0.494c-0.165-2.659-0.282-5.377-0.282-8.39c0-24.966,19.883-45.202,44.414-45.202
			c24.53,0,44.414,20.236,44.414,45.202c0,4.989-0.118,9.695-0.612,14.261l0.706,0.047l3.423,0.012l31.224,0.215l3.176,0.012
			l0.624-0.012c-0.245-3.076-0.501-5.027-0.685-7.986l-0.002,0.196l-8.303-2.313c-7.734-0.088-14.746-4.073-18.756-10.659
			c-12.895-21.177-21.546-37.951-33.938-63.357c-2.587-5.305-3.309-11.403-2.033-17.17l0.767-3.468l0.213,0.047
			c-1.756-1.293-3.065-2.889-4.112-4.911c-0.588-1.141-0.906-2.399-1.023-3.683c-0.318-3.67-1.047-11.965-1.341-15.225
			c-0.083-1.012-0.071-2.034,0.129-3.034c0.647-3.271,1.286-5.985,4.251-7.339c1.47-0.683,3.973-1.984,5.573-2.185"
          />
          <path
            style="fill:#D9D9D9;"
            d="M105.156,50.107l-0.132-0.029c0.04,0.029,0.08,0.057,0.12,0.086L105.156,50.107z"
          />
          <path
            style="fill:#D9D9D9;"
            d="M167.078,146.646h-0.011c0.003,0.052,0.006,0.105,0.009,0.157L167.078,146.646z"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_409_"
              d="M19.884,51.874c6.577-0.341,10.836-0.589,17.731-2.412l34.119-26.696l-17.647-0.941
				C40.639,32.672,30.379,41.696,19.884,51.874"
            />
          </defs>
          <clipPath id="SVGIDA_410_">
            <use xlink:href="#SVGIDA_409_" style="overflow:visible;" />
          </clipPath>

          <linearGradient
            id="SVGIDA_411_"
            gradientUnits="userSpaceOnUse"
            x1="-157"
            y1="201"
            x2="-156"
            y2="201"
            gradientTransform="matrix(0 -30.0486 30.0486 0 -5993.9678 -4665.7632)"
          >
            <stop offset="0" style="stop-color:#41494A" />
            <stop offset="1" style="stop-color:#172225" />
          </linearGradient>
          <rect
            x="19.884"
            y="21.824"
            style="clip-path:url(#SVGIDA_410_);fill:url(#SVGIDA_411_);"
            width="51.85"
            height="30.05"
          />
        </g>
        <g>
          <path
            style="fill:#A71916;"
            d="M10.19,69.897v6.295l39.014,1.883l-5.659-13.555c-1.894-4.528-6.236-7.6-11.13-7.8
			c-7.907-0.341-13.977,0.224-20.084,4.142C10.931,63.639,10.19,66.732,10.19,69.897"
          />
          <path
            style="fill:#E31715;"
            d="M10.19,69.897v6.295l5.859,0.282c3.942-6.412,5.553-11.729,6.024-19.342
			c-3.412,0.564-6.577,1.694-9.742,3.729C10.931,63.639,10.19,66.732,10.19,69.897"
          />
          <path
            style="fill:#2A0D0E;"
            d="M47.941,77.189l-5.157-12.352c-1.775-4.244-5.859-7.108-10.405-7.295
			c-1.302-0.056-2.456-0.083-3.53-0.083c-6.787,0-11.409,1.153-15.883,3.975c-0.125,0.077-1.098,0.411-1.098,0.411
			c0.132-0.297,0.317-0.694,0.463-0.983c5.156-3.309,10.286-4.226,16.519-4.226c1.148,0,2.334,0.03,3.564,0.084
			c4.895,0.199,9.236,3.271,11.13,7.801l5.659,13.553l-39.014-1.882v-0.81L47.941,77.189z"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_412_"
              d="M18.891,64.06c-1.846-0.036-3.364,1.449-3.364,3.296v2.133c0,0.92,0.725,1.677,1.644,1.718l19.426,0.81
				c0.659,0.027,1.196-0.521,1.153-1.181c-0.259-4.003-3.514-7.157-7.523-7.292L18.891,64.06z"
            />
          </defs>
          <clipPath id="SVGIDA_413_">
            <use xlink:href="#SVGIDA_412_" style="overflow:visible;" />
          </clipPath>

          <linearGradient
            id="SVGIDA_414_"
            gradientUnits="userSpaceOnUse"
            x1="-157"
            y1="201"
            x2="-156"
            y2="201"
            gradientTransform="matrix(-22.2256 0 0 -22.2256 -3451.655 4535.1216)"
          >
            <stop offset="0" style="stop-color:#9F9F9F" />
            <stop offset="0.05" style="stop-color:#E4E4E3" />
            <stop offset="0.1" style="stop-color:#9F9F9F" />
            <stop offset="0.15" style="stop-color:#E4E4E3" />
            <stop offset="0.2" style="stop-color:#9F9F9F" />
            <stop offset="0.25" style="stop-color:#E4E4E3" />
            <stop offset="0.3" style="stop-color:#9F9F9F" />
            <stop offset="0.35" style="stop-color:#E4E4E3" />
            <stop offset="0.4" style="stop-color:#9F9F9F" />
            <stop offset="0.45" style="stop-color:#E4E4E3" />
            <stop offset="0.5" style="stop-color:#9F9F9F" />
            <stop offset="0.55" style="stop-color:#E4E4E3" />
            <stop offset="0.6" style="stop-color:#9F9F9F" />
            <stop offset="0.65" style="stop-color:#E4E4E3" />
            <stop offset="0.7" style="stop-color:#9F9F9F" />
            <stop offset="0.75" style="stop-color:#E4E4E3" />
            <stop offset="0.8" style="stop-color:#ADADAD" />
            <stop offset="0.85" style="stop-color:#E4E4E3" />
            <stop offset="0.9" style="stop-color:#ADADAD" />
            <stop offset="0.95" style="stop-color:#E4E4E3" />
            <stop offset="1" style="stop-color:#ADADAD" />
          </linearGradient>
          <rect
            x="15.527"
            y="63.543"
            style="clip-path:url(#SVGIDA_413_);fill:url(#SVGIDA_414_);"
            width="22.266"
            height="8.5"
          />
        </g>
        <g>
          <path
            style="fill:#2A0D0E;"
            d="M30.227,63.543c4.01,0.135,7.264,3.289,7.523,7.292c0.042,0.643-0.469,1.182-1.106,1.182
			c-0.016,0-0.031,0-0.047-0.001l-19.426-0.81c-0.919-0.04-1.644-0.797-1.644-1.718v-2.133c0-1.824,1.48-3.296,3.295-3.296
			c0.023,0,0.046,0,0.069,0L30.227,63.543z M30.22,62.365l-0.046,0.003l-11.305,0.516l-0.047-0.001
			c-2.466,0-4.472,2.007-4.472,4.473v2.133c0,1.555,1.217,2.824,2.772,2.893l19.426,0.81l0.072,0.002h0.024
			c0.629,0,1.237-0.263,1.667-0.723c0.431-0.459,0.654-1.082,0.614-1.711c-0.301-4.628-4.023-8.236-8.658-8.391L30.22,62.365z"
          />
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_415_"
                  x="10.19"
                  y="56.637"
                  width="39.014"
                  height="21.438"
                />
              </defs>
              <clipPath id="SVGIDA_416_">
                <use xlink:href="#SVGIDA_415_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_416_);">
                <defs>
                  <path
                    id="SVGIDA_417_"
                    d="M10.19,69.898v6.294l39.014,1.883l-5.659-13.554c-1.894-4.53-6.236-7.601-11.13-7.801
							c-7.907-0.341-13.977,0.224-20.084,4.142C10.931,63.639,10.19,66.733,10.19,69.898"
                  />
                </defs>
                <clipPath id="SVGIDA_418_">
                  <use xlink:href="#SVGIDA_417_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_419_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157"
                  y1="201.0713"
                  x2="-156"
                  y2="201.0713"
                  gradientTransform="matrix(-23.1893 23.1893 -23.1893 -23.1893 1060.6348 8361.7012)"
                >
                  <stop offset="0" style="stop-color:#000000" />
                  <stop offset="0.4854" style="stop-color:#9F9F9F" />
                  <stop offset="0.8117" style="stop-color:#000000" />
                  <stop offset="1" style="stop-color:#000000" />
                </linearGradient>
                <polygon
                  style="clip-path:url(#SVGIDA_418_);fill:url(#SVGIDA_419_);"
                  points="29.697,36.873 -0.658,67.228 29.697,97.582
						60.051,67.228 					"
                />
              </g>
            </g>
          </g>
          <path
            d="M19.672,52.08c6.23-0.323,10.953-0.587,17.987-2.448l0.064-0.031l34.49-26.986l-18.127-0.79l-0.339,0.274l17.508,0.819
			L37.534,49.3c-6.978,1.843-11.027,2.053-17.456,2.387L19.672,52.08z"
          />
          <g style="opacity:0.5;">
            <g>
              <defs>
                <rect
                  id="SVGIDA_420_"
                  x="48.81"
                  y="78.056"
                  width="10.815"
                  height="25.167"
                />
              </defs>
              <clipPath id="SVGIDA_421_">
                <use xlink:href="#SVGIDA_420_" style="overflow:visible;" />
              </clipPath>
              <polygon
                style="clip-path:url(#SVGIDA_421_);"
                points="59.33,103.223 59.625,103.014 49.201,78.074 48.811,78.056 				"
              />
            </g>
          </g>
          <path
            style="fill:none;stroke:#000000;stroke-width:0.257;stroke-miterlimit:10;"
            d="M99.275,77.444v6.002
			c0,2.556-2.091,4.646-4.647,4.646H80.558c-2.555,0-4.646-2.091-4.646-4.646v-6.002c0-2.556,2.091-4.646,4.646-4.646h14.071
			C97.185,72.798,99.275,74.889,99.275,77.444z"
          />
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_422_"
                  x="76.089"
                  y="78.862"
                  width="3.028"
                  height="3.167"
                />
              </defs>
              <clipPath id="SVGIDA_423_">
                <use xlink:href="#SVGIDA_422_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_423_);">
                <defs>
                  <path
                    id="SVGIDA_424_"
                    d="M79.117,80.442c0,0.875-1.294,1.587-2.889,1.587h-0.139v-3.167h0.139
							C77.823,78.862,79.117,79.574,79.117,80.442"
                  />
                </defs>
                <clipPath id="SVGIDA_425_">
                  <use xlink:href="#SVGIDA_424_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_426_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156.9995"
                  y1="201"
                  x2="-155.9995"
                  y2="201"
                  gradientTransform="matrix(0 -3.1675 -3.1675 0 714.265 -415.2647)"
                >
                  <stop offset="0" style="stop-color:#B3B3B2" />
                  <stop offset="0.4812" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#B3B3B2" />
                </linearGradient>
                <rect
                  x="76.089"
                  y="78.862"
                  style="clip-path:url(#SVGIDA_425_);fill:url(#SVGIDA_426_);"
                  width="3.028"
                  height="3.167"
                />
              </g>
            </g>
          </g>
          <path
            style="fill:#D9D9D9;"
            :style="frontBumperClass"
            v-on:click="changeSeverity('frontBumper')"
            d="M346.681,154.969l12.168,0.062l3.176,0.012l0.624-0.012c-0.447-5.624-0.941-10.53-0.941-16.625
			c0-24.966,20.389-45.202,45.543-45.202c25.166,0,45.555,20.236,45.555,45.202c0,4.977-0.951,9.683-2.188,14.235l0.694-0.022
			l3.671-0.294l41.308-3.247c3.53-0.271,5.647-4.036,4.071-7.201l-3.941-7.883l0.188-10.988h3.765c0.529,0,0.988-0.412,1.035-0.941
			c3.4-38.484-43.955-57.18-118.018-64.298c-2.213-0.212-4.436-0.411-6.694-0.6l-0.494-0.047l-3.965-0.388
			c-3.365-0.33-17.442-0.971-20.336-2.7l-13.537-6.489c3.883,2.694,7.13,6.235,9.436,10.354c1.636,2.941,2.835,5.812,4.118,9.589
			c9.997,14.731,4.665,49.855-4.113,78.456c-0.482,1.568-1.059,5.293-2.647,3.92"
          />
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_427_"
                  x="463.559"
                  y="111.675"
                  width="37.955"
                  height="11.33"
                />
              </defs>
              <clipPath id="SVGIDA_428_">
                <use xlink:href="#SVGIDA_427_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_428_);">
                <defs>
                  <path
                    id="SVGIDA_429_"
                    d="M463.559,111.675v5.354c9.813,0.635,16.59,1.012,22.272,4.541l10.777,1.436h3.765
							c0.529,0,0.988-0.412,1.035-0.941c0.047-0.541,0.094-1.082,0.105-1.623C491.655,115.298,479.595,112.604,463.559,111.675"
                  />
                </defs>
                <clipPath id="SVGIDA_430_">
                  <use xlink:href="#SVGIDA_429_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_431_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157.0005"
                  y1="200.999"
                  x2="-156.0005"
                  y2="200.999"
                  gradientTransform="matrix(-37.955 0 0 -37.955 -5457.4282 7746.2959)"
                >
                  <stop offset="0" style="stop-color:#E3E3E3" />
                  <stop offset="1" style="stop-color:#FFFFFF" />
                </linearGradient>
                <rect
                  x="463.559"
                  y="111.675"
                  style="clip-path:url(#SVGIDA_430_);fill:url(#SVGIDA_431_);"
                  width="37.955"
                  height="11.33"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_432_"
              d="M496.637,103.498l-5.912-2.259L496.637,103.498z"
            />
          </defs>
          <clipPath id="SVGIDA_433_">
            <use xlink:href="#SVGIDA_432_" style="overflow:visible;" />
          </clipPath>

          <linearGradient
            id="SVGIDA_434_"
            gradientUnits="userSpaceOnUse"
            x1="-157"
            y1="201"
            x2="-156"
            y2="201"
            gradientTransform="matrix(-5.911 0 0 -5.911 -431.3888 1290.479)"
          >
            <stop offset="0" style="stop-color:#D2D2D2" />
            <stop offset="1" style="stop-color:#FFFFFF" />
          </linearGradient>
          <rect
            x="490.725"
            y="101.239"
            style="clip-path:url(#SVGIDA_433_);fill:url(#SVGIDA_434_);"
            width="5.912"
            height="2.259"
          />
        </g>
        <g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_435_"
                  x="439.017"
                  y="76.72"
                  width="57.615"
                  height="26.778"
                />
              </defs>
              <clipPath id="SVGIDA_436_">
                <use xlink:href="#SVGIDA_435_" style="overflow:visible;" />
              </clipPath>
              <path
                style="clip-path:url(#SVGIDA_436_);fill:#666666;"
                d="M439.017,76.72c0.118,0.377,0.388,0.813,0.813,1.271
					c6,6.528,11.918,11.812,20.754,17.342c3.165,1.976,6.624,3.435,10.259,4.341c7.424,1.871,16.331,2.895,25.79,3.824l-5.906-2.259
					c-8.06-0.8-15.225-1.53-21.554-3.106c-3.083-0.776-6.036-2.023-8.73-3.706c-7.518-4.706-12.565-9.201-17.66-14.766
					c-1.388-1.506-0.835-2.588,1.2-2.388C442.322,77.085,440.664,76.897,439.017,76.72"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_437_"
                  x="488.808"
                  y="92.815"
                  width="7.83"
                  height="10.683"
                />
              </defs>
              <clipPath id="SVGIDA_438_">
                <use xlink:href="#SVGIDA_437_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_438_);">
                <defs>
                  <path
                    id="SVGIDA_439_"
                    d="M490.455,96.686c0.341,1.471,0.329,2.659,0.27,4.554l5.907,2.259c0.059-2.012-0.271-3.53-0.718-5.059
							c-1.224-1.953-2.647-3.824-4.259-5.624h-2.848C489.561,94.003,490.137,95.297,490.455,96.686"
                  />
                </defs>
                <clipPath id="SVGIDA_440_">
                  <use xlink:href="#SVGIDA_439_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_441_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157"
                  y1="201"
                  x2="-156"
                  y2="201"
                  gradientTransform="matrix(-7.8308 0 0 -7.8308 -732.7944 1672.1443)"
                >
                  <stop offset="0" style="stop-color:#D2D2D2" />
                  <stop offset="1" style="stop-color:#FFFFFF" />
                </linearGradient>
                <rect
                  x="488.808"
                  y="92.815"
                  style="clip-path:url(#SVGIDA_440_);fill:url(#SVGIDA_441_);"
                  width="7.882"
                  height="10.683"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_442_"
                  x="468.006"
                  y="121.827"
                  width="28.684"
                  height="21.379"
                />
              </defs>
              <clipPath id="SVGIDA_443_">
                <use xlink:href="#SVGIDA_442_" style="overflow:visible;" />
              </clipPath>
              <path
                style="clip-path:url(#SVGIDA_443_);fill:#7F8080;"
                d="M491.949,140.994c0.224,1.141-0.694,2.212-1.871,2.212h4.707
					c1.176,0,2.094-1.071,1.87-2.212c-1.848-9.283-10.53-14.542-25.248-18.93c-1.436-0.437-2.624-0.247-3.4,0.388
					C481.937,126.77,490.161,131.993,491.949,140.994"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_444_"
                  x="357.93"
                  y="89.227"
                  width="98.994"
                  height="65.815"
                />
              </defs>
              <clipPath id="SVGIDA_445_">
                <use xlink:href="#SVGIDA_444_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_445_);">
                <defs>
                  <path
                    id="SVGIDA_446_"
                    d="M357.93,138.359c0,6.105,0.472,11.13,0.918,16.671l3.177,0.012l0.624-0.012
							c-0.447-5.624-0.941-10.53-0.941-16.624c0-24.966,20.389-45.203,45.543-45.203c25.166,0,45.556,20.237,45.556,45.203
							c0,4.976-0.952,9.682-2.188,14.235l0.695-0.023l3.67-0.294c1.13-4.437,1.941-9.001,1.941-13.813
							c0-27.213-22.236-49.284-49.674-49.284C379.825,89.227,357.93,111.134,357.93,138.359"
                  />
                </defs>
                <clipPath id="SVGIDA_447_">
                  <use xlink:href="#SVGIDA_446_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_448_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157"
                  y1="200.999"
                  x2="-156"
                  y2="200.999"
                  gradientTransform="matrix(0 -65.8152 65.8152 0 -12821.4229 -10177.9434)"
                >
                  <stop offset="0" style="stop-color:#000000" />
                  <stop offset="0.1255" style="stop-color:#000000" />
                  <stop offset="1" style="stop-color:#9D9D9C" />
                </linearGradient>
                <rect
                  x="357.93"
                  y="89.227"
                  style="clip-path:url(#SVGIDA_447_);fill:url(#SVGIDA_448_);"
                  width="98.994"
                  height="65.815"
                />
              </g>
            </g>
          </g>
          <path
            d="M443.962,77.448l0.039-0.351c-37.988-4.262-66.383-7.28-92.065-9.788l-0.034,0.351
			C377.582,70.168,405.975,73.188,443.962,77.448"
          />
          <polygon
            points="380.557,70.471 380.875,70.318 374.527,57.029 374.127,57.009 		"
          />
          <g style="opacity:0.5;">
            <g>
              <defs>
                <rect
                  id="SVGIDA_449_"
                  x="435.471"
                  y="90.5"
                  width="19.485"
                  height="12.658"
                />
              </defs>
              <clipPath id="SVGIDA_450_">
                <use xlink:href="#SVGIDA_449_" style="overflow:visible;" />
              </clipPath>
              <polygon
                style="clip-path:url(#SVGIDA_450_);"
                points="435.777,103.158 454.956,90.796 454.766,90.5 435.471,102.916 				"
              />
            </g>
          </g>
          <path
            d="M490.712,101.41c-7.806-0.772-15.18-1.505-21.582-3.109c-3.128-0.784-6.084-2.039-8.784-3.729
			c-6.885-4.304-12.013-8.59-17.699-14.792c-0.721-0.786-0.973-1.507-0.71-2.031c0.264-0.524,0.998-0.757,2.062-0.647
			c22.084,2.241,34.279,5.833,42.092,12.395c2.3,1.933,3.91,4.47,4.535,7.146c0.349,1.488,0.333,2.717,0.281,4.598l-0.006,0.189
			L490.712,101.41z M443.962,77.453c-0.897-0.09-1.52,0.075-1.71,0.454c-0.189,0.378,0.049,0.974,0.654,1.634
			c5.664,6.179,10.77,10.446,17.626,14.733c2.67,1.669,5.592,2.908,8.685,3.683c6.325,1.587,13.618,2.318,21.342,3.084
			c0.049-1.796,0.051-2.918-0.276-4.318c-0.608-2.603-2.178-5.072-4.42-6.956C478.11,83.253,465.971,79.687,443.962,77.453"
          />
          <polygon
            points="489.023,93.027 491.844,93.027 491.527,92.674 488.891,92.674 		"
          />
          <path
            style="fill:#D9D9D9;"
            :style="frontDoorClass"
            v-on:click="changeSeverity('frontDoor')"
            d="M353.756,70.97l-0.109,0.009l0.002-0.13l-66.119-6.333l-69.489-4.846l-0.21,0.068
			c6.393,32.617,6.522,47.302,3.529,83.162h-0.012l-0.004,0.353l125.479,1.511v-0.012l0.138,0.041
			C356.398,112.642,358.877,84.807,353.756,70.97"
          />
          <path
            style="fill:#333333;"
            d="M218.196,60.131c48.391,2.742,89.819,6.062,135.78,10.848c-1.291-4.053-3.1-6.898-4.745-10.055
			c-2.322-4.419-5.592-8.22-9.5-11.111c-25.158-18.636-44.24-28.661-72.75-36.854c-5.557-1.604-11.253-2.613-16.986-3.093
			c-19.245-1.602-26.178-1.439-42.061-1.439 M343.994,64.084c-38.563-3.909-74.378-6.903-110.843-9.203l-11.576-40.726
			c8.698,0.388,17.89,0.988,27.918,1.822c5.458,0.457,10.777,1.425,15.807,2.876c26.972,7.752,45.501,17.146,70.818,35.899
			c3.186,2.356,5.855,5.48,7.724,9.038C343.894,63.889,343.944,63.985,343.994,64.084"
          />
          <path
            style="fill:#1A1A1A;"
            d="M218.872,34.86c0.816-6.374,4.415-10.885,7.196-10.81c0.903,0.023,4.634,1.862,4.634,1.862
			l-0.001,0.001c2.741,1.37,4.426,6.164,3.662,12.138c-0.669,5.23-2.948,9.317-5.498,10.48l4.546,9.293v0.699l-12.106,0.349
			l-1.941-14.115l1.041,0.375C218.985,42.908,218.332,39.082,218.872,34.86"
          />
          <path
            style="fill:#262626;"
            d="M308.067,69.481l9.478-22.277c0.444-1.044,1.662-1.534,2.706-1.09s1.535,1.662,1.091,2.706
			l-2.911,6.843l1.041,0.413l2.894-6.953c0.162-0.393,0.563-0.642,0.987-0.618c2.725,0.148,11.963-1.976,20.642,4.276
			c4.591,3.308,10.226,20.188,10.226,20.188l-40.307-3.535l0.419-1.005l-1.364,0.075l-1.103,2.593
			c-0.444,1.045-1.662,1.535-2.706,1.091S307.624,70.525,308.067,69.481"
          />
          <g style="opacity:0.4;">
            <g>
              <defs>
                <rect
                  id="SVGIDA_451_"
                  x="207.421"
                  y="6.687"
                  width="143.604"
                  height="59.248"
                />
              </defs>
              <clipPath id="SVGIDA_452_">
                <use xlink:href="#SVGIDA_451_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_452_);">
                <defs>
                  <path
                    id="SVGIDA_453_"
                    d="M216.979,55.66c48.907,2.564,87.729,5.75,134.045,10.274c-1.283-3.776-2.483-6.647-4.118-9.589
							c-2.307-4.118-5.554-7.659-9.437-10.354c-24.989-17.365-43.943-26.707-72.263-34.342c-5.518-1.495-11.177-2.437-16.871-2.884
							c-15.555-1.214-27.816-1.858-40.915-2.08"
                  />
                </defs>
                <clipPath id="SVGIDA_454_">
                  <use xlink:href="#SVGIDA_453_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_455_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157"
                  y1="201"
                  x2="-156"
                  y2="201"
                  gradientTransform="matrix(-65.435 65.435 -65.435 -65.435 3183.0137 23437.3984)"
                >
                  <stop offset="0" style="stop-color:#AFCACA" />
                  <stop offset="0.2552" style="stop-color:#4A7480" />
                  <stop offset="0.5356" style="stop-color:#AFCACA" />
                  <stop offset="0.7615" style="stop-color:#4A7480" />
                  <stop offset="1" style="stop-color:#AFCACA" />
                </linearGradient>
                <polygon
                  style="clip-path:url(#SVGIDA_454_);fill:url(#SVGIDA_455_);"
                  points="279.223,-65.114 177.797,36.311 279.223,137.736
						380.648,36.311 					"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_456_"
              d="M216.805,53.84l-8.866-45.389c15.523,0.002,20.927,0.566,40.26,2.076
				c5.709,0.447,11.275,1.397,16.547,2.825c27.34,7.372,46.106,16.292,71.717,34.09c3.674,2.55,6.752,5.926,8.903,9.766
				c1.151,2.074,2.098,4.129,3.063,6.701C268.84,56.19,216.805,53.84,216.805,53.84 M216.98,55.66c0,0,60.098,3.051,134.044,10.273
				c-1.283-3.775-2.483-6.646-4.119-9.588c-2.306-4.118-5.553-7.659-9.436-10.354c-24.989-17.365-43.943-26.706-72.263-34.342
				c-5.518-1.495-11.177-2.437-16.871-2.884c-19.116-1.49-25.139-2.081-40.915-2.081L216.98,55.66z"
            />
          </defs>
          <clipPath id="SVGIDA_457_">
            <use xlink:href="#SVGIDA_456_" style="overflow:visible;" />
          </clipPath>

          <linearGradient
            id="SVGIDA_458_"
            gradientUnits="userSpaceOnUse"
            x1="-157"
            y1="201"
            x2="-156"
            y2="201"
            gradientTransform="matrix(-65.435 65.435 -65.435 -65.435 3183.0137 23437.3984)"
          >
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="0.1088" style="stop-color:#B1B1B1" />
            <stop offset="0.2176" style="stop-color:#FFFFFF" />
            <stop offset="0.3598" style="stop-color:#B1B1B1" />
            <stop offset="0.4435" style="stop-color:#FFFFFF" />
            <stop offset="0.523" style="stop-color:#B1B1B1" />
            <stop offset="0.5983" style="stop-color:#FFFFFF" />
            <stop offset="0.6946" style="stop-color:#B1B1B1" />
            <stop offset="0.7615" style="stop-color:#FFFFFF" />
            <stop offset="0.8536" style="stop-color:#B1B1B1" />
            <stop offset="0.9247" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#B1B1B1" />
          </linearGradient>
          <polygon
            style="clip-path:url(#SVGIDA_457_);fill:url(#SVGIDA_458_);"
            points="279.223,-65.115 177.797,36.31 279.223,137.735
			380.648,36.31 		"
          />
        </g>
        <g>
          <path
            style="fill:none;stroke:#000000;stroke-width:0.367;stroke-miterlimit:10;"
            d="M207.934,8.426l-0.068,0.026
			c15.579,0,20.969,0.563,40.333,2.074c5.709,0.448,11.277,1.399,16.548,2.826c27.341,7.372,46.107,16.292,71.717,34.089
			c3.675,2.551,6.753,5.928,8.902,9.767c1.153,2.073,2.099,4.13,3.064,6.701c-79.59-7.72-131.625-10.069-131.625-10.069
			 M216.979,55.66c0,0,60.099,3.051,134.044,10.274c-1.282-3.777-2.482-6.646-4.118-9.589c-2.306-4.118-5.553-7.659-9.435-10.353
			c-24.99-17.366-43.944-26.708-72.264-34.344c-5.518-1.494-11.177-2.436-16.871-2.883c-19.116-1.491-25.139-2.08-40.916-2.08"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_459_"
              d="M216.805,53.84c3.859,0.212,7.706,0.423,11.553,0.647L215.323,8.626c-2.495-0.083-4.954-0.153-7.389-0.2
				L216.805,53.84z"
            />
          </defs>
          <clipPath id="SVGIDA_460_">
            <use xlink:href="#SVGIDA_459_" style="overflow:visible;" />
          </clipPath>

          <linearGradient
            id="SVGIDA_461_"
            gradientUnits="userSpaceOnUse"
            x1="-156.9995"
            y1="201"
            x2="-155.9995"
            y2="201"
            gradientTransform="matrix(0 -46.0612 46.0612 0 -9040.1631 -7177.104)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.2845" style="stop-color:#4E4D4D" />
            <stop offset="0.7866" style="stop-color:#1A1A1A" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </linearGradient>
          <rect
            x="207.934"
            y="8.426"
            style="clip-path:url(#SVGIDA_460_);fill:url(#SVGIDA_461_);"
            width="20.424"
            height="46.062"
          />
        </g>
        <g>
          <path
            style="fill:#1A1A1A;"
            d="M324.928,39.733l2.2,22.178c7.012,0.635,14.107,1.307,21.295,2
			c-0.964-2.577-1.905-4.624-3.059-6.707c-2.153-3.835-5.224-7.212-8.906-9.765C332.47,44.663,328.646,42.11,324.928,39.733"
          />
          <path
            style="fill:#F1F1F1;"
            d="M339.487,56.226c0,2.7-2.188,4.888-4.889,4.888c-2.699,0-4.888-2.188-4.888-4.888
			s2.188-4.888,4.888-4.888C337.299,51.338,339.487,53.525,339.487,56.226"
          />
          <path
            style="fill:#F1F1F1;"
            d="M319.071,60.617c-0.014,0.745,0.58,1.362,1.325,1.378c2.297,0.048,4.771,0.012,7.397-0.152
			c1.375-0.086,2.702-0.201,3.981-0.338c2.664-0.287,4.751-2.429,4.964-5.1c0.01-0.122,0.019-0.246,0.026-0.371
			c0.133-2.254-0.166-4.159-0.505-5.544c-0.081-0.332-0.186-0.654-0.317-0.968c-0.285-0.674-0.685-1.462-1.249-2.287
			c-0.007-0.01-0.014-0.021-0.021-0.031c-1.373-1.995-3.574-3.317-5.981-3.591c-0.906-0.103-1.927-0.097-3.026,0.114
			c-1.085,0.208-2.019,0.572-2.801,0.982c-1.694,0.894-2.806,2.59-3.024,4.493c-0.2,1.728-0.37,3.526-0.5,5.394
			C319.194,56.684,319.109,58.693,319.071,60.617"
          />
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_462_"
                  x="227.779"
                  y="73.08"
                  width="28.806"
                  height="4.955"
                />
              </defs>
              <clipPath id="SVGIDA_463_">
                <use xlink:href="#SVGIDA_462_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_463_);">
                <defs>
                  <path
                    id="SVGIDA_464_"
                    d="M230.596,78.035l24.292-0.191c1.202-0.009,1.935-1.089,1.626-2.398
							c-0.308-1.311-1.544-2.374-2.746-2.365l-24.293,0.191c-1.202,0.009-1.934,1.089-1.626,2.398
							C228.158,76.98,229.393,78.044,230.596,78.035"
                  />
                </defs>
                <clipPath id="SVGIDA_465_">
                  <use xlink:href="#SVGIDA_464_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_466_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157"
                  y1="201"
                  x2="-156"
                  y2="201"
                  gradientTransform="matrix(0 -4.9548 4.9548 0 -753.7303 -699.8665)"
                >
                  <stop offset="0" style="stop-color:#7F8080" />
                  <stop offset="0.3891" style="stop-color:#FFFFFF" />
                  <stop offset="0.6527" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#7F8080" />
                </linearGradient>
                <rect
                  x="227.541"
                  y="73.071"
                  style="clip-path:url(#SVGIDA_465_);fill:url(#SVGIDA_466_);"
                  width="29.282"
                  height="4.973"
                />
              </g>
              <g style="clip-path:url(#SVGIDA_463_);">
                <g>
                  <defs>
                    <rect
                      id="SVGIDA_467_"
                      x="227.779"
                      y="73.08"
                      width="28.806"
                      height="4.955"
                    />
                  </defs>
                  <clipPath id="SVGIDA_468_">
                    <use xlink:href="#SVGIDA_467_" style="overflow:visible;" />
                  </clipPath>
                  <g style="clip-path:url(#SVGIDA_468_);">
                    <defs>
                      <path
                        id="SVGIDA_469_"
                        d="M230.596,78.035l24.292-0.191c1.202-0.009,1.935-1.089,1.626-2.398
									c-0.308-1.311-1.544-2.374-2.746-2.365l-24.293,0.191c-1.202,0.009-1.934,1.089-1.626,2.398
									C228.158,76.98,229.393,78.044,230.596,78.035"
                      />
                    </defs>
                    <clipPath id="SVGIDA_470_">
                      <use
                        xlink:href="#SVGIDA_469_"
                        style="overflow:visible;"
                      />
                    </clipPath>

                    <linearGradient
                      id="SVGIDA_471_"
                      gradientUnits="userSpaceOnUse"
                      x1="-157"
                      y1="201"
                      x2="-156"
                      y2="201"
                      gradientTransform="matrix(28.8062 0 0 28.8062 4750.3569 -5714.4824)"
                    >
                      <stop offset="0" style="stop-color:#C6C6C6" />
                      <stop offset="0.2" style="stop-color:#FFFFFF" />
                      <stop offset="0.8" style="stop-color:#FFFFFF" />
                      <stop offset="1" style="stop-color:#C6C6C6" />
                    </linearGradient>
                    <rect
                      x="227.541"
                      y="73.071"
                      style="clip-path:url(#SVGIDA_470_);fill:url(#SVGIDA_471_);"
                      width="29.282"
                      height="4.973"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_472_"
                  x="235.747"
                  y="77.876"
                  width="14.88"
                  height="3.718"
                />
              </defs>
              <clipPath id="SVGIDA_473_">
                <use xlink:href="#SVGIDA_472_" style="overflow:visible;" />
              </clipPath>
              <path
                style="clip-path:url(#SVGIDA_473_);fill:#CCCCCC;"
                d="M250.618,77.876l-14.871,0.118c0.835,2.06,2.882,3.612,4.87,3.601
					l6.835-0.06C249.453,81.523,250.747,79.936,250.618,77.876"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_474_"
                  x="234.547"
                  y="69.229"
                  width="14.989"
                  height="4"
                />
              </defs>
              <clipPath id="SVGIDA_475_">
                <use xlink:href="#SVGIDA_474_" style="overflow:visible;" />
              </clipPath>
              <path
                style="clip-path:url(#SVGIDA_475_);fill:#CCCCCC;"
                d="M234.583,73.229l14.954-0.118c-0.765-2.2-2.895-3.906-4.977-3.882
					l-6.836,0.047C235.641,69.299,234.312,71.029,234.583,73.229"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_476_"
                  x="319.071"
                  y="43.548"
                  width="17.727"
                  height="18.467"
                />
              </defs>
              <clipPath id="SVGIDA_477_">
                <use xlink:href="#SVGIDA_476_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_477_);">
                <defs>
                  <path
                    id="SVGIDA_478_"
                    d="M319.071,60.617c-0.015,0.745,0.58,1.363,1.326,1.378c2.297,0.048,4.77,0.011,7.396-0.153
							c1.375-0.086,2.703-0.201,3.981-0.338c2.664-0.287,4.752-2.428,4.964-5.098c0.01-0.123,0.019-0.247,0.025-0.372
							c0.135-2.254-0.165-4.159-0.504-5.544c-0.081-0.331-0.185-0.654-0.317-0.968c-0.284-0.675-0.685-1.463-1.248-2.287
							c-0.008-0.011-0.015-0.021-0.022-0.031c-1.373-1.995-3.574-3.317-5.98-3.591c-0.906-0.104-1.928-0.097-3.026,0.113
							c-1.084,0.209-2.019,0.572-2.8,0.984c-1.696,0.892-2.807,2.589-3.026,4.492c-0.199,1.727-0.369,3.527-0.5,5.393
							C319.195,56.683,319.109,58.693,319.071,60.617"
                  />
                </defs>
                <clipPath id="SVGIDA_479_">
                  <use xlink:href="#SVGIDA_478_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_480_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157.0005"
                  y1="201"
                  x2="-156.0005"
                  y2="201"
                  gradientTransform="matrix(17.7264 0 0 -17.7264 3102.1199 3615.7871)"
                >
                  <stop offset="0" style="stop-color:#C6C6C6" />
                  <stop offset="0.2427" style="stop-color:#FFFFFF" />
                  <stop offset="0.4017" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#C6C6C6" />
                </linearGradient>
                <rect
                  x="319.057"
                  y="43.51"
                  style="clip-path:url(#SVGIDA_479_);fill:url(#SVGIDA_480_);"
                  width="17.843"
                  height="18.533"
                />
              </g>
              <g style="clip-path:url(#SVGIDA_477_);">
                <g>
                  <defs>
                    <rect
                      id="SVGIDA_481_"
                      x="319.071"
                      y="43.548"
                      width="17.727"
                      height="18.467"
                    />
                  </defs>
                  <clipPath id="SVGIDA_482_">
                    <use xlink:href="#SVGIDA_481_" style="overflow:visible;" />
                  </clipPath>
                  <g style="clip-path:url(#SVGIDA_482_);">
                    <defs>
                      <path
                        id="SVGIDA_483_"
                        d="M319.071,60.617c-0.015,0.745,0.58,1.363,1.326,1.378c2.297,0.048,4.77,0.011,7.396-0.153
									c1.375-0.086,2.703-0.201,3.981-0.338c2.664-0.287,4.752-2.428,4.964-5.098c0.01-0.123,0.019-0.247,0.025-0.372
									c0.135-2.254-0.165-4.159-0.504-5.544c-0.081-0.331-0.185-0.654-0.317-0.968c-0.284-0.675-0.685-1.463-1.248-2.287
									c-0.008-0.011-0.015-0.021-0.022-0.031c-1.373-1.995-3.574-3.317-5.98-3.591c-0.906-0.104-1.928-0.097-3.026,0.113
									c-1.084,0.209-2.019,0.572-2.8,0.984c-1.696,0.892-2.807,2.589-3.026,4.492c-0.199,1.727-0.369,3.527-0.5,5.393
									C319.195,56.683,319.109,58.693,319.071,60.617"
                      />
                    </defs>
                    <clipPath id="SVGIDA_484_">
                      <use
                        xlink:href="#SVGIDA_483_"
                        style="overflow:visible;"
                      />
                    </clipPath>

                    <linearGradient
                      id="SVGIDA_485_"
                      gradientUnits="userSpaceOnUse"
                      x1="-157"
                      y1="200.998"
                      x2="-156"
                      y2="200.998"
                      gradientTransform="matrix(0 -18.4665 -18.4665 0 4039.7051 -2837.2288)"
                    >
                      <stop offset="0" style="stop-color:#C6C6C6" />
                      <stop offset="0.2845" style="stop-color:#FFFFFF" />
                      <stop offset="1" style="stop-color:#C6C6C6" />
                    </linearGradient>
                    <rect
                      x="319.057"
                      y="43.51"
                      style="clip-path:url(#SVGIDA_484_);fill:url(#SVGIDA_485_);"
                      width="17.843"
                      height="18.533"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_486_"
                  x="333.552"
                  y="51.734"
                  width="5.931"
                  height="9.377"
                />
              </defs>
              <clipPath id="SVGIDA_487_">
                <use xlink:href="#SVGIDA_486_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_487_);">
                <defs>
                  <path
                    id="SVGIDA_488_"
                    d="M333.552,61.005c0.341,0.071,0.684,0.106,1.047,0.106c2.695,0,4.884-2.188,4.884-4.884
							c0-2.022-1.225-3.753-2.966-4.493c0.212,1.199,0.342,2.658,0.247,4.294c-0.012,0.13-0.012,0.259-0.022,0.377
							C336.576,58.44,335.317,60.17,333.552,61.005"
                  />
                </defs>
                <clipPath id="SVGIDA_489_">
                  <use xlink:href="#SVGIDA_488_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_490_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156.9995"
                  y1="201"
                  x2="-155.9995"
                  y2="201"
                  gradientTransform="matrix(0 -9.3769 9.3769 0 -1548.2456 -1411.0679)"
                >
                  <stop offset="0" style="stop-color:#C6C6C6" />
                  <stop offset="0.2427" style="stop-color:#FFFFFF" />
                  <stop offset="0.4017" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#C6C6C6" />
                </linearGradient>
                <rect
                  x="333.552"
                  y="51.734"
                  style="clip-path:url(#SVGIDA_489_);fill:url(#SVGIDA_490_);"
                  width="5.931"
                  height="9.377"
                />
              </g>
            </g>
          </g>
          <polyline
            points="221.298,143.266 346.905,144.776 346.909,144.424 221.302,142.913 		"
          />
          <path
            d="M347.248,144.491c10.823-36.868,12.359-67.745,3.914-78.664l-0.279,0.216c8.379,10.832,6.818,41.585-3.974,78.348
			L347.248,144.491z"
          />
          <path
            d="M221.659,143.024c3.004-35.96,2.072-54.753-4.333-87.433l-9.581-49.065h-0.521l9.755,49.134
			c6.398,32.642,7.329,51.415,4.328,87.335L221.659,143.024z"
          />
          <path
            style="fill:#D9D9D9;"
            :style="backDoorClass"
            v-on:click="changeSeverity('backDoor')"
            d="M139.571,131.746c-12.888-21.165-21.535-37.932-33.922-63.328
			c-2.553-5.234-3.265-11.25-2.006-16.939l0.755-3.41c1.42,1.021,3.121,1.856,5.252,2.532c2.541,0.813,5.212,1.188,7.871,1.26
			c36.316,0.937,68.909,2.229,99.639,3.895l-0.153,0.031c6.391,32.607,7.326,51.377,4.337,87.225l-63.314-0.774
			C150.417,142.149,143.518,138.228,139.571,131.746"
          />
          <path
            style="fill:#333333;"
            d="M207.803,6.635l-9.471,0.864c-28.351,0-54.519,2.489-89.859,7.256
			c-1.611,0.215-3.21,0.631-4.69,1.364c-2.985,1.451-4.549,3.383-5.2,6.893c-0.202,1.073-0.213,2.172-0.131,3.258
			c0.297,3.497,1.031,12.398,1.351,16.338c0.118,1.376,0.438,2.728,1.03,3.952c1.919,3.951,4.655,6.426,9.547,8.08
			c2.559,0.871,5.248,1.275,7.924,1.351c37.308,1.027,68.074,2.295,99.565,4.137 M209.202,13.876l7.638,40.32
			c-27.427-1.613-50.59-2.853-80.571-3.808l-4.065-32.461c22.751-2.658,43.819-4.295,66.124-4.295h0.001
			C203.383,13.633,203.917,13.714,209.202,13.876 M104.572,24.15c0.297-1.601,0.618-1.903,1.863-2.51
			c0.797-0.394,1.74-0.659,2.838-0.805c6.659-0.898,13.108-1.729,19.426-2.49l3.999,31.93c-4.693-0.145-9.43-0.285-14.227-0.417
			c-2.251-0.063-4.318-0.41-6.137-1.028c-3.619-1.225-4.948-2.746-6.024-4.965c-0.222-0.458-0.374-1.079-0.435-1.787
			c-0.317-3.914-1.053-12.827-1.349-16.329C104.479,25.128,104.493,24.573,104.572,24.15"
          />
          <g style="opacity:0.4;">
            <g>
              <defs>
                <rect
                  id="SVGIDA_491_"
                  x="97.763"
                  y="6.372"
                  width="119.252"
                  height="49.304"
                />
              </defs>
              <clipPath id="SVGIDA_492_">
                <use xlink:href="#SVGIDA_491_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_492_);">
                <defs>
                  <path
                    id="SVGIDA_493_"
                    d="M207.456,6.564c-34.196-0.932-58.616,1.563-99.692,6.761c-1.6,0.2-3.188,0.588-4.659,1.271
							c-2.965,1.353-4.518,3.153-5.165,6.423c-0.2,1-0.212,2.024-0.129,3.036c0.294,3.26,1.023,11.554,1.341,15.225
							c0.118,1.282,0.435,2.541,1.024,3.683c1.906,3.682,4.623,5.988,9.482,7.53c2.542,0.811,5.212,1.188,7.871,1.258
							c46.399,1.198,61.371,1.528,99.486,3.926"
                  />
                </defs>
                <clipPath id="SVGIDA_494_">
                  <use xlink:href="#SVGIDA_493_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_495_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157"
                  y1="201.0469"
                  x2="-156"
                  y2="201.0469"
                  gradientTransform="matrix(-72.3584 72.3584 -72.3584 -72.3584 3381.6138 25901.2188)"
                >
                  <stop offset="0" style="stop-color:#AFCACA" />
                  <stop offset="0.2552" style="stop-color:#4A7480" />
                  <stop offset="0.5356" style="stop-color:#AFCACA" />
                  <stop offset="0.7615" style="stop-color:#4A7480" />
                  <stop offset="1" style="stop-color:#AFCACA" />
                </linearGradient>
                <polygon
                  style="clip-path:url(#SVGIDA_494_);fill:url(#SVGIDA_495_);"
                  points="157.372,-54.011 72.707,30.654 157.372,115.319
						242.037,30.654 					"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <rect
              id="SVGIDA_496_"
              x="102.815"
              y="30.096"
              transform="matrix(-0.1242 -0.9923 0.9923 -0.1242 106.7544 157.9432)"
              width="40.525"
              height="3.53"
            />
          </defs>
          <clipPath id="SVGIDA_497_">
            <use xlink:href="#SVGIDA_496_" style="overflow:visible;" />
          </clipPath>

          <linearGradient
            id="SVGIDA_498_"
            gradientUnits="userSpaceOnUse"
            x1="-157"
            y1="201"
            x2="-156"
            y2="201"
            gradientTransform="matrix(0 -40.6501 40.6501 0 -8047.5776 -6329.8691)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.2845" style="stop-color:#4E4D4D" />
            <stop offset="0.7866" style="stop-color:#1A1A1A" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </linearGradient>
          <rect
            x="118.809"
            y="11.536"
            style="clip-path:url(#SVGIDA_497_);fill:url(#SVGIDA_498_);"
            width="8.537"
            height="40.649"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_499_"
              d="M197.02,6.564c-28.161-0.001-54.154,2.318-89.256,6.761c-1.6,0.2-3.188,0.588-4.659,1.271
				c-2.965,1.353-4.518,3.152-5.165,6.424c-0.2,1-0.211,2.023-0.129,3.035c0.294,3.26,1.023,11.555,1.341,15.225
				c0.118,1.282,0.435,2.542,1.024,3.683c1.905,3.683,4.623,5.988,9.482,7.529c2.542,0.812,5.212,1.188,7.872,1.259
				c91.616,2.366,99.485,3.926,99.485,3.926l-0.175-1.819l-99.265-3.87c-2.676-0.071-5.16-0.468-7.379-1.177
				c-4.256-1.349-6.704-3.278-8.453-6.658c-0.448-0.869-0.729-1.891-0.834-3.033c-0.316-3.663-1.046-11.961-1.341-15.222
				c-0.078-0.962-0.045-1.794,0.103-2.531c0.517-2.615,1.646-4.015,4.167-5.164c1.192-0.552,2.582-0.93,4.145-1.125
				c32.01-4.05,66.716-6.336,89.034-6.747c2.738-0.05,10.953,0.113,10.953,0.113l-0.513-1.878H197.02z"
            />
          </defs>
          <clipPath id="SVGIDA_500_">
            <use xlink:href="#SVGIDA_499_" style="overflow:visible;" />
          </clipPath>

          <linearGradient
            id="SVGIDA_501_"
            gradientUnits="userSpaceOnUse"
            x1="-157"
            y1="201.0439"
            x2="-156"
            y2="201.0439"
            gradientTransform="matrix(-72.3584 72.3584 -72.3584 -72.3584 3381.6138 25901.2188)"
          >
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="0.1088" style="stop-color:#B1B1B1" />
            <stop offset="0.2176" style="stop-color:#FFFFFF" />
            <stop offset="0.3598" style="stop-color:#B1B1B1" />
            <stop offset="0.4435" style="stop-color:#FFFFFF" />
            <stop offset="0.523" style="stop-color:#B1B1B1" />
            <stop offset="0.5983" style="stop-color:#FFFFFF" />
            <stop offset="0.6946" style="stop-color:#B1B1B1" />
            <stop offset="0.7615" style="stop-color:#FFFFFF" />
            <stop offset="0.8536" style="stop-color:#B1B1B1" />
            <stop offset="0.9247" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#B1B1B1" />
          </linearGradient>
          <polygon
            style="clip-path:url(#SVGIDA_500_);fill:url(#SVGIDA_501_);"
            points="157.372,-53.08 73.172,31.119 157.372,115.319
			241.571,31.119 		"
          />
        </g>
        <g>
          <path
            style="fill:none;stroke:#000000;stroke-width:0.367;stroke-miterlimit:10;"
            d="M216.84,53.856l-99.266-3.87
			c-2.676-0.071-5.159-0.467-7.379-1.176c-4.255-1.35-6.703-3.279-8.453-6.66c-0.448-0.868-0.728-1.89-0.833-3.033
			c-0.317-3.663-1.047-11.961-1.341-15.221c-0.078-0.961-0.045-1.794,0.102-2.531c0.518-2.615,1.647-4.014,4.167-5.164
			c1.192-0.553,2.583-0.93,4.145-1.125c32.01-4.051,66.716-6.336,89.035-6.748c2.737-0.05,10.952,0.114,10.952,0.114l-0.513-1.879
			H197.02c-28.16,0-54.153,2.32-89.255,6.761c-1.6,0.2-3.189,0.589-4.659,1.271c-2.965,1.353-4.518,3.152-5.165,6.424
			c-0.2,1-0.212,2.023-0.13,3.035c0.294,3.259,1.024,11.554,1.341,15.225c0.118,1.282,0.436,2.541,1.024,3.682
			c1.906,3.684,4.624,5.989,9.483,7.53c2.541,0.813,5.212,1.189,7.871,1.259c91.616,2.365,99.486,3.927,99.486,3.927"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDA_502_"
              d="M205.64,53.268c3.741,0.189,7.482,0.39,11.2,0.589l-8.87-45.414c-2.424-0.06-4.812-0.083-7.178-0.095
				L205.64,53.268z"
            />
          </defs>
          <clipPath id="SVGIDA_503_">
            <use xlink:href="#SVGIDA_502_" style="overflow:visible;" />
          </clipPath>

          <linearGradient
            id="SVGIDA_504_"
            gradientUnits="userSpaceOnUse"
            x1="-156.9995"
            y1="201"
            x2="-155.9995"
            y2="201"
            gradientTransform="matrix(0 -45.5082 45.5082 0 -8938.3418 -7090.938)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.2845" style="stop-color:#4E4D4D" />
            <stop offset="0.7866" style="stop-color:#1A1A1A" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </linearGradient>
          <rect
            x="200.792"
            y="8.348"
            style="clip-path:url(#SVGIDA_503_);fill:url(#SVGIDA_504_);"
            width="16.048"
            height="45.509"
          />
        </g>
        <g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_505_"
                  x="127.542"
                  y="72.01"
                  width="14.88"
                  height="3.718"
                />
              </defs>
              <clipPath id="SVGIDA_506_">
                <use xlink:href="#SVGIDA_505_" style="overflow:visible;" />
              </clipPath>
              <path
                style="clip-path:url(#SVGIDA_506_);fill:#CCCCCC;"
                d="M142.413,72.01l-14.871,0.118c0.835,2.06,2.882,3.612,4.87,3.601
					l6.836-0.06C141.248,75.657,142.542,74.069,142.413,72.01"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_507_"
                  x="126.342"
                  y="63.363"
                  width="14.989"
                  height="4"
                />
              </defs>
              <clipPath id="SVGIDA_508_">
                <use xlink:href="#SVGIDA_507_" style="overflow:visible;" />
              </clipPath>
              <path
                style="clip-path:url(#SVGIDA_508_);fill:#CCCCCC;"
                d="M126.377,67.363l14.954-0.118c-0.765-2.2-2.895-3.906-4.977-3.882
					l-6.836,0.047C127.436,63.433,126.106,65.163,126.377,67.363"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_509_"
                  x="119.574"
                  y="67.214"
                  width="28.806"
                  height="4.955"
                />
              </defs>
              <clipPath id="SVGIDA_510_">
                <use xlink:href="#SVGIDA_509_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_510_);">
                <defs>
                  <path
                    id="SVGIDA_511_"
                    d="M122.39,72.169l24.294-0.191c1.202-0.01,1.934-1.089,1.626-2.398
							c-0.309-1.311-1.544-2.375-2.747-2.365l-24.293,0.19c-1.202,0.01-1.934,1.09-1.626,2.399
							C119.952,71.114,121.188,72.178,122.39,72.169"
                  />
                </defs>
                <clipPath id="SVGIDA_512_">
                  <use xlink:href="#SVGIDA_511_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_513_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157"
                  y1="201"
                  x2="-156"
                  y2="201"
                  gradientTransform="matrix(0 -4.9549 4.9549 0 -861.9519 -705.7469)"
                >
                  <stop offset="0" style="stop-color:#7F8080" />
                  <stop offset="0.3891" style="stop-color:#FFFFFF" />
                  <stop offset="0.6527" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#7F8080" />
                </linearGradient>
                <rect
                  x="119.336"
                  y="67.204"
                  style="clip-path:url(#SVGIDA_512_);fill:url(#SVGIDA_513_);"
                  width="29.282"
                  height="4.974"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDA_514_"
                  x="119.574"
                  y="67.214"
                  width="28.806"
                  height="4.955"
                />
              </defs>
              <clipPath id="SVGIDA_515_">
                <use xlink:href="#SVGIDA_514_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_515_);">
                <defs>
                  <path
                    id="SVGIDA_516_"
                    d="M122.39,72.169l24.294-0.191c1.202-0.01,1.934-1.089,1.626-2.398
							c-0.309-1.311-1.544-2.375-2.747-2.365l-24.293,0.19c-1.202,0.01-1.934,1.09-1.626,2.399
							C119.952,71.114,121.188,72.178,122.39,72.169"
                  />
                </defs>
                <clipPath id="SVGIDA_517_">
                  <use xlink:href="#SVGIDA_516_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_518_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157"
                  y1="201"
                  x2="-156"
                  y2="201"
                  gradientTransform="matrix(28.8062 0 0 28.8062 4642.1465 -5720.3701)"
                >
                  <stop offset="0" style="stop-color:#C6C6C6" />
                  <stop offset="0.2" style="stop-color:#FFFFFF" />
                  <stop offset="0.8" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#C6C6C6" />
                </linearGradient>
                <rect
                  x="119.336"
                  y="67.204"
                  style="clip-path:url(#SVGIDA_517_);fill:url(#SVGIDA_518_);"
                  width="29.282"
                  height="4.974"
                />
              </g>
            </g>
          </g>
          <path
            d="M221.691,143.364l0.004-0.354l-63.656-0.885c-7.612-0.086-14.513-4.008-18.459-10.49
			c-12.888-21.164-21.535-37.932-33.922-63.327c-2.553-5.233-3.266-11.249-2.006-16.938l0.767-3.468l-0.345-0.076l-0.767,3.468
			c-1.275,5.767-0.554,11.864,2.034,17.169c12.391,25.406,21.043,42.181,33.937,63.357c4.01,6.586,11.022,10.571,18.757,10.659
			L221.691,143.364z"
          />
          <path
            d="M221.695,143.041c3.004-35.96,2.072-54.753-4.333-87.433l-9.558-48.974l-0.347,0.068l9.558,48.973
			c6.398,32.643,7.329,51.415,4.328,87.335L221.695,143.041z"
          />
          <path
            d="M362.29,53.873c0.034,0.023,0.07,0.047,0.105,0.07c2.895,1.729,6.153,2.788,9.519,3.118l3.965,0.389
			c-1.694-1.036-3.365-2.048-5.024-3.036C368.572,54.484,365.925,54.272,362.29,53.873"
          />
          <g style="opacity:0.4;">
            <g>
              <defs>
                <rect
                  id="SVGIDA_519_"
                  x="283.822"
                  y="13.682"
                  width="92.057"
                  height="43.769"
                />
              </defs>
              <clipPath id="SVGIDA_520_">
                <use xlink:href="#SVGIDA_519_" style="overflow:visible;" />
              </clipPath>
              <g style="clip-path:url(#SVGIDA_520_);">
                <defs>
                  <path
                    id="SVGIDA_521_"
                    d="M284.909,14.683c29.59,12.483,52.226,24.107,77.487,39.261c2.894,1.729,6.152,2.789,9.518,3.117
							l3.965,0.39c-35.614-21.755-63.333-35.438-89.593-43.686l-1.153-0.07C283.474,13.6,283.379,14.047,284.909,14.683"
                  />
                </defs>
                <clipPath id="SVGIDA_522_">
                  <use xlink:href="#SVGIDA_521_" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                  id="SVGIDA_523_"
                  gradientUnits="userSpaceOnUse"
                  x1="-157.001"
                  y1="201"
                  x2="-156.001"
                  y2="201"
                  gradientTransform="matrix(-92.0564 0 0 -92.0564 -14076.9854 18538.918)"
                >
                  <stop offset="0" style="stop-color:#AFCACA" />
                  <stop offset="0.2552" style="stop-color:#4A7480" />
                  <stop offset="0.5356" style="stop-color:#AFCACA" />
                  <stop offset="0.7615" style="stop-color:#4A7480" />
                  <stop offset="1" style="stop-color:#AFCACA" />
                </linearGradient>
                <rect
                  x="283.379"
                  y="13.6"
                  style="clip-path:url(#SVGIDA_522_);fill:url(#SVGIDA_523_);"
                  width="92.5"
                  height="43.851"
                />
              </g>
            </g>
          </g>
          <path
            d="M375.879,57.449l-0.487-0.297l-3.461-0.267c-3.338-0.327-6.604-1.397-9.444-3.095
			c-26.224-15.731-48.68-27.109-77.509-39.271c-0.842-0.349-0.963-0.548-0.978-0.579c0.004-0.008,0.151-0.082,0.717-0.082
			c0.116,0,1.888,0.008,1.888,0.008l-1.032-0.325l-0.429-0.022c-1.24-0.065-1.444,0.154-1.49,0.355
			c-0.046,0.203,0.046,0.497,1.188,0.972c28.811,12.153,51.254,23.525,77.463,39.249c2.885,1.724,6.201,2.81,9.592,3.143
			L375.879,57.449z"
          />
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    front: Number,
    frontDoor: Number,
    rearDoor: Number,
    rear: Number,
    frontWheel: Number,
    rearWheel: Number
  },

  data() {
    return {
      right: {
        frontDoor: 0,
        frontBumper: 0,
        backDoor: 0,
        rearBumper: 0,
        frontWheel: 0,
        rearWheel: 0
      }
    };
  },

  computed: {
    frontWheelClass() {
      return this.getSeverityColour(this.right.frontWheel, {});
    },

    rearWheelClass() {
      return this.getSeverityColour(this.right.rearWheel, {});
    },

    frontDoorClass() {
      return this.getSeverityColour(this.right.frontDoor);
    },

    frontBumperClass() {
      return this.getSeverityColour(this.right.frontBumper);
    },

    rearBumperClass() {
      return this.getSeverityColour(this.right.rearBumper);
    },

    backDoorClass() {
      return this.getSeverityColour(this.right.backDoor);
    }
  },

  methods: {
    changeSeverity(section) {
      if (this.right[section] == 3) {
        this.right[section] = 0;
      } else {
        this.right[section] = this.right[section] + 1;
      }

      this.$emit('updated', this.right);
    },

    getSeverityColour(severity, defaultColour = '#D9D9D9', opacity = null) {
      const colour = this.getColour(severity, defaultColour);

      if (opacity) {
        return {
          opacity,
          ...colour
        };
      }

      return colour;
    },

    getColour(severity, defaultColour = '#D9D9D9') {
      switch (severity) {
        case 1:
          return {
            fill: '#FFCA28'
          };

        case 2:
          return {
            fill: '#f0ad4e'
          };

        case 3:
          return {
            fill: '#d9534f'
          };

        default:
          return typeof defaultColour === 'string'
            ? {
                fill: defaultColour
              }
            : defaultColour;
      }
    }
  },

  watch: {
    front(value) {
      this.right.frontBumper = value;
    },
    frontDoor(value) {
      this.right.frontDoor = value;
    },
    rearDoor(value) {
      this.right.backDoor = value;
    },
    rear(value) {
      this.right.rearBumper = value;
    },
    frontWheel(value) {
      this.right.frontWheel = value;
    },
    rearWheel(value) {
      this.right.rearWheel = value;
    }
  }
};
</script>
